
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4uAlQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $33804b048d4018aa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jWKz5 = parcelRequire("jWKz5");
var $7AilP = parcelRequire("7AilP");
var $1jd5c = parcelRequire("1jd5c");
var $a9Nfh = parcelRequire("a9Nfh");

var $90XDC = parcelRequire("90XDC");

var $5CSWr = parcelRequire("5CSWr");

var $2r8fH = parcelRequire("2r8fH");

var $kb4zh = parcelRequire("kb4zh");

var $eGLgs = parcelRequire("eGLgs");

var $2WDJ4 = parcelRequire("2WDJ4");

var $8J6rn = parcelRequire("8J6rn");

var $dF4Di = parcelRequire("dF4Di");

var $7CMCs = parcelRequire("7CMCs");

var $beRD7 = parcelRequire("beRD7");

var $4R6GH = parcelRequire("4R6GH");

var $id7K0 = parcelRequire("id7K0");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $7jF6i = parcelRequire("7jF6i");

var $9NiTW = parcelRequire("9NiTW");

var $dZw8H = parcelRequire("dZw8H");

var $koeKL = parcelRequire("koeKL");

var $itmJb = parcelRequire("itmJb");

var $bmKPg = parcelRequire("bmKPg");
var $2YP9W = parcelRequire("2YP9W");

var $3FJn6 = parcelRequire("3FJn6");

var $bMSgL = parcelRequire("bMSgL");

var $I5c2Z = parcelRequire("I5c2Z");
const $33804b048d4018aa$var$HeartbeatsPage = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const cloudId = (0, $koeKL.useCloudId)();
    const helpPanelLink = (0, $5Zxxp.useHelpPanelLink)();
    const [{ fetchStatus: fetchStatus, opsgenieBaseUrl: opsgenieBaseUrl }] = (0, $7jF6i.useOpsgenieBaseUrl)('eocHeartbeats');
    const opsgenieGlobalHeartbeatsUrl = fetchStatus === 'SUCCESS' ? `${opsgenieBaseUrl}/settings/heartbeat` : '';
    const isPrimaryAdmin = (0, $itmJb.useIsAdmin)();
    const { isTransitioning: isTransitioning } = (0, $8J6rn.useOgTenantInfo)();
    const { data: features } = (0, $3FJn6.useFeatures)();
    const { data: sidebarRights, loading: sidebarRightsLoading } = (0, $2YP9W.useResource)((0, $2r8fH.sidebarRightsResource));
    const { data: team } = (0, $2YP9W.useResource)((0, $2r8fH.teamResource));
    const { data: data } = (0, $2YP9W.useResource)((0, $90XDC.heartbeatsResource));
    const hasAnyHeartbeat = (0, $5uXOq.useMemo)(()=>data?.heartbeats.length !== 0, [
        data
    ]);
    const canDisplayTeamHeartbeats = Boolean(sidebarRights?.showHeartbeats);
    if (team && (0, $4R6GH.fg)('enable-sidebar-rights-check')) {
        if (sidebarRightsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null);
        if (!canDisplayTeamHeartbeats) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.GenericPermissionErrorPageAsync), null);
    }
    if (!team && features?.hasGlobalHeartbeatsAccess === false && (0, $4R6GH.fg)('jira-roles-check-in-view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.GenericPermissionErrorPageAsync), null);
    // TODO: Remove this if after cleaning up global hb flag.
    if (!team && !(0, $4R6GH.fg)('global_heartbeats')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.GenericPermissionErrorPageAsync), null);
    const supportUrls = {
        [(0, $a9Nfh.SupportUrlKeys).API_DOCUMENTATION]: 'https://developer.atlassian.com/cloud/jira/service-desk-ops/rest/v2/api-group-heartbeats/#api-group-heartbeats',
        [(0, $a9Nfh.SupportUrlKeys).OG_GLOBAL_HEARTBEATS]: opsgenieGlobalHeartbeatsUrl,
        [(0, $a9Nfh.SupportUrlKeys).API_PING_URL]: `/jsm/ops/api/${cloudId}/v1/teams/${teamId}/heartbeats/ping`,
        [(0, $a9Nfh.SupportUrlKeys).HEARTBEATS_API]: 'https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account',
        [(0, $a9Nfh.SupportUrlKeys).CREATE_API_TOKEN]: 'https://developer.atlassian.com/cloud/jira/service-desk/basic-auth-for-rest-apis/#basic-auth-for-rest-apis',
        [(0, $a9Nfh.SupportUrlKeys).EMAIL_INSTRUCTIONS]: 'https://support.atlassian.com/jira-service-management-cloud/docs/create-a-heartbeat-with-built-in-email'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        teamName: "alexstrasza",
        packageName: "jiraEocHeartbeats",
        id: "jiraHeartbeatsPage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $I5c2Z.default).pageTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5CSWr.Container), {
        clickHandler: helpPanelLink,
        links: (0, $bMSgL.heartbeatsLinks)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2WDJ4.GlobalContextContainer), {
        teamName: "alexstrasza",
        packageName: "jiraEocHeartbeats"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF4Di.ConsolidatedStateWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7AilP.default), {
        isTransitioning: isTransitioning,
        isPrimaryAdmin: isPrimaryAdmin,
        supportUrls: supportUrls,
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jWKz5.Breadcrumbs), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null), hasAnyHeartbeat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: "jira-ops_team_heartbeats",
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1jd5c.HeartbeatsTour), {
        learnMoreUrl: "https://support.atlassian.com/jira-service-management-cloud/docs/what-are-heartbeats/"
    })))))));
};
var $33804b048d4018aa$export$2e2bcd8739ae039 = $33804b048d4018aa$var$HeartbeatsPage;

});
parcelRegister("jWKz5", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $20e4d4c0039708f2$export$2dc68d50d56fbbd);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");
var $bmKPg = parcelRequire("bmKPg");

var $ujWmd = parcelRequire("ujWmd");

var $fuUnn = parcelRequire("fuUnn");
var $jbeEq = parcelRequire("jbeEq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $fXc9u = parcelRequire("fXc9u");

var $j8iOY = parcelRequire("j8iOY");
const $20e4d4c0039708f2$var$AvatarContainerStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.050'
});
const $20e4d4c0039708f2$export$2dc68d50d56fbbd = ()=>{
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const requestedResponders = (0, $5uXOq.useMemo)(()=>{
        if (teamId) return [
            {
                id: teamId,
                type: 'team'
            }
        ];
        return [];
    }, [
        teamId
    ]);
    const [team] = (0, $fXc9u.useResponderNames)(requestedResponders);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return teamId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbeEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        text: formatMessage((0, $j8iOY.default).teams),
        href: "/jira/people/search",
        component: (0, $hDzhb.default)
    }), team && 'name' in team && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        text: team.name,
        href: `/jira/ops/teams/${teamId}/on-call`,
        component: (0, $hDzhb.default),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $20e4d4c0039708f2$var$AvatarContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            appearance: "square",
            borderColor: "transparent",
            size: "xsmall",
            src: team.avatarUrl
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        text: formatMessage((0, $j8iOY.default).heartbeatsTitle),
        key: "Parent page"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};

});
parcelRegister("fXc9u", function(module, exports) {

$parcel$export(module.exports, "useResponderNames", () => $e8e4422ea9190968$export$26c3076cb2234d56);

var $5uXOq = parcelRequire("5uXOq");

var $hEySk = parcelRequire("hEySk");
const $e8e4422ea9190968$export$26c3076cb2234d56 = (requestedResponders)=>{
    const [{ responders: responders }, { batchResponders: batchResponders }] = (0, $hEySk.useResponderNamesStore)();
    const memoizedResponders = (0, $5uXOq.useMemo)(()=>{
        return requestedResponders.map((responder)=>{
            return responders[responder.id] ?? {
                acknowledged: false,
                isError: false,
                isLoading: true,
                name: '',
                ...responder
            };
        });
    }, [
        responders,
        requestedResponders
    ]);
    (0, $5uXOq.useEffect)(()=>{
        batchResponders(requestedResponders);
    }, [
        requestedResponders,
        batchResponders
    ]);
    return memoizedResponders;
};

});
parcelRegister("hEySk", function(module, exports) {

$parcel$export(module.exports, "ResponderNamesContainer", () => $6d57183bc999b4da$export$ae46960d51ae2b7);
$parcel$export(module.exports, "useResponderNamesStore", () => $6d57183bc999b4da$export$d2c212d52c0e4d25);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $eIMZo = parcelRequire("eIMZo");

var $jF6Os = parcelRequire("jF6Os");
const $6d57183bc999b4da$export$cd391a137954b857 = (0, $iXqE5.createStore)({
    initialState: (0, $jF6Os.initialState),
    actions: $eIMZo.actions,
    name: 'ResponderNamesStore'
});
const $6d57183bc999b4da$export$ae46960d51ae2b7 = (0, $gg7kZ.createContainer)($6d57183bc999b4da$export$cd391a137954b857);
const $6d57183bc999b4da$export$d2c212d52c0e4d25 = (0, $3sQ5x.createHook)($6d57183bc999b4da$export$cd391a137954b857);

});
parcelRegister("eIMZo", function(module, exports) {

$parcel$export(module.exports, "actions", () => $00dbd40d3cd5db38$export$e324594224ef24da);

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $8eCQi = parcelRequire("8eCQi");

var $c3dSt = parcelRequire("c3dSt");

var $6DiJG = parcelRequire("6DiJG");

var $c8qzg = parcelRequire("c8qzg");
const $00dbd40d3cd5db38$var$fetchResponders = (missingResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { flagApi: flagApi, intlApi: intlApi, defaultCatch: defaultCatch })=>{
        const { responders: responders } = getState();
        if (!Object.keys(missingResponders).length) return Promise.resolve();
        const errorItems = (0, $c3dSt.mapErrorForResponder)(missingResponders);
        setState({
            responders: {
                ...responders,
                ...missingResponders
            }
        });
        //TODO: How to handle if BE returns [], what will be the behaviour?
        return (0, $6DiJG.getResponderNames)(Object.values(missingResponders).map(({ id: id, type: type })=>({
                id: id,
                type: type
            }))).then((response)=>{
            const responseMap = response.values.map((r)=>({
                    isError: false,
                    isLoading: false,
                    acknowledged: true,
                    ...r
                })).reduce((acc, r)=>{
                acc[r.id] = r;
                return acc;
            }, {});
            const responderItemMap = Object.keys(missingResponders).reduce((acc, key)=>{
                const itemByEmail = Object.values(responseMap).find((res)=>res.email === key);
                if (itemByEmail) {
                    acc[key] = {
                        ...errorItems[key],
                        ...itemByEmail
                    };
                    return acc;
                }
                const itemByAtlassianIdentifier = Object.values(responseMap).find((res)=>res.atlassianIdentifier === key);
                if (itemByAtlassianIdentifier) {
                    acc[key] = {
                        ...errorItems[key],
                        ...itemByAtlassianIdentifier
                    };
                    return acc;
                }
                acc[key] = {
                    ...errorItems[key],
                    ...responseMap[key]
                };
                return acc;
            }, {});
            setState({
                responders: {
                    ...getState().responders,
                    ...responderItemMap
                }
            });
        }).catch(defaultCatch({
            id: 'fetchResponders',
            httpErrorHandler: ()=>{
                //Retry will be shown on the toast message
                const dismiss = flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    title: intlApi.formatMessage((0, $c8qzg.messages).fetchError),
                    isAutoDismiss: true,
                    actions: [
                        {
                            content: intlApi.formatMessage((0, $c8qzg.messages).retry),
                            onClick: ()=>{
                                dispatch($00dbd40d3cd5db38$var$fetchResponders(missingResponders));
                                dismiss();
                            }
                        }
                    ]
                });
                const responders = Object.assign({}, getState().responders, errorItems);
                setState({
                    responders: responders
                });
            }
        }));
    };
/**
 * It takes missingResponders and updates the store with additional parameters
 * when it is called on the useResponderNames() hook.
 * It sets isLoading to true for every responder item.
 * This function is implemented to batch requests coming from different components.
 */ const $00dbd40d3cd5db38$var$batchResponders = (requestedResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { displayName: displayName })=>{
        (0, $hmVmJ.assert)(displayName === 'ResponderNamesWrapper', new (0, $dH6Pi.AssertionError)('useResponderNames', 'Unable to find ResponderNamesWrapper'));
        const missingResponders = requestedResponders.filter((responder)=>!getState().responders[responder.id]);
        if (!missingResponders.length) return;
        const requestedRespondersMap = requestedResponders.reduce((acc, r)=>{
            acc[r.id] = {
                id: r.id,
                type: r.type,
                acknowledged: false,
                isError: false,
                isLoading: true
            };
            return acc;
        }, {});
        const existingResponders = getState().responders;
        const allResponderIds = [
            ...Object.keys(existingResponders),
            ...Object.keys(requestedRespondersMap)
        ];
        const allResponders = allResponderIds.reduce((acc, key)=>{
            acc[key] = {
                ...requestedRespondersMap[key],
                ...existingResponders[key]
            };
            return acc;
        }, {});
        setState({
            responders: allResponders
        });
        const timeoutState = getState().timeout;
        if (timeoutState !== undefined) clearTimeout(timeoutState);
        //It debounces the requested responders(batching)
        const timeout = setTimeout(()=>{
            const missingResponders = Object.fromEntries(Object.entries(getState().responders).filter(([key, value])=>(0, $c3dSt.isNotLoaded)(value)).map(([key, value])=>[
                    key,
                    {
                        ...value,
                        acknowledged: true
                    }
                ]));
            if (Object.keys(missingResponders).length) dispatch($00dbd40d3cd5db38$var$fetchResponders(missingResponders));
        }, 10);
        setState({
            timeout: timeout
        });
    };
const $00dbd40d3cd5db38$export$e324594224ef24da = {
    fetchResponders: $00dbd40d3cd5db38$var$fetchResponders,
    batchResponders: $00dbd40d3cd5db38$var$batchResponders
};

});
parcelRegister("8eCQi", function(module, exports) {

$parcel$export(module.exports, "errorToastProps", () => $06a51a880a3faae2$export$c37f1e5051cd0bbc);
$parcel$export(module.exports, "warningToastProps", () => $06a51a880a3faae2$export$fe81a150e4e6ac02);
$parcel$export(module.exports, "infoToastProps", () => $06a51a880a3faae2$export$e70d6574d157a39b);
$parcel$export(module.exports, "successToastProps", () => $06a51a880a3faae2$export$b56198a940066d8f);

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");


var $2bUsm = parcelRequire("2bUsm");
const $06a51a880a3faae2$var$ErrorWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).error)
    }));
const $06a51a880a3faae2$var$WarningWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).warning)
    }));
const $06a51a880a3faae2$var$InfoWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).info)
    }));
const $06a51a880a3faae2$var$SuccessWithIntl = (0, $8RXs9.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $2bUsm.default).success)
    }));
const $06a51a880a3faae2$export$c37f1e5051cd0bbc = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$ErrorWithIntl, null),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$fe81a150e4e6ac02 = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$WarningWithIntl, null),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$e70d6574d157a39b = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$InfoWithIntl, null),
        appearance: 'normal'
    });
const $06a51a880a3faae2$export$b56198a940066d8f = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });

});
parcelRegister("1jWct", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e457cb24ac9ea7300ef511f2118ffa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f64b62884a9bedb$var$InformationIcon = (props)=>/*#__PURE__*/ $0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
    }, props));
$0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;

});

parcelRegister("c2i4s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4b1d8f8ae82590ab9e3b231233297b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));

var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c33b074f80a91d5$var$SuccessIcon = (props)=>/*#__PURE__*/ $8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
    }, props));
$8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;

});

var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("2bUsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7145ce6f0cfaef60$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7145ce6f0cfaef60$var$messages = (0, $7VHMR.defineMessages)({
    error: {
        id: 'eoc.common.toast.error',
        defaultMessage: 'Error',
        description: 'The title for an error as a single word.'
    },
    warning: {
        id: 'eoc.common.toast.warning',
        defaultMessage: 'Warning',
        description: 'The title for a warning as a single word.'
    },
    success: {
        id: 'eoc.common.toast.success',
        defaultMessage: 'Success',
        description: 'The title for success as a single word.'
    },
    info: {
        id: 'eoc.common.toast.info',
        defaultMessage: 'Information',
        description: 'The title for an information as a single word.'
    }
});
var $7145ce6f0cfaef60$export$2e2bcd8739ae039 = $7145ce6f0cfaef60$var$messages;

});


parcelRegister("c3dSt", function(module, exports) {

$parcel$export(module.exports, "mapErrorForResponder", () => $f99f931354012934$export$245cebe8a9527ff0);
$parcel$export(module.exports, "isNotLoaded", () => $f99f931354012934$export$ea78f980ad0c92fe);
const $f99f931354012934$export$245cebe8a9527ff0 = (requestedResponders)=>Object.entries(requestedResponders).reduce((acc, [key, value])=>{
        acc[key] = {
            id: value.id,
            type: value.type,
            isError: true,
            acknowledged: true,
            isLoading: false
        };
        return acc;
    }, {});
const $f99f931354012934$export$ea78f980ad0c92fe = (responder)=>!Boolean(responder?.isError) && !Boolean(responder?.acknowledged);

});

parcelRegister("6DiJG", function(module, exports) {

$parcel$export(module.exports, "getResponderNames", () => $721598a63b2bde28$export$7345ec3bad54e226);

var $j74qU = parcelRequire("j74qU");
const $721598a63b2bde28$export$7345ec3bad54e226 = (requestedResponders)=>{
    const responders = requestedResponders.reduce((acc, curr)=>{
        // any is intentional here we don't want to add
        // unknown to the ResponderType because we don't want it to be public
        if (curr.type === 'unknown') return [
            ...acc,
            {
                id: curr.id,
                type: 'schedule'
            },
            {
                id: curr.id,
                type: 'user'
            },
            {
                id: curr.id,
                type: 'team'
            },
            {
                id: curr.id,
                type: 'escalation'
            }
        ];
        return [
            ...acc,
            curr
        ];
    }, []);
    return (0, $j74qU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: responders
        }
    });
};

});

parcelRegister("c8qzg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $43634ee9e12c5e07$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $43634ee9e12c5e07$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    fetchError: {
        id: `eoc.responder-names-fetch-error`,
        defaultMessage: "We couldn't fetch the responder names.",
        description: 'The text will be displayed when there is error'
    },
    retry: {
        id: `eoc.responder-names-retry`,
        defaultMessage: 'Retry',
        description: 'The title for retry as a single word.'
    }
});

});


parcelRegister("jF6Os", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $f657b42bad68e54a$export$d4c72bab9d6cc13a);
const $f657b42bad68e54a$export$d4c72bab9d6cc13a = {
    responders: {}
};

});



parcelRegister("j8iOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0429223926f936a3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $0429223926f936a3$var$messages = (0, $7VHMR.defineMessages)({
    heartbeatsTitle: {
        id: 'eoc.heartbeats.breadcrumbs.title.no-translate',
        defaultMessage: 'Heartbeats',
        description: 'The title of heartbeats.'
    },
    teams: {
        id: 'eoc.heartbeats.breadcrumbs.teams.no-translate',
        defaultMessage: 'Teams',
        description: 'The text will be displayed on the breadcrumb for Team list navigation'
    }
});
var $0429223926f936a3$export$2e2bcd8739ae039 = $0429223926f936a3$var$messages;

});


parcelRegister("7AilP", function(module, exports) {

$parcel$export(module.exports, "default", () => $508dc1ee7e5a979e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");
var $994MI = parcelRequire("994MI");

var $lkmWu = parcelRequire("lkmWu");

var $bU3PY = parcelRequire("bU3PY");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $fNobW = parcelRequire("fNobW");

var $h8yj2 = parcelRequire("h8yj2");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $gIuON = parcelRequire("gIuON");

var $1JB21 = parcelRequire("1JB21");

var $eoC0M = parcelRequire("eoC0M");

var $hem2I = parcelRequire("hem2I");

var $a9Nfh = parcelRequire("a9Nfh");

var $eBqFt = parcelRequire("eBqFt");

var $90XDC = parcelRequire("90XDC");

var $8xiJF = parcelRequire("8xiJF");

var $fFflN = parcelRequire("fFflN");

var $8od9I = parcelRequire("8od9I");

var $aNseN = parcelRequire("aNseN");

var $kzba1 = parcelRequire("kzba1");

var $RYkVo = parcelRequire("RYkVo");

var $kn6nR = parcelRequire("kn6nR");

var $c2ZIb = parcelRequire("c2ZIb");

var $1li9a = parcelRequire("1li9a");

var $hDWrk = parcelRequire("hDWrk");

var $l6bFa = parcelRequire("l6bFa");
const $508dc1ee7e5a979e$var$ContainerStyles = (0, $8CUq3.xcss)({
    minWidth: '1024px',
    paddingRight: 'space.300',
    paddingLeft: 'space.300'
});
const $508dc1ee7e5a979e$var$horizontalWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.300'
});
const $508dc1ee7e5a979e$var$Heartbeats = ({ breadcrumbs: breadcrumbs })=>{
    const { data: data, loading: loading, error: error } = (0, $hem2I.default)((0, $90XDC.heartbeatsResource));
    const { loading: rightsLoading, error: rightsError } = (0, $hem2I.default)((0, $90XDC.heartbeatsUserRightsResource));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { supportUrls: supportUrls, isPrimaryAdmin: isPrimaryAdmin } = (0, $eBqFt.useHeartbeatsContext)();
    const opsgenieGlobalHeartbeatsUrl = supportUrls[(0, $a9Nfh.SupportUrlKeys).OG_GLOBAL_HEARTBEATS];
    const isHorizontalNav = (0, $1JB21.useIsNewNavigation)();
    if (loading || rightsLoading || (0, $gIuON.isServer)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "eoc-heartbeats-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $508dc1ee7e5a979e$var$ContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNseN.Header), {
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6bFa.ActionButtonsSkeleton), null),
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6bFa.BottomBarSkeleton), null),
        breadcrumbs: breadcrumbs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6bFa.ContentSkeleton), null)));
    if (error || rightsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $508dc1ee7e5a979e$var$ContainerStyles
    }, isHorizontalNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $508dc1ee7e5a979e$var$horizontalWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kn6nR.Description), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNseN.Header), {
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kn6nR.Description), null),
        breadcrumbs: breadcrumbs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fFflN.ErrorState), null));
    (0, $hmVmJ.assert)(!!data, new (0, $dH6Pi.AssertionError)('Heartbeats', 'component rendered before data is fetched!'));
    const { heartbeats: heartbeats, limit: limit, limitExceeded: limitExceeded } = data;
    if (!heartbeats.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $508dc1ee7e5a979e$var$ContainerStyles
    }, !isHorizontalNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNseN.Header), {
        breadcrumbs: breadcrumbs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8xiJF.EmptyState), null));
    const shouldDisplayLimitExceedBanner = limitExceeded && limit;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldDisplayLimitExceedBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkmWu.default), {
        appearance: "warning",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            LEGACY_secondaryColor: "inherit"
        })
    }, formatMessage((0, $hDWrk.default).heartbeatLimitBanner, {
        limit: limit
    }), isPrimaryAdmin && opsgenieGlobalHeartbeatsUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: opsgenieGlobalHeartbeatsUrl,
        target: "_blank"
    }, formatMessage((0, $hDWrk.default).viewInOgText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $508dc1ee7e5a979e$var$ContainerStyles
    }, isHorizontalNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $508dc1ee7e5a979e$var$horizontalWrapperStyles,
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2ZIb.Filter), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kzba1.ActionButtons), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kn6nR.Description), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNseN.Header), {
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kzba1.ActionButtons), null),
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $RYkVo.BottomBar), null),
        breadcrumbs: breadcrumbs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1li9a.List), null)));
};
const $508dc1ee7e5a979e$var$HeartbeatsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ isTransitioning: isTransitioning, isPrimaryAdmin: isPrimaryAdmin, supportUrls: supportUrls, breadcrumbs: breadcrumbs })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const time = Date.now();
        return ()=>{
            const current = Date.now();
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'time consumed', {
                duration: current - time
            });
        };
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eoC0M.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eBqFt.HeartbeatsProvider), {
        isTransitioning: isTransitioning,
        isPrimaryAdmin: isPrimaryAdmin,
        supportUrls: supportUrls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($508dc1ee7e5a979e$var$Heartbeats, {
        breadcrumbs: breadcrumbs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8od9I.Focus), null)));
});
var $508dc1ee7e5a979e$export$2e2bcd8739ae039 = (0, $994MI.default)({
    source: 'HeartbeatsPage',
    tags: [
        'heartbeats'
    ]
})($508dc1ee7e5a979e$var$HeartbeatsWrapper);

});
parcelRegister("h8yj2", function(module, exports) {

$parcel$export(module.exports, "fireAnalytics", () => $b264de6d6a035739$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $b264de6d6a035739$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $b264de6d6a035739$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $b264de6d6a035739$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $b264de6d6a035739$export$6f46fb37ad7d962b);

var $hYfgW = parcelRequire("hYfgW");


var $4zfLY = parcelRequire("4zfLY");
const $b264de6d6a035739$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $6e65040b988c460f$export$2ceccf177fae277c));
};
const $b264de6d6a035739$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $b264de6d6a035739$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $b264de6d6a035739$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$947dac6c72b26f81), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$12346a674644c156), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b264de6d6a035739$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $4zfLY.getImperativeAnalyticsDataFromArguments)(rest);
    $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$f1d537d508d2945a), {
        attributes: attributes
    });
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

parcelRegister("4zfLY", function(module, exports) {

$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $ccaec2c661eabde7$export$e6baab532ef8c6bf);
const $ccaec2c661eabde7$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $ccaec2c661eabde7$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $ccaec2c661eabde7$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $ccaec2c661eabde7$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $ccaec2c661eabde7$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $ccaec2c661eabde7$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});


parcelRegister("1JB21", function(module, exports) {

$parcel$export(module.exports, "useIsNewNavigation", () => $8a123ed33d4d2eb9$export$b78431fea1079e74);

var $74BDp = parcelRequire("74BDp");
const $8a123ed33d4d2eb9$export$b78431fea1079e74 = ()=>{
    const { getHorizontalNav: getHorizontalNav } = (0, $74BDp.useGlobalContextActions)();
    return getHorizontalNav?.() || false;
};

});
parcelRegister("74BDp", function(module, exports) {

$parcel$export(module.exports, "GlobalContextContainer", () => $aca7a4d9aea0d818$export$8a0b5f75aa4dc446);
$parcel$export(module.exports, "useExternalFlagService", () => $aca7a4d9aea0d818$export$6b9ad8a324c94098);
$parcel$export(module.exports, "useSendMessage", () => $aca7a4d9aea0d818$export$fe8707b58c509543);
$parcel$export(module.exports, "useGlobalContextActions", () => $aca7a4d9aea0d818$export$8a9eff51cb8da29e);

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $bMb9B = parcelRequire("bMb9B");
const $aca7a4d9aea0d818$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'global-context',
    initialState: {
        reporter: undefined
    },
    actions: $bMb9B
});
const $aca7a4d9aea0d818$export$8a0b5f75aa4dc446 = ({ flagService: flagService, reporter: reporter, children: children, messages: messages, config: config })=>{
    const { locale: locale } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aca7a4d9aea0d818$var$OriginalGlobalContextContainer, {
        config: config,
        reporter: reporter,
        isGlobal: true,
        flagService: flagService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
        locale: locale,
        messages: messages && messages[locale]
    }, children));
};
const $aca7a4d9aea0d818$var$OriginalGlobalContextContainer = (0, $gg7kZ.createContainer)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    onInit: ()=>async ({ getState: getState, setState: setState }, { flagService: flagService, config: config })=>{
            !getState().flagService && setState({
                flagService: flagService
            });
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        },
    onUpdate: ()=>async ({ getState: getState, setState: setState }, { config: config })=>{
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        }
});
const $aca7a4d9aea0d818$export$2041a7a7b51b1fce = (0, $51nlc.createSubscriber)($aca7a4d9aea0d818$export$390f32400eaf98c9);
const $aca7a4d9aea0d818$export$6b9ad8a324c94098 = (0, $3sQ5x.createHook)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    selector: (state)=>state.flagService
});
const $aca7a4d9aea0d818$export$fe8707b58c509543 = (handlerClass)=>{
    const [{ handler: handler, context: context }] = $aca7a4d9aea0d818$var$useSendMessageInternal(handlerClass);
    return (params)=>{
        return handler(params, context);
    };
};
const $aca7a4d9aea0d818$var$useSendMessageInternal = (0, $3sQ5x.createHook)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
    selector: (state, arg)=>{
        if (state.config && state.config.messageHandler && state.config.messageHandler instanceof arg) return {
            handler: state.config.messageHandler.handler.bind(state.config.messageHandler),
            context: state.config.context
        };
        throw new Error(`The messageHandler provided from nearest GlobalContextContainer doesn't implement the one from the inner tree. Please make sure you have a compatible GlobalContextContainer`);
    }
});
const $aca7a4d9aea0d818$export$8a9eff51cb8da29e = (0, $3sQ5x.createActionsHook)($aca7a4d9aea0d818$export$390f32400eaf98c9);

});
parcelRegister("bMb9B", function(module, exports) {

$parcel$export(module.exports, "reporterAction", () => $3a0e18e647f4c498$export$f3910000817a36c2);
$parcel$export(module.exports, "getHorizontalNav", () => $3a0e18e647f4c498$export$7c79a3553de2e8e7);
const $3a0e18e647f4c498$export$f3910000817a36c2 = ({ id: id, error: error, attributes: attributes })=>({}, { reporter: reporter })=>{
        if (reporter) {
            reporter({
                id: id,
                error: error,
                attributes: attributes
            });
            return;
        }
    };
const $3a0e18e647f4c498$export$7c79a3553de2e8e7 = ()=>({}, { config: config })=>{
        return config?.isNewNavigation || false;
    };

});



parcelRegister("eoC0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $7feb9746acf3ea52$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2VYEV = parcelRequire("2VYEV");

var $2tKfK = parcelRequire("2tKfK");

var $hEySk = parcelRequire("hEySk");
/**
 * Wrapper should live on the root level since it uses glocal scoped container.
 */ const $7feb9746acf3ea52$var$ResponderNamesWrapper = ({ scope: scope, isGlobal: isGlobal = true, children: children })=>{
    const flagApi = (0, $2tKfK.default)();
    const intl = (0, $koVbs.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    if (scope) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEySk.ResponderNamesContainer), {
        flagApi: flagApi,
        intlApi: intl,
        scope: scope,
        defaultCatch: defaultCatch,
        displayName: "ResponderNamesWrapper"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hEySk.ResponderNamesContainer), {
        flagApi: flagApi,
        intlApi: intl,
        isGlobal: isGlobal,
        defaultCatch: defaultCatch,
        displayName: "ResponderNamesWrapper"
    }, children);
};
var $7feb9746acf3ea52$export$2e2bcd8739ae039 = $7feb9746acf3ea52$var$ResponderNamesWrapper;

});
parcelRegister("2VYEV", function(module, exports) {

$parcel$export(module.exports, "useDefaultCatch", () => $06138e726543d489$export$3ab31fcc1d7c2589);

var $5uXOq = parcelRequire("5uXOq");

var $kmpOn = parcelRequire("kmpOn");

var $8tpNZ = parcelRequire("8tpNZ");
var $aI12f = parcelRequire("aI12f");
var $cQDa6 = parcelRequire("cQDa6");
function $06138e726543d489$export$3ab31fcc1d7c2589() {
    const reportError = (0, $cQDa6.useReportError)();
    const [error, setError] = (0, $5uXOq.useState)();
    if (error) throw error;
    return (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kmpOn)))(({ id: id, httpErrorHandler: httpErrorHandler, reporter: customReporter, attributes: attributes }, error)=>{
            if (!(0, $aI12f.isNetworkError)(error)) return setError(new (0, $8tpNZ.EocError)(id, error));
            if (customReporter !== null) {
                const reporter = customReporter ?? reportError;
                reporter(id, error, attributes);
            }
            try {
                return httpErrorHandler?.(error);
            } catch (handlerError) {
                if (!(0, $aI12f.isNetworkError)(handlerError)) setError(new (0, $8tpNZ.EocError)(id, handlerError));
                throw handlerError;
            }
        }), [
        reportError
    ]);
}

});
parcelRegister("kmpOn", function(module, exports) {

var $6CA7f = parcelRequire("6CA7f");

var $g7JQw = parcelRequire("g7JQw");
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * Please note that default parameters don't count towards a [function arity](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length)
 * and therefore `curry` won't work well with those:
 *
 * ```
 * const h = R.curry((a, b, c = 2) => a + b + c);
 *
 * h(40);
 * //=> function (waits for `b`)
 *
 * h(39)(1);
 * //=> 42
 *
 * h(1)(2, 3);
 * //=> 6
 *
 * h(1)(2)(7);
 * //=> Error! (`3` is not a function!)
 * ```
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $ed29e25cf476d3b2$var$curry = /*#__PURE__*/ $6CA7f(function curry(fn) {
    return $g7JQw(fn.length, fn);
});
module.exports = $ed29e25cf476d3b2$var$curry;

});
parcelRegister("6CA7f", function(module, exports) {

var $dtL0L = parcelRequire("dtL0L");
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $4d224e922cc0a345$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $dtL0L(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
module.exports = $4d224e922cc0a345$var$_curry1;

});
parcelRegister("dtL0L", function(module, exports) {
function $9d027343e6afec73$var$_isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = $9d027343e6afec73$var$_isPlaceholder;

});


parcelRegister("g7JQw", function(module, exports) {

var $dxgtl = parcelRequire("dxgtl");

var $6CA7f = parcelRequire("6CA7f");

var $18myW = parcelRequire("18myW");

var $90GZI = parcelRequire("90GZI");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $bbd0dce5f5e12876$var$curryN = /*#__PURE__*/ $18myW(function curryN(length, fn) {
    if (length === 1) return $6CA7f(fn);
    return $dxgtl(length, $90GZI(length, [], fn));
});
module.exports = $bbd0dce5f5e12876$var$curryN;

});
parcelRegister("dxgtl", function(module, exports) {
function $9dab227b64b88e13$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
module.exports = $9dab227b64b88e13$var$_arity;

});

parcelRegister("18myW", function(module, exports) {

var $6CA7f = parcelRequire("6CA7f");

var $dtL0L = parcelRequire("dtL0L");
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $0d380a4094fa43af$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $dtL0L(a) ? f2 : $6CA7f(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $dtL0L(a) && $dtL0L(b) ? f2 : $dtL0L(a) ? $6CA7f(function(_a) {
                    return fn(_a, b);
                }) : $dtL0L(b) ? $6CA7f(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
module.exports = $0d380a4094fa43af$var$_curry2;

});

parcelRegister("90GZI", function(module, exports) {

var $dxgtl = parcelRequire("dxgtl");

var $dtL0L = parcelRequire("dtL0L");
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $01b160e2e45af68a$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$dtL0L(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$dtL0L(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : $dxgtl(left, $01b160e2e45af68a$var$_curryN(length, combined, fn));
    };
}
module.exports = $01b160e2e45af68a$var$_curryN;

});



parcelRegister("8tpNZ", function(module, exports) {

$parcel$export(module.exports, "EocError", () => $d534eb2e187b068b$export$e76fc0e0bc06f4df);
function $d534eb2e187b068b$var$hasMessage(cause) {
    return typeof cause === 'object' && cause !== null && 'message' in cause;
}
class $d534eb2e187b068b$export$e76fc0e0bc06f4df extends Error {
    constructor(id, cause){
        super(`[${id}] ${$d534eb2e187b068b$var$hasMessage(cause) ? cause.message : cause}`), this.id = id, this.cause = cause;
        this.name = 'EocError';
    }
}

});

parcelRegister("cQDa6", function(module, exports) {

$parcel$export(module.exports, "useReportError", () => $c58a665a3c6a26b3$export$5a5695b638d078e7);

var $5uXOq = parcelRequire("5uXOq");

var $aI12f = parcelRequire("aI12f");

var $74BDp = parcelRequire("74BDp");
function $c58a665a3c6a26b3$export$cad78388f408899e(error) {
    if (!(0, $aI12f.isNetworkError)(error)) return true;
    return !(0, $aI12f.isHTTPError)(error);
}
const $c58a665a3c6a26b3$export$5a5695b638d078e7 = ()=>{
    const { reporterAction: reporterAction } = (0, $74BDp.useGlobalContextActions)();
    return (0, $5uXOq.useMemo)(()=>(id, error, attributes)=>{
            if (!$c58a665a3c6a26b3$export$cad78388f408899e(error)) return;
            reporterAction({
                id: id,
                error: error,
                attributes: attributes
            });
        }, [
        reporterAction
    ]);
};

});


parcelRegister("2tKfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c357df09fe3f96fe$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $fWXJB = parcelRequire("fWXJB");
var $epfFv = parcelRequire("epfFv");
var $bKCvK = parcelRequire("bKCvK");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $74BDp = parcelRequire("74BDp");
const $c357df09fe3f96fe$var$useFlags = ()=>{
    const [flagService] = (0, $74BDp.useExternalFlagService)();
    const serviceRef = (0, $5uXOq.useRef)(flagService);
    (0, $hmVmJ.assert)(!serviceRef.current || !!flagService, new (0, $dH6Pi.AssertionError)('GlobalContext', 'flagService was destroyed.'));
    return serviceRef.current !== undefined ? {
        showFlag: ({ isAutoDismiss: isAutoDismiss, ...props })=>{
            const Component = ({ id: id, onDismissed: onDismissed })=>{
                if (isAutoDismiss) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fWXJB.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epfFv.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
            };
            const id = (0, $7Jxgt.v4)();
            Component.id = id;
            serviceRef.current.showFlag(Component);
            return ()=>{
                serviceRef.current.dismissFlag({
                    id: id,
                    command: 'DISMISS'
                });
            };
        }
    } : //eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bKCvK.useFlags)();
};
var $c357df09fe3f96fe$export$2e2bcd8739ae039 = $c357df09fe3f96fe$var$useFlags;

});


parcelRegister("hem2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf0b5f2d38c9a8bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2YP9W = parcelRequire("2YP9W");

var $gIuON = parcelRequire("gIuON");

var $8tpNZ = parcelRequire("8tpNZ");
var $aI12f = parcelRequire("aI12f");
var $cQDa6 = parcelRequire("cQDa6");
const $bf0b5f2d38c9a8bd$var$useEocResource = (routeResource, options)=>{
    const reporter = (0, $cQDa6.useReportError)();
    const resource = (0, $2YP9W.useResource)(routeResource, options);
    const { error: error } = resource;
    (0, $5uXOq.useEffect)(()=>{
        if (!error) return;
        const id = routeResource.type;
        if ((0, $gIuON.isServer)() || (0, $aI12f.isNetworkError)(error)) reporter(id, error);
        else throw new (0, $8tpNZ.EocError)(id, error);
    }, [
        error,
        reporter,
        routeResource.type
    ]);
    // User always responsible for rendering an appropriate error view on jsx.
    // Thus, we return RouteResource at the end.
    // Also, it is default behaviour if there is no error.
    return resource;
};
var $bf0b5f2d38c9a8bd$export$2e2bcd8739ae039 = $bf0b5f2d38c9a8bd$var$useEocResource;

});

parcelRegister("a9Nfh", function(module, exports) {

$parcel$export(module.exports, "OptionalSupportUrlKeys", () => $115dab097871c07e$export$62a01ab601e0cc35);
$parcel$export(module.exports, "SupportUrlKeys", () => $115dab097871c07e$export$fd084a4832546967);
var $115dab097871c07e$export$62a01ab601e0cc35 = /*#__PURE__*/ function(OptionalSupportUrlKeys) {
    OptionalSupportUrlKeys["WHAT_ARE_HEARTBEATS"] = "WhatAreHeartbeats";
    return OptionalSupportUrlKeys;
}({});
var $115dab097871c07e$export$fd084a4832546967 = /*#__PURE__*/ function(SupportUrlKeys) {
    SupportUrlKeys["API_DOCUMENTATION"] = "APIDocumentation";
    SupportUrlKeys["OG_GLOBAL_HEARTBEATS"] = "OGGlobalHeartbeats";
    SupportUrlKeys["API_PING_URL"] = "APIPingURL";
    SupportUrlKeys["HEARTBEATS_API"] = "HeartbeatsAPI";
    SupportUrlKeys["CREATE_API_TOKEN"] = "CreateAPIToken";
    SupportUrlKeys["EMAIL_INSTRUCTIONS"] = "EmailInstructions";
    return SupportUrlKeys;
}({});

});

parcelRegister("eBqFt", function(module, exports) {

$parcel$export(module.exports, "useHeartbeatsContext", () => $f6ad09ed9eb62767$export$e5b9693a695bc1d6);
$parcel$export(module.exports, "HeartbeatsProvider", () => $f6ad09ed9eb62767$export$fde947f04a8a5906);

var $5uXOq = parcelRequire("5uXOq");

var $a9Nfh = parcelRequire("a9Nfh");

var $b3dJz = parcelRequire("b3dJz");

var $33XOa = parcelRequire("33XOa");
const $f6ad09ed9eb62767$var$HeartbeatsContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    focusState: {
        isOpen: false,
        open: ()=>{},
        close: ()=>{}
    },
    filters: {
        searchText: '',
        statuses: [],
        handleSearchTextChange: ()=>{},
        handleStatusesChange: ()=>{}
    },
    isTransitioning: false,
    opsgenieGlobalHeartbeatsUrl: undefined,
    isPrimaryAdmin: false,
    supportUrls: {
        [(0, $a9Nfh.SupportUrlKeys).API_DOCUMENTATION]: '',
        [(0, $a9Nfh.SupportUrlKeys).OG_GLOBAL_HEARTBEATS]: '',
        [(0, $a9Nfh.SupportUrlKeys).API_PING_URL]: '',
        [(0, $a9Nfh.SupportUrlKeys).HEARTBEATS_API]: '',
        [(0, $a9Nfh.SupportUrlKeys).CREATE_API_TOKEN]: '',
        [(0, $a9Nfh.SupportUrlKeys).EMAIL_INSTRUCTIONS]: ''
    }
});
const $f6ad09ed9eb62767$export$e5b9693a695bc1d6 = ()=>(0, $5uXOq.useContext)($f6ad09ed9eb62767$var$HeartbeatsContext);
const $f6ad09ed9eb62767$export$fde947f04a8a5906 = ({ children: children, isTransitioning: isTransitioning, isPrimaryAdmin: isPrimaryAdmin, supportUrls: supportUrls })=>{
    const filters = (0, $b3dJz.useFilters)();
    const focusState = (0, $33XOa.useFocusState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6ad09ed9eb62767$var$HeartbeatsContext.Provider, {
        value: {
            filters: filters,
            focusState: focusState,
            isTransitioning: isTransitioning,
            isPrimaryAdmin: isPrimaryAdmin,
            supportUrls: supportUrls
        }
    }, children);
};

});
parcelRegister("b3dJz", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $c1e758f44c962dd5$export$973ca22476b0e05f);

var $5uXOq = parcelRequire("5uXOq");
const $c1e758f44c962dd5$export$973ca22476b0e05f = ()=>{
    const [searchText, setSearchText] = (0, $5uXOq.useState)('');
    const [statuses, setStatuses] = (0, $5uXOq.useState)([]);
    return {
        searchText: searchText,
        statuses: statuses,
        handleSearchTextChange: setSearchText,
        handleStatusesChange: setStatuses
    };
};

});

parcelRegister("33XOa", function(module, exports) {

$parcel$export(module.exports, "useFocusState", () => $295fee831cb30542$export$ae79915617215704);

var $5uXOq = parcelRequire("5uXOq");
const $295fee831cb30542$export$ae79915617215704 = ()=>{
    const [isOpen, setOpen] = (0, $5uXOq.useState)(false);
    const [mode, setMode] = (0, $5uXOq.useState)();
    const [data, setData] = (0, $5uXOq.useState)();
    const [returnRef, setReturnRef] = (0, $5uXOq.useState)();
    const close = ()=>{
        setMode(undefined);
        setData(undefined);
        setOpen(false);
        setReturnRef(undefined);
    };
    const open = (settings)=>{
        setData(settings.mode === 'create' ? undefined : settings.data);
        setMode(settings.mode);
        setOpen(true);
        setReturnRef(settings.returnRef);
    };
    return {
        isOpen: isOpen,
        mode: mode,
        data: data,
        returnRef: returnRef,
        open: open,
        close: close
    };
};

});


parcelRegister("8xiJF", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $cc7a74969c494b2c$export$fddf379e22a74b00);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $hTEpF = parcelRequire("hTEpF");

var $jhmo0 = parcelRequire("jhmo0");

var $h8yj2 = parcelRequire("h8yj2");

var $dcaj2 = parcelRequire("dcaj2");

var $a9Nfh = parcelRequire("a9Nfh");

var $bfQPa = parcelRequire("bfQPa");

var $9w3gY = parcelRequire("9w3gY");

var $eBqFt = parcelRequire("eBqFt");

var $pJLAO = parcelRequire("pJLAO");

var $8xn55 = parcelRequire("8xn55");
const $cc7a74969c494b2c$export$fddf379e22a74b00 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { supportUrls: supportUrls } = (0, $eBqFt.useHeartbeatsContext)();
    const whatAreHeartbeatsUrl = supportUrls[(0, $a9Nfh.OptionalSupportUrlKeys).WHAT_ARE_HEARTBEATS];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $8xn55.default).title),
        description: formatMessage((0, $8xn55.default).description, {
            linkReadMore: (msg)=>whatAreHeartbeatsUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
                    href: whatAreHeartbeatsUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: (e)=>{
                        e.stopPropagation();
                        const event = createAnalyticsEvent({});
                        (0, $h8yj2.fireUIAnalytics)(event, 'link clicked', 'learnMore');
                    }
                }, msg) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcaj2.IPHAnchor), {
                    id: "heartbeats-empty-state",
                    requiresDot: true,
                    onClick: (e)=>{
                        e.stopPropagation();
                        const event = createAnalyticsEvent({});
                        (0, $h8yj2.fireUIAnalytics)(event, 'link clicked', 'learnMore');
                    }
                }, msg)
        }),
        headingLevel: 3,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9w3gY.CreateButton), null),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bfQPa.AutoCreateButton), null),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $pJLAO.CustomSVG), null)
    });
};

});
parcelRegister("dcaj2", function(module, exports) {

$parcel$export(module.exports, "IPHLink", () => $0f1e1fb6194c43d2$export$8ca4cba792159c15);
$parcel$export(module.exports, "IPHAnchor", () => $0f1e1fb6194c43d2$export$207fbd0853777a20);

var $5uXOq = parcelRequire("5uXOq");

var $hDzhb = parcelRequire("hDzhb");

var $jhmo0 = parcelRequire("jhmo0");

var $cgL5K = parcelRequire("cgL5K");

var $5CSWr = parcelRequire("5CSWr");
const $0f1e1fb6194c43d2$export$8ca4cba792159c15 = ({ id: id, children: children, requiresDot: requiresDot, onClick: onClick, ...restProps })=>{
    const { handleClick: handleClick } = (0, $5CSWr.useActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
        onClick: (event)=>{
            event.preventDefault();
            onClick?.(event);
            handleClick(id);
        },
        ...restProps
    }, children), requiresDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, "."));
};
const $0f1e1fb6194c43d2$export$207fbd0853777a20 = ({ id: id, children: children, requiresDot: requiresDot, onClick: onClick, ...restProps })=>{
    const { handleClick: handleClick } = (0, $5CSWr.useActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: "",
        onClick: (event, analytics)=>{
            event.preventDefault();
            onClick?.(event, analytics);
            handleClick(id);
        },
        ...restProps
    }, children), requiresDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, "."));
};

});
parcelRegister("5CSWr", function(module, exports) {

$parcel$export(module.exports, "Container", () => $ed5d957c8094ea69$export$42a852a2b6b56249);
$parcel$export(module.exports, "useActions", () => $ed5d957c8094ea69$export$bc923229a7fa61e7);

var $3sQ5x = parcelRequire("3sQ5x");
var $eW6Xc = parcelRequire("eW6Xc");
var $iXqE5 = parcelRequire("iXqE5");

var $5WwZV = parcelRequire("5WwZV");
const $ed5d957c8094ea69$var$Store = (0, $iXqE5.createStore)({
    initialState: {},
    actions: $5WwZV.actions
});
const $ed5d957c8094ea69$export$42a852a2b6b56249 = (0, $eW6Xc.createContainer)($ed5d957c8094ea69$var$Store);
const $ed5d957c8094ea69$export$bc923229a7fa61e7 = (0, $3sQ5x.createActionsHook)($ed5d957c8094ea69$var$Store);

});
parcelRegister("eW6Xc", function(module, exports) {

$parcel$export(module.exports, "createDefaultEocWrapper", () => $479853350fd92f18$export$a9264953429b0df);
$parcel$export(module.exports, "createContainer", () => $479853350fd92f18$export$26ae5ca175b4ec5a);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
/**
 * This component runs the useContainerHook with props that are sent from useSyncContainerProps.
 * We can use all features of react hooks inside here. Also, we created this component outside of
 * the createDefaultEocWrapper due to if we use this inside of the createDefaultEocWrapper,
 * it'll re-render on every child have changed.
 */ function $479853350fd92f18$var$InnerElement({ children: children, useContainerHook: useContainerHook, containerProps: containerProps }) {
    useContainerHook?.(containerProps);
    return children;
}
function $479853350fd92f18$export$a9264953429b0df({ useSyncContainerProps: useSyncContainerProps, useContainerHook: useContainerHook }) {
    return ({ children: children })=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(children)) {
            const containerProps = useSyncContainerProps ? useSyncContainerProps(children.props) : {};
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(children, {
                ...children.props,
                ...containerProps
            }, useContainerHook ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($479853350fd92f18$var$InnerElement, {
                useContainerHook: useContainerHook,
                containerProps: containerProps
            }, children.props.children) : children.props.children);
        }
        return null;
    };
}
const $479853350fd92f18$export$26ae5ca175b4ec5a = (store, options)=>{
    const OriginalContainer = (0, $gg7kZ.createContainer)(store, {
        ...options
    });
    const HOC = ({ ...props })=>{
        return options?.Wrapper ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(options.Wrapper, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OriginalContainer, props, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OriginalContainer, props, props.children);
    };
    HOC.displayName = OriginalContainer.displayName + '-HOC'; // To track if error occure because of HOC
    return HOC;
};

});

parcelRegister("5WwZV", function(module, exports) {

$parcel$export(module.exports, "actions", () => $f8f2b378390bc8e0$export$e324594224ef24da);
const $f8f2b378390bc8e0$var$handleClick = (id)=>({}, { clickHandler: clickHandler, links: links })=>{
        if (!links[id]) return;
        const { iphId: iphId, sacUrl: sacUrl } = links[id];
        if (typeof clickHandler !== 'undefined') return clickHandler(iphId);
        window.open(sacUrl, '_blank');
    };
const $f8f2b378390bc8e0$export$e324594224ef24da = {
    handleClick: $f8f2b378390bc8e0$var$handleClick
};

});



parcelRegister("bfQPa", function(module, exports) {

$parcel$export(module.exports, "AutoCreateButton", () => $d7c41ddfc6354bb8$export$ee0d302b60e0aca5);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $ecUTX = parcelRequire("ecUTX");

var $eQXmh = parcelRequire("eQXmh");

var $hoCgA = parcelRequire("hoCgA");
const $d7c41ddfc6354bb8$export$ee0d302b60e0aca5 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isAutoCreateEnabled: isAutoCreateEnabled, isAutoCreateUpdating: isAutoCreateUpdating, handleUpdateAutoCreation: handleUpdateAutoCreation, isUpdateAutoCreationModalOpen: isUpdateAutoCreationModalOpen, handleUpdateAutoCreationClick: handleUpdateAutoCreationClick, handleCloseUpdateAutoCreationModal: handleCloseUpdateAutoCreationModal } = (0, $ecUTX.useAutoCreateController)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        isLoading: isAutoCreateUpdating,
        onClick: handleUpdateAutoCreationClick
    }, formatMessage((0, $hoCgA.default).turnAutoHeartbeatButton, {
        isEnabled: isAutoCreateEnabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eQXmh.AutoCreateConfirmModal), {
        onConfirm: handleUpdateAutoCreation,
        onClose: handleCloseUpdateAutoCreationModal,
        isOpen: isUpdateAutoCreationModalOpen,
        isEnabled: isAutoCreateEnabled
    }));
};

});
parcelRegister("ecUTX", function(module, exports) {

$parcel$export(module.exports, "useAutoCreateController", () => $858c2886e1764329$export$b1e7c272e203bcef);

var $5uXOq = parcelRequire("5uXOq");

var $hem2I = parcelRequire("hem2I");

var $coZh4 = parcelRequire("coZh4");

var $90XDC = parcelRequire("90XDC");
const $858c2886e1764329$export$b1e7c272e203bcef = ()=>{
    const { isAutoCreateUpdating: isAutoCreateUpdating, updateAutoCreation: updateAutoCreation } = (0, $coZh4.useAutoCreateService)();
    const { data: data, update: update } = (0, $hem2I.default)((0, $90XDC.heartbeatsResource));
    const [isUpdateAutoCreationModalOpen, setUpdateAutoCreationModalOpen] = (0, $5uXOq.useState)(false);
    const isAutoCreateEnabled = (0, $5uXOq.useMemo)(()=>!!data?.autoCreateEnabled, [
        data?.autoCreateEnabled
    ]);
    const handleUpdateAutoCreationClick = ()=>{
        setUpdateAutoCreationModalOpen(true);
    };
    const handleCloseUpdateAutoCreationModal = ()=>{
        setUpdateAutoCreationModalOpen(false);
    };
    const handleUpdateAutoCreation = ()=>{
        handleCloseUpdateAutoCreationModal();
        return updateAutoCreation(!isAutoCreateEnabled).then(()=>{
            update((state)=>({
                    ...state,
                    autoCreateEnabled: !isAutoCreateEnabled
                }));
        }).catch(()=>{});
    };
    return {
        isAutoCreateEnabled: isAutoCreateEnabled,
        isAutoCreateUpdating: isAutoCreateUpdating,
        isUpdateAutoCreationModalOpen: isUpdateAutoCreationModalOpen,
        handleUpdateAutoCreation: handleUpdateAutoCreation,
        handleUpdateAutoCreationClick: handleUpdateAutoCreationClick,
        handleCloseUpdateAutoCreationModal: handleCloseUpdateAutoCreationModal
    };
};

});
parcelRegister("coZh4", function(module, exports) {

$parcel$export(module.exports, "useAutoCreateService", () => $066b5eee19071e13$export$68d06f10362421d0);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bmKPg = parcelRequire("bmKPg");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $6dFjI = parcelRequire("6dFjI");

var $3wndl = parcelRequire("3wndl");
const $066b5eee19071e13$export$68d06f10362421d0 = ()=>{
    const [isAutoCreateUpdating, setAutoCreateUpdating] = (0, $5uXOq.useState)(false);
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const flagApi = (0, $2tKfK.default)();
    const intlApi = (0, $koVbs.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const updateAutoCreation = (autoCreateEnabled)=>{
        setAutoCreateUpdating(true);
        return (0, $6dFjI.updateAutoCreationEndpoint)(teamId, autoCreateEnabled).then(()=>{
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: intlApi.formatMessage((0, $3wndl.default).updateAutoCreationSuccessTitle, {
                    isEnabled: autoCreateEnabled
                })
            });
        }).catch((e)=>{
            defaultCatch({
                id: 'updateAutoCreation',
                httpErrorHandler: (error)=>{
                    flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: error.message,
                        title: intlApi.formatMessage((0, $3wndl.default).updateAutoCreationErrorTitle, {
                            isEnabled: autoCreateEnabled
                        })
                    });
                }
            }, e);
            throw e;
        }).finally(()=>{
            setAutoCreateUpdating(false);
        });
    };
    return {
        isAutoCreateUpdating: isAutoCreateUpdating,
        updateAutoCreation: updateAutoCreation
    };
};

});
parcelRegister("3wndl", function(module, exports) {

$parcel$export(module.exports, "default", () => $998a8ef76586a41b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $998a8ef76586a41b$var$messages = (0, $7VHMR.defineMessages)({
    deleteErrorTitle: {
        id: 'eoc-heartbeats.services.store.delete-heartbeat-error-title.no-translate',
        defaultMessage: "We couldn\u2019t delete the heartbeat",
        description: `This message will be shown when the request for deleting the heartbeat fails and it will be shown
    on the error flag title`
    },
    deleteSuccessTitle: {
        id: 'eoc-heartbeats.services.store.delete-heartbeat-success-title.no-translate',
        defaultMessage: 'Heartbeat deleted',
        description: `This message will be shown when the request for deleting the heartbeat succeeded and it will be shown
    on the success flag title`
    },
    deleteSuccessDescription: {
        id: 'eoc-heartbeats.services.store.delete-heartbeat-success-description.no-translate',
        defaultMessage: 'Nothing to worry about, everything is going great!',
        description: `This message will be shown when the request for deleting the heartbeat succeeded and it will be shown
    on the success flag description`
    },
    updateAutoCreationSuccessTitle: {
        id: 'eoc-heartbeats.services.store.update-auto-creation-success-title.no-translate',
        defaultMessage: 'Auto-heartbeats {isEnabled, select, true {turned on} other {turned off}}.',
        description: `This message will be shown when the request for deleting the heartbeat succeeded and it will be shown
    on the success flag title`
    },
    updateAutoCreationErrorTitle: {
        id: 'eoc-heartbeats.services.store.update-auto-creation-error-title.no-translate',
        defaultMessage: "We couldn\u2019t {isEnabled, select, true {turned on} other {turned off}} auto-heartbeats",
        description: `This message will be shown when the request for turning on/off auto-heartbeats and it will be shown
    on the error flag title`
    }
});
var $998a8ef76586a41b$export$2e2bcd8739ae039 = $998a8ef76586a41b$var$messages;

});



parcelRegister("eQXmh", function(module, exports) {

$parcel$export(module.exports, "AutoCreateConfirmModal", () => $7ca1507ddddc46e3$export$11bf014349aea4b6);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $hBpDN = parcelRequire("hBpDN");
const $7ca1507ddddc46e3$export$11bf014349aea4b6 = ({ isOpen: isOpen, isEnabled: isEnabled, onClose: onClose, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $hBpDN.messages).title, {
        isEnabled: isEnabled
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, formatMessage(isEnabled ? (0, $hBpDN.messages).turnOffDescription : (0, $hBpDN.messages).turnOnDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: onClose,
        autoFocus: true
    }, formatMessage((0, $hBpDN.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "warning",
        onClick: onConfirm
    }, formatMessage((0, $hBpDN.messages).actionButton, {
        isEnabled: isEnabled
    })))));
};

});
parcelRegister("hBpDN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8e4b56f7eddc94e7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8e4b56f7eddc94e7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.heartbeats.confirm-modal.title.no-translate',
        defaultMessage: '{isEnabled, select, true {Turn off} other {Turn on}} auto-heartbeats',
        description: 'The text will be displayed in the confirm modal title'
    },
    turnOnDescription: {
        id: 'eoc.heartbeats.confirm-modal.turn-on-description.no-translate',
        defaultMessage: "We\u2019ll automatically create a new heartbeat for each ping request you send, if the heartbeat doesn\u2019t already exist.",
        description: 'The text will be displayed in the turn on confirm modal body description'
    },
    turnOffDescription: {
        id: 'eoc.heartbeats.confirm-modal.turn-off-description.no-translate',
        defaultMessage: "We\u2019ll no longer create heartbeats for the pings you send.",
        description: 'The text will be displayed in the turn off confirm modal body description'
    },
    cancel: {
        id: 'eoc.heartbeats.confirm-modal.cancel-button.no-translate',
        defaultMessage: 'Cancel',
        description: 'The text will be displayed in the confirm modal footer for cancel button.'
    },
    actionButton: {
        id: 'eoc.heartbeats.extra-property.confirm-modal.confirm-button.no-translate',
        defaultMessage: '{isEnabled, select, true {Turn off} other {Turn on}}',
        description: 'The text will be displayed in the confirm modal footer for confirm button.'
    }
});

});


parcelRegister("hoCgA", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabc99a8a0bc4491$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $fabc99a8a0bc4491$var$messages = (0, $7VHMR.defineMessages)({
    turnAutoHeartbeatButton: {
        id: 'eoc.heartbeats.empty-state.secondary-action.no-translate',
        defaultMessage: '{isEnabled, select, true {Turn off} other {Turn on}} auto-heartbeats',
        description: 'Text of secondary empty state button used to turn on auto heartbeat creation.'
    }
});
var $fabc99a8a0bc4491$export$2e2bcd8739ae039 = $fabc99a8a0bc4491$var$messages;

});


parcelRegister("9w3gY", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $83681d50d241befd$export$6d3c345ce7c38fd9);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $h8yj2 = parcelRequire("h8yj2");

var $eBqFt = parcelRequire("eBqFt");

var $fV6sm = parcelRequire("fV6sm");
const $83681d50d241befd$export$6d3c345ce7c38fd9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { focusState: focusState } = (0, $eBqFt.useHeartbeatsContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: (_, analyticsEvent)=>{
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'createHeartbeatButton');
            focusState.open({
                mode: 'create'
            });
        }
    }, formatMessage((0, $fV6sm.default).createHeartbeatButton));
};

});
parcelRegister("fV6sm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb4d583f2e96bf37$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $cb4d583f2e96bf37$var$messages = (0, $7VHMR.defineMessages)({
    createHeartbeatButton: {
        id: 'eoc.heartbeats.empty-state.primary-action.no-translate',
        defaultMessage: 'Create heartbeat',
        description: 'Text of primary empty state button used to create heartbeat.'
    }
});
var $cb4d583f2e96bf37$export$2e2bcd8739ae039 = $cb4d583f2e96bf37$var$messages;

});


parcelRegister("pJLAO", function(module, exports) {

$parcel$export(module.exports, "CustomSVG", () => $c1f2a0450a3d7f39$export$59357636fba1f8da);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5uXOq = parcelRequire("5uXOq");
const $c1f2a0450a3d7f39$export$59357636fba1f8da = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "160",
        height: "170",
        viewBox: "0 0 160 137",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_1719_8670)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "160",
        height: "136.01",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M111.697 39.5325H14.3169V136.042H111.697V39.5325Z",
        fill: "#CFD4DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M111.762 39.5325H41.4028V107.383H111.762V39.5325Z",
        fill: "url(#paint0_linear_1719_8670)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M54.752 71.9065H31.6646V73.1963H54.752V71.9065Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M54.752 64.2322H31.6646V65.522H54.752V64.2322Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M44.1756 56.5579H31.6646V57.8477H44.1756V56.5579Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.4084 56.5579H24.5708V57.8477H27.4084V56.5579Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.4084 64.2322H24.5708V65.522H27.4084V64.2322Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.4084 71.9065H24.5708V73.1963H27.4084V71.9065Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.4084 79.5164H24.5708V80.8062H27.4084V79.5164Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.4084 87.1907H24.5708V88.4805H27.4084V87.1907Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.4084 94.8005H24.5708V96.0903H27.4084V94.8005Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.4084 102.475H24.5708V103.765H27.4084V102.475Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.4084 110.149H24.5708V111.439H27.4084V110.149Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M27.4084 117.759H24.5708V119.049H27.4084V117.759Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M98.9278 94.8005H59.5889V96.0903H98.9278V94.8005Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M55.2034 94.8005H31.6646V96.0903H55.2034V94.8005Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M102.668 102.475H69.198V103.765H102.668V102.475Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M64.8771 102.475H44.1758V103.765H64.8771V102.475Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M89.7058 110.149H44.1758V111.439H89.7058V110.149Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M75.5179 117.759H56.6868V119.049H75.5179V117.759Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M67.7792 79.5164H46.175V80.8062H67.7792V79.5164Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M67.7792 87.1907H46.175V88.4805H67.7792V87.1907Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M26.8925 88.6739C22.4064 88.6664 18.0228 90.0151 14.3169 92.5433V99.7017C16.5691 97.213 19.5091 95.4485 22.7647 94.6317C26.0203 93.8148 29.4451 93.9822 32.6054 95.1128C35.7658 96.2434 38.5197 98.2862 40.5184 100.983C42.5171 103.679 43.6708 106.908 43.8335 110.261C43.9962 113.613 43.1604 116.939 41.4321 119.816C39.7038 122.693 37.1607 124.993 34.1246 126.424C31.0885 127.856 27.696 128.354 24.3767 127.856C21.0573 127.358 17.9603 125.886 15.4777 123.628L14.3169 122.467V129.625C17.216 131.573 20.5309 132.816 23.9964 133.254C27.4618 133.691 30.9816 133.311 34.2739 132.145C37.5663 130.978 40.5398 129.057 42.9565 126.535C45.3732 124.013 47.166 120.96 48.1914 117.621C49.2167 114.282 49.4463 110.749 48.8615 107.306C48.2768 103.862 46.894 100.603 44.8239 97.7894C42.7538 94.976 40.0539 92.6862 36.9401 91.1033C33.8264 89.5204 30.3854 88.6884 26.8925 88.6739Z",
        fill: "#CFD4DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M149.617 0H52.2371V96.5095H149.617V0Z",
        fill: "url(#paint1_linear_1719_8670)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M92.6724 32.374H69.585V33.6638H92.6724V32.374Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M92.6724 24.6997H69.585V25.9895H92.6724V24.6997Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M82.096 17.0254H69.585V18.3152H82.096V17.0254Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M65.2641 17.0254H62.4265V18.3152H65.2641V17.0254Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M65.2641 24.6997H62.4265V25.9895H65.2641V24.6997Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M65.2641 32.374H62.4265V33.6638H65.2641V32.374Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M65.2641 39.9839H62.4265V41.2737H65.2641V39.9839Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M65.2641 47.6582H62.4265V48.948H65.2641V47.6582Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M65.2641 55.2681H62.4265V56.5579H65.2641V55.2681Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M65.2641 62.9424H62.4265V64.2322H65.2641V62.9424Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M65.2641 70.6167H62.4265V71.9065H65.2641V70.6167Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M65.2641 78.2266H62.4265V79.5164H65.2641V78.2266Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M136.784 55.2681H97.4446V56.5579H136.784V55.2681Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M93.1238 55.2681H69.585V56.5579H93.1238V55.2681Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M140.589 62.9424H107.118V64.2322H140.589V62.9424Z",
        fill: "#FFAB00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M102.733 62.9424H82.0315V64.2322H102.733V62.9424Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M127.562 70.6167H82.0315V71.9065H127.562V70.6167Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M113.374 78.2266H94.5425V79.5164H113.374V78.2266Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M105.699 39.9839H84.0952V41.2737H105.699V39.9839Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M105.699 47.6582H84.0952V48.948H105.699V47.6582Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M149.617 42.5635C146.76 39.1832 142.965 36.726 138.711 35.5028C134.457 34.2795 129.937 34.3451 125.72 35.6912C121.504 37.0373 117.781 39.6035 115.024 43.0653C112.266 46.5271 110.596 50.7289 110.226 55.1395C109.857 59.55 110.803 63.9712 112.946 67.8438C115.089 71.7165 118.332 74.8668 122.265 76.8962C126.199 78.9256 130.646 79.7431 135.044 79.2452C139.441 78.7474 143.593 76.9565 146.973 74.0991C147.918 73.2834 148.801 72.3997 149.617 71.4551V42.5635ZM132.527 73.9702C129.173 73.9702 125.894 72.9754 123.104 71.1117C120.315 69.2481 118.141 66.5991 116.857 63.4999C115.574 60.4007 115.238 56.9904 115.892 53.7004C116.547 50.4103 118.162 47.3881 120.534 45.0161C122.906 42.6441 125.928 41.0287 129.218 40.3743C132.509 39.7198 135.919 40.0557 139.018 41.3394C142.117 42.6232 144.766 44.7971 146.63 47.5863C148.493 50.3755 149.488 53.6547 149.488 57.0093C149.488 61.5076 147.701 65.8216 144.52 69.0024C141.34 72.1832 137.026 73.9702 132.527 73.9702Z",
        fill: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.52356 120.586L-0.0527344 130.162L2.68335 132.898L12.2596 123.322L9.52356 120.586Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M135.752 73.4545C146.615 73.4545 155.421 64.6481 155.421 53.785C155.421 42.9218 146.615 34.1155 135.752 34.1155C124.889 34.1155 116.083 42.9218 116.083 53.785C116.083 64.6481 124.889 73.4545 135.752 73.4545Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M140.524 55.9775H115.244V59.8469H140.524V55.9775Z",
        fill: "#FDC150"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M140.524 43.7888H117.824V47.6582H140.524V43.7888Z",
        fill: "#FAFBFC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.5",
        d: "M155.421 53.7849C155.421 53.0755 155.421 52.4306 155.357 51.7212C153.422 45.8484 149.249 40.976 143.742 38.1626C138.236 35.3491 131.842 34.8217 125.95 36.695C122.955 38.4166 120.466 40.8964 118.734 43.8852C117.002 46.8739 116.087 50.2661 116.083 53.7204C116.748 51.4545 117.857 49.3437 119.347 47.5108C120.836 45.678 122.675 44.1598 124.756 43.0448C126.838 41.9297 129.121 41.2401 131.472 41.016C133.823 40.7919 136.195 41.0379 138.45 41.7396C140.705 42.4413 142.797 43.5847 144.606 45.1032C146.415 46.6217 147.903 48.485 148.984 50.5844C150.066 52.6838 150.718 54.9774 150.905 57.3316C151.091 59.6858 150.807 62.0535 150.069 64.2968C149.446 66.2418 148.51 68.0718 147.296 69.714C149.812 67.8898 151.861 65.4951 153.273 62.7262C154.686 59.9574 155.422 56.8932 155.421 53.7849Z",
        fill: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M135.752 75.3891C131.479 75.3891 127.302 74.122 123.749 71.7481C120.196 69.3742 117.427 66.0001 115.792 62.0524C114.157 58.1048 113.729 53.7609 114.563 49.5701C115.396 45.3793 117.454 41.5298 120.475 38.5084C123.497 35.487 127.346 33.4294 131.537 32.5958C135.728 31.7622 140.072 32.19 144.019 33.8252C147.967 35.4604 151.341 38.2294 153.715 41.7822C156.089 45.335 157.356 49.512 157.356 53.7849C157.356 59.5147 155.08 65.0098 151.028 69.0613C146.977 73.1129 141.482 75.3891 135.752 75.3891ZM135.752 36.0501C132.244 36.0501 128.815 37.0902 125.899 39.0389C122.983 40.9877 120.709 43.7574 119.367 46.9981C118.025 50.2387 117.674 53.8045 118.358 57.2447C119.042 60.685 120.731 63.845 123.212 66.3252C125.692 68.8055 128.852 70.4946 132.292 71.1789C135.732 71.8632 139.298 71.512 142.539 70.1697C145.779 68.8274 148.549 66.5543 150.498 63.6378C152.447 60.7213 153.487 57.2925 153.487 53.7849C153.487 49.0813 151.618 44.5704 148.292 41.2445C144.966 37.9186 140.455 36.0501 135.752 36.0501Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M25.022 127.368C35.8852 127.368 44.6915 118.562 44.6915 107.699C44.6915 96.8354 35.8852 88.0291 25.022 88.0291C14.1589 88.0291 5.35254 96.8354 5.35254 107.699C5.35254 118.562 14.1589 127.368 25.022 127.368Z",
        fill: "#E5E8EC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M34.3088 116.018H22.8296V119.887H34.3088V116.018Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M34.3088 103.894H22.8296V107.763H34.3088V103.894Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M33.7929 91.7048H22.8296V95.5742H33.7929V91.7048Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.2",
        d: "M27.9241 88.2224C22.3303 88.4082 16.9857 90.5811 12.8492 94.3512C8.71263 98.1214 6.05482 103.242 5.35254 108.795C5.56904 112.683 6.93485 116.419 9.27691 119.531C11.619 122.642 14.8319 124.988 18.5085 126.272C16.469 124.997 14.7089 123.323 13.3345 121.349C11.96 119.375 10.9998 117.144 10.5118 114.789C10.0238 112.434 10.018 110.005 10.4949 107.647C10.9718 105.29 11.9215 103.054 13.2866 101.074C14.6517 99.094 16.4038 97.4111 18.4373 96.1271C20.4708 94.843 22.7435 93.9843 25.118 93.6029C27.4925 93.2215 29.9198 93.3253 32.2531 93.908C34.5864 94.4906 36.7775 95.5401 38.6939 96.9931C40.9284 98.5049 42.7826 100.514 44.1111 102.862C43.1368 99.1077 41.0848 95.7211 38.2084 93.1196C35.3319 90.5182 31.7568 88.8158 27.9241 88.2224Z",
        fill: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M25.0222 129.303C20.7493 129.303 16.5723 128.036 13.0195 125.662C9.46673 123.288 6.69767 119.914 5.0625 115.966C3.42733 112.018 2.99949 107.674 3.8331 103.484C4.6667 99.2929 6.7243 95.4434 9.7457 92.422C12.7671 89.4006 16.6166 87.343 20.8074 86.5094C24.9982 85.6758 29.3421 86.1036 33.2897 87.7388C37.2374 89.3739 40.6115 92.143 42.9854 95.6958C45.3593 99.2486 46.6264 103.426 46.6264 107.698C46.6264 113.428 44.3502 118.923 40.2986 122.975C36.2471 127.026 30.752 129.303 25.0222 129.303ZM25.0222 89.9637C21.5146 89.9637 18.0857 91.0038 15.1693 92.9525C12.2528 94.9012 9.97967 97.671 8.63737 100.912C7.29506 104.152 6.94385 107.718 7.62815 111.158C8.31246 114.599 10.0015 117.759 12.4818 120.239C14.962 122.719 18.1221 124.408 21.5623 125.092C25.0025 125.777 28.5684 125.426 31.809 124.083C35.0496 122.741 37.8194 120.468 39.7681 117.551C41.7168 114.635 42.757 111.206 42.757 107.698C42.757 102.995 40.8885 98.484 37.5626 95.1581C34.2366 91.8321 29.7257 89.9637 25.0222 89.9637Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M150.447 66.7551L147.71 69.4912L157.268 79.0493L160.005 76.3132L150.447 66.7551Z",
        fill: "#0065FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint0_linear_1719_8670",
        x1: "76.5628",
        y1: "107.383",
        x2: "76.5628",
        y2: "10.8731",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#E5E8EC",
        stopOpacity: "0.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.08",
        stopColor: "#E1E4E9",
        stopOpacity: "0.27"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.18",
        stopColor: "#DCE0E5",
        stopOpacity: "0.46"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.29",
        stopColor: "#D8DCE2",
        stopOpacity: "0.63"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.4",
        stopColor: "#D5D9DF",
        stopOpacity: "0.76"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.53",
        stopColor: "#D2D7DD",
        stopOpacity: "0.87"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.66",
        stopColor: "#D0D5DC",
        stopOpacity: "0.94"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.8",
        stopColor: "#CFD4DB",
        stopOpacity: "0.99"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#CFD4DB"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint1_linear_1719_8670",
        x1: "52.437",
        y1: "96.7287",
        x2: "149.379",
        y2: "-0.219268",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        stopColor: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.58",
        stopColor: "#192D4E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.78",
        stopColor: "#203354"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.93",
        stopColor: "#2B3D5C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#344563"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_1719_8670"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "160",
        height: "136.01",
        fill: "white"
    }))));
};

});

parcelRegister("8xn55", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0388504eaf1d873$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c0388504eaf1d873$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.heartbeats.empty-state.title.no-translate',
        defaultMessage: 'Add your first heartbeat',
        description: 'Title of the empty state.'
    },
    description: {
        id: 'eoc.heartbeats.empty-state.description.no-translate',
        defaultMessage: 'Heartbeats maintain the functionality of your systems by sending regular pings and generating alerts when unresponsive. <linkReadMore>Read more about heartbeats</linkReadMore>',
        description: 'Description of the empty state'
    },
    primaryActionButton: {
        id: 'eoc.heartbeats.empty-state.primary-action.no-translate',
        defaultMessage: 'Create heartbeat',
        description: 'Text of primary empty state button used to create heartbeat.'
    },
    secondaryActionButton: {
        id: 'eoc.heartbeats.empty-state.secondary-action.no-translate',
        defaultMessage: 'Turn on auto-heartbeats',
        description: 'Text of secondary empty state button used to turn on auto heartbeat creation.'
    }
});
var $c0388504eaf1d873$export$2e2bcd8739ae039 = $c0388504eaf1d873$var$messages;

});


parcelRegister("fFflN", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $29fab9ac2935f5d5$export$c1ed4f415b9e7023);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $hTEpF = parcelRequire("hTEpF");

var $3T3fi = parcelRequire("3T3fi");

var $h6wNC = parcelRequire("h6wNC");
const $29fab9ac2935f5d5$export$c1ed4f415b9e7023 = ({ title: title })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: title || formatMessage((0, $h6wNC.default).errorStateTitle),
        description: formatMessage((0, $h6wNC.default).errorStateDescription),
        headingLevel: 2,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            onClick: ()=>window.location.reload(),
            appearance: "primary"
        }, formatMessage((0, $h6wNC.default).errorStateCTA)),
        width: "wide",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3T3fi)))
    });
};

});
parcelRegister("3T3fi", function(module, exports) {
module.exports = new URL("Error.09b29c7d.svg", import.meta.url).toString();

});

parcelRegister("h6wNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $592094481590a5c6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $592094481590a5c6$var$messages = (0, $7VHMR.defineMessages)({
    errorStateTitle: {
        id: 'eoc.heartbeats.common.team.error-state-title.no-translate',
        defaultMessage: "We couldn\u2019t load the heartbeats",
        description: 'Title that will be shown when there is error in fetching heartbeats'
    },
    errorStateDescription: {
        id: 'eoc.heartbeats.common.team.error-state-description.no-translate',
        defaultMessage: 'Refresh the page to try again.',
        description: 'Description that will be shown when there is error in fetching heartbeats'
    },
    errorStateCTA: {
        id: 'eoc.heartbeats.common.team.error-state-cta.no-translate',
        defaultMessage: 'Refresh',
        description: 'Call to action that will be shown when there is error in fetching heartbeats'
    }
});
var $592094481590a5c6$export$2e2bcd8739ae039 = $592094481590a5c6$var$messages;

});


parcelRegister("8od9I", function(module, exports) {

$parcel$export(module.exports, "Focus", () => $7921785a33dc6da2$export$807a7eae502106e7);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $84THj = parcelRequire("84THj");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $c9zAO = parcelRequire("c9zAO");
var $gUawG = parcelRequire("gUawG");

var $xNdpE = parcelRequire("xNdpE");

var $eBqFt = parcelRequire("eBqFt");

var $1Ik9L = parcelRequire("1Ik9L");

var $bxZSn = parcelRequire("bxZSn");
const $7921785a33dc6da2$var$ColumnStyles = (0, $8CUq3.xcss)({
    width: '100%',
    marginTop: 'space.400',
    marginLeft: 'auto',
    marginRight: 'auto'
});
const $7921785a33dc6da2$var$MiddleColumnMediumStyles = (0, $8CUq3.xcss)({
    maxWidth: '705px'
});
const $7921785a33dc6da2$var$MiddleColumnLargeStyles = (0, $8CUq3.xcss)({
    maxWidth: '994px'
});
const $7921785a33dc6da2$var$CrossButtonContainerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    left: '56px',
    top: 'space.400'
});
const $7921785a33dc6da2$var$WrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    flex: '1 1 0',
    overflow: 'auto'
});
const $7921785a33dc6da2$export$807a7eae502106e7 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { focusState: focusState } = (0, $eBqFt.useHeartbeatsContext)();
    (0, $gUawG.useCloseOnEscapePress)({
        onClose: focusState.close
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9zAO.default), {
        isOpen: focusState.isOpen,
        returnFocusRef: focusState.returnRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7921785a33dc6da2$var$WrapperStyles
    }, focusState.mode !== 'view' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7921785a33dc6da2$var$CrossButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        label: formatMessage((0, $xNdpE.default).closeFocusState),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($84THj))),
        onClick: focusState.close
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $7921785a33dc6da2$var$ColumnStyles,
            focusState.mode !== 'view' ? $7921785a33dc6da2$var$MiddleColumnMediumStyles : $7921785a33dc6da2$var$MiddleColumnLargeStyles
        ]
    }, (focusState.mode === 'create' || focusState.mode === 'edit' || focusState.mode === 'duplicate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxZSn.Form), {
        data: focusState.data
    }), focusState.mode === 'view' && !!focusState.data && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Ik9L.Detail), {
        data: focusState.data
    }))));
};

});
parcelRegister("c9zAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dcb38b620190310$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");

var $k8nZq = parcelRequire("k8nZq");

var $hwd6J = parcelRequire("hwd6J");
const $7dcb38b620190310$var$FocusState = ({ isOpen: isOpen, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k8nZq.default), {
        zIndex: "unset"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35XSW.default), {
        appear: true
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hwd6J.Wrapper), props)));
var $7dcb38b620190310$export$2e2bcd8739ae039 = $7dcb38b620190310$var$FocusState;

});
parcelRegister("hwd6J", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $827b078dcb836503$export$e6dfd72ab29f8598);

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");

var $9ZKDH = parcelRequire("9ZKDH");

var $2alJM = parcelRequire("2alJM");

var $SliG5 = parcelRequire("SliG5");

var $8Sbj3 = parcelRequire("8Sbj3");

var $VSDnB = parcelRequire("VSDnB");

var $j8GHK = parcelRequire("j8GHK");
const $827b078dcb836503$export$e6dfd72ab29f8598 = ({ children: children, onAnimationFinish: onAnimationFinish, autoFocus: autoFocus = false, whiteList: whiteList, returnFocusRef: returnFocusRef, returnFocus: returnFocus, onDeactivation: onDeactivation, label: label, titleId: titleId })=>{
    const FocusLock = (0, $VSDnB.fg)('platform_dst_modal-dialog-bump-focus-lock') ? (0, $9ZKDH.default) : (0, $ao4Ml.default);
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    const accessibilityAttributes = {
        role: 'dialog',
        'aria-modal': true,
        'aria-label': label,
        'aria-labelledby': titleId
    };
    (0, $SliG5.default)(typeof autoFocus === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Sbj3.default), {
        enterFrom: "left",
        exitTo: "left",
        fade: "in",
        duration: 500,
        onFinish: onAnimationFinish
    }, (slideInProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FocusLock, {
            returnFocus: returnFocus,
            autoFocus: autoFocusLock,
            onDeactivation: (args)=>{
                if (!!returnFocusRef) window.setTimeout(()=>{
                    returnFocusRef.current?.focus();
                }, 0);
                onDeactivation?.(args);
            },
            whiteList: (element)=>{
                if (element.role === 'alert') return false; // False means it will not be controlled by the focus
                return !!whiteList ? whiteList(element) : true;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8GHK.Container), {
            ...slideInProps,
            ...accessibilityAttributes,
            tabIndex: -1
        }, children))));
};

});
parcelRegister("9ZKDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $746dfd2d0cf51cd7$export$2e2bcd8739ae039);

var $6PeDP = parcelRequire("6PeDP");

var $746dfd2d0cf51cd7$export$2e2bcd8739ae039 = (0, $6PeDP.default);

});
parcelRegister("6PeDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f82dcf8634374b5$export$2e2bcd8739ae039);

var $ddEsc = parcelRequire("ddEsc");

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");

var $ahD4b = parcelRequire("ahD4b");

var $b2m1U = parcelRequire("b2m1U");
var $4f82dcf8634374b5$var$FocusLockCombination = /*#__PURE__*/ $5uXOq.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $ahD4b.default), (0, $bS32t.default)({
        sideCar: (0, $b2m1U.default),
        ref: ref
    }, props));
});
var $4f82dcf8634374b5$var$_ref = (0, $ahD4b.default).propTypes || {}, $4f82dcf8634374b5$var$sideCar = $4f82dcf8634374b5$var$_ref.sideCar, $4f82dcf8634374b5$var$propTypes = (0, $ddEsc.default)($4f82dcf8634374b5$var$_ref, [
    "sideCar"
]);
$4f82dcf8634374b5$var$FocusLockCombination.propTypes = {};
var $4f82dcf8634374b5$export$2e2bcd8739ae039 = $4f82dcf8634374b5$var$FocusLockCombination;

});
parcelRegister("ahD4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $77c9cbb18a82bf09$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $5uXOq = parcelRequire("5uXOq");


var $26Cgu = parcelRequire("26Cgu");

var $3Du7S = parcelRequire("3Du7S");

var $i9hEi = parcelRequire("i9hEi");

var $bBdTc = parcelRequire("bBdTc");

var $qUTzN = parcelRequire("qUTzN");
var $77c9cbb18a82bf09$var$emptyArray = [];
var $77c9cbb18a82bf09$var$FocusLock = /*#__PURE__*/ $5uXOq.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $5uXOq.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $5uXOq.useRef();
    var isActive = $5uXOq.useRef(false);
    var originalFocusedElement = $5uXOq.useRef(null);
    var _React$useState2 = $5uXOq.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $77c9cbb18a82bf09$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $5uXOq.useState({}), id = _React$useState3[0];
    var onActivation = $5uXOq.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $5uXOq.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $5uXOq.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $5uXOq.useCallback(function(event) {
        if (isActive.current) (0, $bBdTc.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $bBdTc.mediumBlur).useMedium;
    var setObserveNode = $5uXOq.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $bS32t.default)((_extends2 = {}, _extends2[$26Cgu.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$26Cgu.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $3Du7S.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $5uXOq.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $5uXOq.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $i9hEi.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $5uXOq.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $i9hEi.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $5uXOq.createElement(SideCar, {
        id: id,
        sideCar: (0, $bBdTc.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ $5uXOq.createElement(Container, (0, $bS32t.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $5uXOq.createElement((0, $qUTzN.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $i9hEi.hiddenGuard)
    }));
});
$77c9cbb18a82bf09$var$FocusLock.propTypes = {};
var $77c9cbb18a82bf09$export$2e2bcd8739ae039 = $77c9cbb18a82bf09$var$FocusLock;

});
parcelRegister("i9hEi", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $d366c1f945d68088$export$b8c7b07253306600);

var $5uXOq = parcelRequire("5uXOq");

var $d366c1f945d68088$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $d366c1f945d68088$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, /*#__PURE__*/ $5uXOq.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $d366c1f945d68088$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $5uXOq.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $d366c1f945d68088$export$b8c7b07253306600
    }));
};
$d366c1f945d68088$var$InFocusGuard.propTypes = {};
var $d366c1f945d68088$export$2e2bcd8739ae039 = $d366c1f945d68088$var$InFocusGuard;

});

parcelRegister("bBdTc", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $871dec83c3926a0e$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $871dec83c3926a0e$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $871dec83c3926a0e$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $871dec83c3926a0e$export$892cbf28e5518020);

var $bzFTo = parcelRequire("bzFTo");
var $871dec83c3926a0e$export$5733e022b1d538cb = (0, $bzFTo.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $871dec83c3926a0e$export$b3e9a9312f73723c = (0, $bzFTo.createMedium)();
var $871dec83c3926a0e$export$3a1d52767cbc07b8 = (0, $bzFTo.createMedium)();
var $871dec83c3926a0e$export$892cbf28e5518020 = (0, $bzFTo.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});

parcelRegister("qUTzN", function(module, exports) {

$parcel$export(module.exports, "focusScope", () => $050e900ff3b78811$export$f5272e9b1168239c);

var $5uXOq = parcelRequire("5uXOq");
var $050e900ff3b78811$export$f5272e9b1168239c = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});


parcelRegister("b2m1U", function(module, exports) {

$parcel$export(module.exports, "default", () => $8090f8448316e203$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $6mqio = parcelRequire("6mqio");

var $j4988 = parcelRequire("j4988");
var $2RQOj = parcelRequire("2RQOj");
var $1q0r0 = parcelRequire("1q0r0");
var $5x9g9 = parcelRequire("5x9g9");
var $jl7aa = parcelRequire("jl7aa");
var $l1lpg = parcelRequire("l1lpg");
var $cCk2L = parcelRequire("cCk2L");

var $e53ns = parcelRequire("e53ns");

var $bBdTc = parcelRequire("bBdTc");
var $8090f8448316e203$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $8090f8448316e203$var$isFreeFocus = function isFreeFocus() {
    return $8090f8448316e203$var$focusOnBody() || (0, $jl7aa.focusIsHidden)();
};
var $8090f8448316e203$var$lastActiveTrap = null;
var $8090f8448316e203$var$lastActiveFocus = null;
var $8090f8448316e203$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $8090f8448316e203$var$lastPortaledElement = null;
var $8090f8448316e203$var$focusWasOutsideWindow = false;
var $8090f8448316e203$var$windowFocused = false;
var $8090f8448316e203$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $8090f8448316e203$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($8090f8448316e203$var$lastActiveTrap.whiteList || $8090f8448316e203$var$defaultWhitelist)(activeElement);
};
var $8090f8448316e203$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $8090f8448316e203$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $8090f8448316e203$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $8090f8448316e203$var$lastPortaledElement && $8090f8448316e203$var$lastPortaledElement.portaledElement === element;
};
function $8090f8448316e203$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $8090f8448316e203$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($8090f8448316e203$var$focusWasOutsideWindow);
    return $8090f8448316e203$var$focusWasOutsideWindow === 'meanwhile';
};
var $8090f8448316e203$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $8090f8448316e203$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $8090f8448316e203$var$checkInHost(activeElement, area, area);
    });
};
var $8090f8448316e203$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $l1lpg.getFocusableNodes)(nodes, new Map());
};
var $8090f8448316e203$var$isNotFocusable = function isNotFocusable(node) {
    return !$8090f8448316e203$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $8090f8448316e203$var$activateTrap = function activateTrap() {
    var result = false;
    if ($8090f8448316e203$var$lastActiveTrap) {
        var _lastActiveTrap = $8090f8448316e203$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $8090f8448316e203$var$lastPortaledElement && $8090f8448316e203$var$lastPortaledElement.portaledElement;
        if ($8090f8448316e203$var$focusOnBody() && $8090f8448316e203$var$lastActiveFocus) {
            if (!document.body.contains($8090f8448316e203$var$lastActiveFocus) || $8090f8448316e203$var$isNotFocusable($8090f8448316e203$var$lastActiveFocus)) {
                $8090f8448316e203$var$lastActiveFocus = null;
                var newTarget = $8090f8448316e203$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $e53ns.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$8090f8448316e203$var$focusWasOutside(crossFrame) || !noFocusGuards || !$8090f8448316e203$var$lastActiveFocus || $8090f8448316e203$var$windowFocused) return false;
                var nodes = $8090f8448316e203$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $8090f8448316e203$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $8090f8448316e203$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$8090f8448316e203$var$isFreeFocus() || !$8090f8448316e203$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $5x9g9.focusInside)(workingArea) || activeElement && $8090f8448316e203$var$withinHost(activeElement, workingArea) || $8090f8448316e203$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$8090f8448316e203$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $cCk2L.moveFocusInside)(workingArea, $8090f8448316e203$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $8090f8448316e203$var$lastPortaledElement = {};
                        }
                    }
                    $8090f8448316e203$var$focusWasOutsideWindow = false;
                    $8090f8448316e203$var$lastActiveFocus = document && document.activeElement;
                    $8090f8448316e203$var$tryRestoreFocus = (0, $j4988.captureFocusRestore)($8090f8448316e203$var$lastActiveFocus);
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $2RQOj.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $8090f8448316e203$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $8090f8448316e203$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $8090f8448316e203$var$onTrap = function onTrap(event) {
    if ($8090f8448316e203$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $8090f8448316e203$var$onBlur = function onBlur() {
    return (0, $e53ns.deferAction)($8090f8448316e203$var$activateTrap);
};
var $8090f8448316e203$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $8090f8448316e203$var$recordPortal(currentNode, source);
};
var $8090f8448316e203$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $8090f8448316e203$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        onBlur: $8090f8448316e203$var$onBlur,
        onFocus: $8090f8448316e203$var$onFocus
    }, children);
};
$8090f8448316e203$var$FocusTrap.propTypes = {};
var $8090f8448316e203$var$onWindowFocus = function onWindowFocus() {
    $8090f8448316e203$var$windowFocused = true;
};
var $8090f8448316e203$var$onWindowBlur = function onWindowBlur() {
    $8090f8448316e203$var$windowFocused = false;
    $8090f8448316e203$var$focusWasOutsideWindow = 'just';
    (0, $e53ns.deferAction)(function() {
        $8090f8448316e203$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $8090f8448316e203$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $8090f8448316e203$var$onTrap);
    document.addEventListener('focusout', $8090f8448316e203$var$onBlur);
    window.addEventListener('focus', $8090f8448316e203$var$onWindowFocus);
    window.addEventListener('blur', $8090f8448316e203$var$onWindowBlur);
};
var $8090f8448316e203$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $8090f8448316e203$var$onTrap);
    document.removeEventListener('focusout', $8090f8448316e203$var$onBlur);
    window.removeEventListener('focus', $8090f8448316e203$var$onWindowFocus);
    window.removeEventListener('blur', $8090f8448316e203$var$onWindowBlur);
};
function $8090f8448316e203$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $8090f8448316e203$var$focusLockAPI = {
    moveFocusInside: (0, $cCk2L.moveFocusInside),
    focusInside: (0, $5x9g9.focusInside),
    focusNextElement: (0, $1q0r0.focusNextElement),
    focusPrevElement: (0, $1q0r0.focusPrevElement),
    focusFirstElement: (0, $1q0r0.focusFirstElement),
    focusLastElement: (0, $1q0r0.focusLastElement),
    captureFocusRestore: (0, $j4988.captureFocusRestore)
};
function $8090f8448316e203$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$8090f8448316e203$var$lastActiveTrap) $8090f8448316e203$var$attachHandler();
    var lastTrap = $8090f8448316e203$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $8090f8448316e203$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $8090f8448316e203$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($8090f8448316e203$var$focusLockAPI);
        $8090f8448316e203$var$activateTrap(true);
        (0, $e53ns.deferAction)($8090f8448316e203$var$activateTrap);
    } else {
        $8090f8448316e203$var$detachHandler();
        $8090f8448316e203$var$lastActiveFocus = null;
    }
}
(0, $bBdTc.mediumFocus).assignSyncMedium($8090f8448316e203$var$onFocus);
(0, $bBdTc.mediumBlur).assignMedium($8090f8448316e203$var$onBlur);
(0, $bBdTc.mediumEffect).assignMedium(function(cb) {
    return cb($8090f8448316e203$var$focusLockAPI);
});
var $8090f8448316e203$export$2e2bcd8739ae039 = (0, $6mqio.default)($8090f8448316e203$var$reducePropsToState, $8090f8448316e203$var$handleStateChangeOnClient)($8090f8448316e203$var$FocusWatcher);

});
parcelRegister("e53ns", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $a40426fda9e67416$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $a40426fda9e67416$export$c613fed06e332533);
function $a40426fda9e67416$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $a40426fda9e67416$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $a40426fda9e67416$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("j8GHK", function(module, exports) {

$parcel$export(module.exports, "Container", () => $cef6782c660ceaff$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
const $cef6782c660ceaff$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1fzto3r0"
})({
    position: 'fixed',
    display: 'flex',
    zIndex: (0, $k5uoT.layers).modal(),
    top: '0px',
    left: '0px',
    width: '100vw',
    height: '100vh',
    background: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    pointerEvents: 'initial'
});

});



parcelRegister("gUawG", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $1b2d9a76966481dd$export$4a4bf067ea9e7886);

var $5uXOq = parcelRequire("5uXOq");
const $1b2d9a76966481dd$export$4a4bf067ea9e7886 = ({ onClose: onClose, isDisabled: isDisabled })=>{
    const escapePressed = (0, $5uXOq.useRef)(false);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== 'Escape') return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $5uXOq.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        document.addEventListener('keydown', onKeyDown);
        document.addEventListener('keyup', onKeyUp);
        return ()=>{
            document.removeEventListener('keydown', onKeyDown);
            document.removeEventListener('onKeyUp', onKeyUp);
        };
    }, [
        onKeyDown,
        onKeyUp
    ]);
};

});

parcelRegister("xNdpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa93c3de9e860f8c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $fa93c3de9e860f8c$var$messages = (0, $7VHMR.defineMessages)({
    description: {
        id: 'eoc.heartbeats.empty-state.description.no-translate',
        defaultMessage: 'Create a heartbeat to monitor the connectivity of your systems by using the <linkRestApi>Heartbeats API</linkRestApi> or sending an email. <linkReadMore>Read more about heartbeats</linkReadMore>',
        description: 'Description of the empty state'
    },
    cancel: {
        id: 'eoc.heartbeats.cancel.no-translate',
        defaultMessage: 'Cancel',
        description: 'Cancel button text.'
    },
    chevronDownIconLabel: {
        id: 'eoc.heartbeats.chevron-down-icon-label.no-translate',
        defaultMessage: 'Chevron down',
        description: 'Chevron down icon label.'
    },
    closeFocusState: {
        id: 'eoc.heartbeats.close-focus-state-icon-label.no-translate',
        defaultMessage: 'Close focus state',
        description: 'Chevron down icon label.'
    },
    errorTitle: {
        id: 'eoc-heartbeats.error-title.no-translate',
        defaultMessage: 'Error',
        description: 'Title of error message that will be displayed in the flag'
    }
});
var $fa93c3de9e860f8c$export$2e2bcd8739ae039 = $fa93c3de9e860f8c$var$messages;

});

parcelRegister("1Ik9L", function(module, exports) {

$parcel$export(module.exports, "Detail", () => $466e9469e80eb647$export$47eb42ff093406d4);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("7pOuf");
var $3jBDv = parcelRequire("3jBDv");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $l1N8i = parcelRequire("l1N8i");

var $3Fq5M = parcelRequire("3Fq5M");

var $bJeNF = parcelRequire("bJeNF");

var $c2i4s = parcelRequire("c2i4s");

var $VSDnB = parcelRequire("VSDnB");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $fphHl = parcelRequire("fphHl");
var $jxIT3 = parcelRequire("jxIT3");
var $cte3m = parcelRequire("cte3m");
var $8TQB5 = parcelRequire("8TQB5");

var $d9xxV = parcelRequire("d9xxV");

var $6UXEc = parcelRequire("6UXEc");


var $3bDjY = parcelRequire("3bDjY");

var $h8yj2 = parcelRequire("h8yj2");

var $aIZdc = parcelRequire("aIZdc");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $dP9y2 = parcelRequire("dP9y2");

var $gILJi = parcelRequire("gILJi");

var $jxRF2 = parcelRequire("jxRF2");

var $diw6H = parcelRequire("diw6H");
var $fXc9u = parcelRequire("fXc9u");

var $hem2I = parcelRequire("hem2I");

var $awLan = parcelRequire("awLan");

var $a9Nfh = parcelRequire("a9Nfh");

var $ikN1y = parcelRequire("ikN1y");

var $aSfpo = parcelRequire("aSfpo");

var $34X01 = parcelRequire("34X01");

var $5AXpX = parcelRequire("5AXpX");

var $jrQLn = parcelRequire("jrQLn");

var $eBqFt = parcelRequire("eBqFt");

var $7mCor = parcelRequire("7mCor");

var $90XDC = parcelRequire("90XDC");

var $5g2ZN = parcelRequire("5g2ZN");

var $5J8sV = parcelRequire("5J8sV");
const $466e9469e80eb647$var$bottomBoxStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius.200'
});
const $466e9469e80eb647$var$topBoxStyles = (0, $8CUq3.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius.200',
    borderWidth: 'border.width'
});
const $466e9469e80eb647$var$attributeLabelStyles = (0, $8CUq3.xcss)({
    width: '160px',
    flexShrink: 0,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    color: 'color.text.subtlest',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});
const $466e9469e80eb647$var$tagsLabelStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '28px'
});
const $466e9469e80eb647$var$attributeValueStyles = (0, $8CUq3.xcss)({
    minWidth: '0',
    wordBreak: 'break-word'
});
const $466e9469e80eb647$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    maxWidth: '1024px',
    width: '100%'
});
const $466e9469e80eb647$var$fullWidthStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
const $466e9469e80eb647$var$badgeWrapperStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});
const $466e9469e80eb647$export$47eb42ff093406d4 = ({ data: active })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [responder] = (0, $fXc9u.useResponderNames)([
        {
            type: 'team',
            id: active.ownerTeamId
        }
    ]);
    const { data: user } = (0, $hem2I.default)((0, $jxRF2.eocUserResource));
    const { data: response } = (0, $hem2I.default)((0, $90XDC.heartbeatsResource));
    const { data: rights } = (0, $hem2I.default)((0, $90XDC.heartbeatsUserRightsResource));
    (0, $hmVmJ.assert)(!!response && !!rights, new (0, $dH6Pi.AssertionError)('Detail', 'data coming from resources should not be undefined!'));
    const timeZone = user?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const { focusState: focusState, isTransitioning: isTransitioning, supportUrls: supportUrls } = (0, $eBqFt.useHeartbeatsContext)();
    const { isDeleteModalOpen: isDeleteModalOpen, handleDelete: handleDelete, handleDeleteClick: handleDeleteClick, isDeleting: isDeleting, handleModalClose: handleModalClose } = (0, $jrQLn.useDeleteModalController)();
    const { handleSwitchClick: handleSwitchClick, handleSwitch: handleSwitch, isSwitchModalOpen: isSwitchModalOpen, isSwitchLoading: isSwitchLoading, handleModalClose: handleSwitchModalClose } = (0, $7mCor.useSwitchController)();
    const data = (0, $5uXOq.useMemo)(()=>response.heartbeats.find((heartbeat)=>heartbeat.name === active.name) ?? active, [
        active,
        response
    ]);
    const apiPingUrl = supportUrls[(0, $a9Nfh.SupportUrlKeys).API_PING_URL];
    const apiDocumentation = supportUrls[(0, $a9Nfh.SupportUrlKeys).API_DOCUMENTATION];
    const createAPIToken = supportUrls[(0, $a9Nfh.SupportUrlKeys).CREATE_API_TOKEN];
    const emailInstructions = supportUrls[(0, $a9Nfh.SupportUrlKeys).EMAIL_INSTRUCTIONS];
    const apiUrl = (0, $5uXOq.useMemo)(()=>{
        const baseUrl = (0, $aIZdc.isFedRamp)() ? 'https://api.atlassian-us-gov-mod.com' : 'https://api.atlassian.com';
        return `${baseUrl}${apiPingUrl}?name=${data.name}`;
    }, [
        apiPingUrl,
        data.name
    ]);
    const attributes = [
        {
            label: formatMessage((0, $5g2ZN.default).name),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "p"
            }, data.name)
        },
        {
            label: formatMessage((0, $5g2ZN.default).description),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "p"
            }, data.description ?? '-')
        },
        {
            label: formatMessage((0, $5g2ZN.default).assignedTeam),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $diw6H.default), {
                responder: responder
            })
        },
        {
            label: formatMessage((0, $5g2ZN.default).lastPinged),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "p"
            }, (0, $awLan.MIN_DATE_SHOWN_EPOCH) <= data.lastReceivedAt && data.lastReceivedAt <= (0, $5AXpX.getMaxAvailableEpoch)() ? (0, $3jBDv.default)(data.lastReceivedAt, timeZone, 'MMM d, y h:mm a') : '-')
        },
        {
            label: formatMessage((0, $5g2ZN.default).nextPing),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "p"
            }, (0, $awLan.MIN_DATE_SHOWN_EPOCH) <= data.willExpireAt && data.willExpireAt <= (0, $5AXpX.getMaxAvailableEpoch)() ? (0, $3jBDv.default)(data.willExpireAt, timeZone, 'MMM d, y h:mm a') : '-')
        },
        {
            label: formatMessage((0, $5g2ZN.default).pingInterval),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "p"
            }, data.interval, " ", data.intervalUnit)
        },
        {
            label: formatMessage((0, $5g2ZN.default).status),
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aSfpo.HeartbeatStatus), {
                heartbeat: data
            })
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center",
        xcss: $466e9469e80eb647$var$contentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        grow: "fill",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large"
    }, data.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100"
    }, rights.hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: ()=>{
            handleSwitchClick(data);
        },
        isLoading: data.status === 'Off' && isSwitchLoading
    }, data.status === 'Off' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).turOnButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).turOffButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: focusState.close
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).close)), rights.hasDeleteRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                label: "more",
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
                ref: triggerRef,
                appearance: "subtle"
            }),
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            handleDeleteClick(data);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).delete))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        grow: "fill",
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).title))), isTransitioning && (0, $VSDnB.fg)('platform.show-optimal-tooling_brgom') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: formatMessage((0, $5g2ZN.default).transitioningTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).transitioningMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $466e9469e80eb647$var$topBoxStyles,
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $466e9469e80eb647$var$fullWidthStyles,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: $466e9469e80eb647$var$fullWidthStyles,
        space: "space.200"
    }, attributes.map((attribute, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "start",
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $466e9469e80eb647$var$attributeLabelStyles
        }, attribute.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $466e9469e80eb647$var$attributeValueStyles
        }, attribute.content)))), rights.hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        onClick: (_, analyticsEvent)=>{
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'editButton');
            focusState.open({
                data: data,
                mode: 'edit'
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).edit))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5J8sV.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $466e9469e80eb647$var$attributeLabelStyles
    }, formatMessage((0, $5g2ZN.default).alertMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $466e9469e80eb647$var$attributeValueStyles,
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $466e9469e80eb647$var$badgeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gILJi.default), {
        priority: data.alertPriority
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, data.alertMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $466e9469e80eb647$var$attributeLabelStyles,
            $466e9469e80eb647$var$tagsLabelStyles
        ]
    }, formatMessage((0, $5g2ZN.default).alertTags)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $466e9469e80eb647$var$attributeValueStyles,
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UXEc.default), null, data.alertTags.map((alertTag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            key: alertTag,
            position: "bottom",
            content: alertTag
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
            text: alertTag
        })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        backgroundColor: "color.background.neutral.hovered",
        xcss: $466e9469e80eb647$var$bottomBoxStyles,
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).instructions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fphHl.default), {
        id: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cte3m.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxIT3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).apiTabTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxIT3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).emailTabTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TQB5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).apiInstruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        as: "ol",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: createAPIToken,
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).apiInstructionSecondBulletCreateToken)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).apiInstructionFirstBullet)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $5g2ZN.default).apiInstructionSecondBullet,
        tagName: "span",
        values: {
            linkApiDocumentation: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
                    href: apiDocumentation,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, msg)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5J8sV.StyledCode), null, apiUrl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dP9y2.CopyToClipboard), {
        tooltip: (0, $5g2ZN.default).copy,
        value: apiUrl
    }, ({ isCopied: isCopied })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
            spacing: "spacious",
            label: "",
            color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).apiInstructionThirdBullet)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).apiInstructionFourthBullet))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TQB5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).emailInstruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        as: "ol",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).emailInstructionFirstBullet), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5J8sV.StyledCode), null, data.name, response.heartbeatEmailDomain), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dP9y2.CopyToClipboard), {
        tooltip: (0, $5g2ZN.default).copy,
        value: `${data.name}${response.heartbeatEmailDomain}`
    }, ({ isCopied: isCopied })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
            spacing: "spacious",
            label: "",
            color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).emailInstructionSecondBullet)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: emailInstructions,
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5g2ZN.default).emailInstructionLearnMore)))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikN1y.DeleteModal), {
        onDeleteAttemptCancel: handleModalClose,
        onDelete: ()=>handleDelete().then(()=>focusState.close()),
        isLoading: isDeleting,
        isDeleteDialogOpen: isDeleteModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34X01.SwitchModal), {
        onSwitchAttemptCancel: handleSwitchModalClose,
        onSwitch: handleSwitch,
        isLoading: isSwitchLoading,
        isSwitchDialogOpen: isSwitchModalOpen
    }));
};

});
parcelRegister("7pOuf", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("3jBDv")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $3jBDv = parcelRequire("3jBDv");





});
parcelRegister("3jBDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $26a0572fe950f2cb$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $61Uyf = parcelRequire("61Uyf");

var $5JlXS = parcelRequire("5JlXS");
function $26a0572fe950f2cb$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $61Uyf.default)((0, $5JlXS.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("61Uyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $463eb401f4e59c9f$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $9aXG6 = parcelRequire("9aXG6");

var $61HCj = parcelRequire("61HCj");
var $463eb401f4e59c9f$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $463eb401f4e59c9f$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($463eb401f4e59c9f$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $61HCj.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $9aXG6.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("9aXG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ae3570f968e4346$export$2e2bcd8739ae039);

var $kbn1d = parcelRequire("kbn1d");

var $7l0tz = parcelRequire("7l0tz");
var $6ae3570f968e4346$var$MILLISECONDS_IN_MINUTE = 60000;
var $6ae3570f968e4346$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $6ae3570f968e4346$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $6ae3570f968e4346$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $6ae3570f968e4346$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $6ae3570f968e4346$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $6ae3570f968e4346$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $6ae3570f968e4346$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $6ae3570f968e4346$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $6ae3570f968e4346$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $6ae3570f968e4346$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $6ae3570f968e4346$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $6ae3570f968e4346$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $kbn1d.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $kbn1d.default)('long', date, options);
        }
    }
};
function $6ae3570f968e4346$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $7l0tz.default)(timeZone, originalDate, true) / $6ae3570f968e4346$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $6ae3570f968e4346$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $6ae3570f968e4346$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $6ae3570f968e4346$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $6ae3570f968e4346$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $6ae3570f968e4346$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $6ae3570f968e4346$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $6ae3570f968e4346$var$formatTimezone(offset, dirtyDelimeter);
}
function $6ae3570f968e4346$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $6ae3570f968e4346$var$addLeadingZeros(minutes, 2);
}
var $6ae3570f968e4346$export$2e2bcd8739ae039 = $6ae3570f968e4346$var$formatters;

});
parcelRegister("kbn1d", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb16b0b8d4838c1a$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $eb16b0b8d4838c1a$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $eb16b0b8d4838c1a$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $eb16b0b8d4838c1a$var$partsTimeZone(dtf, date) : $eb16b0b8d4838c1a$var$hackyTimeZone(dtf, date);
}
function $eb16b0b8d4838c1a$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $eb16b0b8d4838c1a$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $eb16b0b8d4838c1a$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("7l0tz", function(module, exports) {

$parcel$export(module.exports, "default", () => $557add12604a4253$export$2e2bcd8739ae039);

var $7uvRJ = parcelRequire("7uvRJ");

var $eTApr = parcelRequire("eTApr");
var $557add12604a4253$var$MILLISECONDS_IN_HOUR = 3600000;
var $557add12604a4253$var$MILLISECONDS_IN_MINUTE = 60000;
var $557add12604a4253$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $557add12604a4253$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $557add12604a4253$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $557add12604a4253$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$557add12604a4253$var$validateTimezone(hours)) return NaN;
        return -(hours * $557add12604a4253$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $557add12604a4253$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$557add12604a4253$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $557add12604a4253$var$MILLISECONDS_IN_HOUR + minutes * $557add12604a4253$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($557add12604a4253$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $557add12604a4253$var$toUtcDate(date);
        var offset = $557add12604a4253$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $557add12604a4253$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $557add12604a4253$var$toUtcDate(date) {
    return (0, $eTApr.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $557add12604a4253$var$calcOffset(date, timezoneString) {
    var tokens = (0, $7uvRJ.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $eTApr.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $557add12604a4253$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $557add12604a4253$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $557add12604a4253$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $557add12604a4253$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $557add12604a4253$var$validIANATimezoneCache = {};
function $557add12604a4253$var$isValidTimezoneIANAString(timeZoneString) {
    if ($557add12604a4253$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $557add12604a4253$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("7uvRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $57440d9e0f195ac1$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $57440d9e0f195ac1$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $57440d9e0f195ac1$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $57440d9e0f195ac1$var$partsOffset(dtf, date) : $57440d9e0f195ac1$var$hackyOffset(dtf, date);
}
var $57440d9e0f195ac1$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $57440d9e0f195ac1$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $57440d9e0f195ac1$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $57440d9e0f195ac1$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $57440d9e0f195ac1$var$dtfCache = {};
function $57440d9e0f195ac1$var$getDateTimeFormat(timeZone) {
    if (!$57440d9e0f195ac1$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $57440d9e0f195ac1$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $57440d9e0f195ac1$var$dtfCache[timeZone];
}

});

parcelRegister("eTApr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad8271dce117ee3c$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $ad8271dce117ee3c$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("61HCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4634ab807c03cbcf$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $7l0tz = parcelRequire("7l0tz");

var $99su0 = parcelRequire("99su0");
var $4634ab807c03cbcf$var$MILLISECONDS_IN_HOUR = 3600000;
var $4634ab807c03cbcf$var$MILLISECONDS_IN_MINUTE = 60000;
var $4634ab807c03cbcf$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $4634ab807c03cbcf$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $99su0.default)
};
function $4634ab807c03cbcf$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $4634ab807c03cbcf$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $4634ab807c03cbcf$var$splitDateString(argument);
    var parseYearResult = $4634ab807c03cbcf$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $4634ab807c03cbcf$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $4634ab807c03cbcf$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $7l0tz.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $4634ab807c03cbcf$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $4634ab807c03cbcf$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $4634ab807c03cbcf$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $4634ab807c03cbcf$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $4634ab807c03cbcf$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $4634ab807c03cbcf$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $4634ab807c03cbcf$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $4634ab807c03cbcf$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $4634ab807c03cbcf$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $4634ab807c03cbcf$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $4634ab807c03cbcf$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$4634ab807c03cbcf$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $4634ab807c03cbcf$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$4634ab807c03cbcf$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $4634ab807c03cbcf$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$4634ab807c03cbcf$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $4634ab807c03cbcf$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$4634ab807c03cbcf$var$validateWeekDate(year, week)) return new Date(NaN);
        return $4634ab807c03cbcf$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $4634ab807c03cbcf$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$4634ab807c03cbcf$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $4634ab807c03cbcf$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $4634ab807c03cbcf$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $4634ab807c03cbcf$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$4634ab807c03cbcf$var$validateTime(hours)) return NaN;
        return hours % 24 * $4634ab807c03cbcf$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $4634ab807c03cbcf$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$4634ab807c03cbcf$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $4634ab807c03cbcf$var$MILLISECONDS_IN_HOUR + minutes * $4634ab807c03cbcf$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $4634ab807c03cbcf$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$4634ab807c03cbcf$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $4634ab807c03cbcf$var$MILLISECONDS_IN_HOUR + minutes * $4634ab807c03cbcf$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $4634ab807c03cbcf$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $4634ab807c03cbcf$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $4634ab807c03cbcf$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $4634ab807c03cbcf$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $4634ab807c03cbcf$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $4634ab807c03cbcf$var$isLeapYearIndex(year);
        if (isLeapYear && date > $4634ab807c03cbcf$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $4634ab807c03cbcf$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $4634ab807c03cbcf$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $4634ab807c03cbcf$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $4634ab807c03cbcf$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $4634ab807c03cbcf$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("99su0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a9b0c7151457606$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $6a9b0c7151457606$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $6a9b0c7151457606$export$2e2bcd8739ae039 = $6a9b0c7151457606$var$tzPattern;

});



parcelRegister("5JlXS", function(module, exports) {

$parcel$export(module.exports, "default", () => $42c23177231fac7f$export$2e2bcd8739ae039);

var $7l0tz = parcelRequire("7l0tz");

var $61HCj = parcelRequire("61HCj");
function $42c23177231fac7f$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $61HCj.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $7l0tz.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});



parcelRegister("bJeNF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::384f31b6891d11603b1a7b84cc388cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $889f60aca54b55ef$var$_react = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $889f60aca54b55ef$var$_showMoreHorizontal = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("8U6zd")));

var $889f60aca54b55ef$var$_more = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("3oUqw")));
function $889f60aca54b55ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $889f60aca54b55ef$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $889f60aca54b55ef$var$_react.default.createElement($889f60aca54b55ef$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $889f60aca54b55ef$var$_more.default
    }, props));
$889f60aca54b55ef$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $889f60aca54b55ef$var$_default = module.exports.default = $889f60aca54b55ef$var$ShowMoreHorizontalIcon;

});

parcelRegister("fphHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4810d6c8b7d5c95d$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $dWD6q = parcelRequire("dWD6q");
const $4810d6c8b7d5c95d$var$baseStyles = null;
const $4810d6c8b7d5c95d$var$tabsStyles = null;
const $4810d6c8b7d5c95d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ $5uXOq.createElement((0, $dWD6q.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4810d6c8b7d5c95d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dWD6q.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), null, tabPanelsWithContext));
};
var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;

});
parcelRegister("dWD6q", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $b47499898157cfdc$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $b47499898157cfdc$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $b47499898157cfdc$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $b47499898157cfdc$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("jxIT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a23bdf24c904bdb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $cgL5K = parcelRequire("cgL5K");

var $eQ4wW = parcelRequire("eQ4wW");
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $5a23bdf24c904bdb$var$Tab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $eQ4wW.useTab)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children)));
});
var $5a23bdf24c904bdb$export$2e2bcd8739ae039 = $5a23bdf24c904bdb$var$Tab;

});
parcelRegister("eQ4wW", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $4d8616502e4de6b0$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $4d8616502e4de6b0$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $4d8616502e4de6b0$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $dWD6q = parcelRequire("dWD6q");
const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $dWD6q.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $dWD6q.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $dWD6q.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("cte3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15f9538b451f314$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $eQ4wW = parcelRequire("eQ4wW");

var $dWD6q = parcelRequire("dWD6q");
const $e15f9538b451f314$var$baseStyles = null;
const $e15f9538b451f314$var$tabListStyles = null;
const $e15f9538b451f314$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $e15f9538b451f314$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $eQ4wW.useTabList)();
    const ref = /*#__PURE__*/ (0, $5uXOq.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ $5uXOq.createElement((0, $dWD6q.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        className: (0, $bwpsq.default)([
            "_1yt4ze3t _1e0c1txw _kqswh2mm",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _13xael4l _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _13xael4l _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ])
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        })));
};
var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;

});

parcelRegister("8TQB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca06f45af60382a8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $eQ4wW = parcelRequire("eQ4wW");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $ca06f45af60382a8$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $eQ4wW.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, children)));
};
var $ca06f45af60382a8$export$2e2bcd8739ae039 = $ca06f45af60382a8$var$TabPanel;

});

parcelRegister("d9xxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87927dab24395a15$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");
const $87927dab24395a15$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5oSQr.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aXLIT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $87927dab24395a15$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;

});
parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");

var $2hnSR = parcelRequire("2hnSR");
function $db35d9df42c66ff0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e6s40.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $e6s40.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $e6s40.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $e6s40.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $e6s40.cssVar).color.text.default})`,
    cursor: 'default'
});
const $db35d9df42c66ff0$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e6s40.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $e6s40.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $e6s40.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $e6s40.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $e6s40.cssVar).color.background.active})`
    }
});
const $db35d9df42c66ff0$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $e6s40.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $db35d9df42c66ff0$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$2hnSR.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.active})`
    }
});
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $2hnSR.textColors['standardLink'] : $2hnSR.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $2hnSR.backgroundColors[color] : $2hnSR.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $2hnSR.backgroundColors[color] : $2hnSR.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$baseStyles : $db35d9df42c66ff0$var$baseStylesOld,
            isInteractive && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$focusRingStyles : $db35d9df42c66ff0$var$focusRingStylesOld),
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? isLink && $db35d9df42c66ff0$var$interactiveStyles : undefined,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $db35d9df42c66ff0$var$nonStandardLinkStyles,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && $db35d9df42c66ff0$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.borderColor]: $2hnSR.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.default]: $2hnSR.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.hover]: $2hnSR.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.active]: $2hnSR.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.default]: $2hnSR.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.focusRing]: $2hnSR.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.removeButton.default]: $2hnSR.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.removeButton.hover]: $2hnSR.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).borderRadius]: $2hnSR.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});
parcelRegister("e6s40", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $1dd8b7ac532261be$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $1dd8b7ac532261be$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $1dd8b7ac532261be$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $1dd8b7ac532261be$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $1dd8b7ac532261be$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $1dd8b7ac532261be$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $1dd8b7ac532261be$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $1dd8b7ac532261be$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $1dd8b7ac532261be$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $1dd8b7ac532261be$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $1dd8b7ac532261be$var$gridSizeValue = (0, $k5uoT.gridSize)();
const $1dd8b7ac532261be$var$borderRadiusValue = (0, $k5uoT.borderRadius)();
const $1dd8b7ac532261be$var$tagHeightUnitless = 2.5 * $1dd8b7ac532261be$var$gridSizeValue;
const $1dd8b7ac532261be$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$1dd8b7ac532261be$var$tagHeightUnitless}px`})`;
const $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca = $1dd8b7ac532261be$var$tagHeightUnitless; // button should be square
const $1dd8b7ac532261be$var$maxWidthUnitless = 25 * $1dd8b7ac532261be$var$gridSizeValue;
const $1dd8b7ac532261be$export$2e3bcb01bf928995 = $1dd8b7ac532261be$var$maxWidthUnitless - $1dd8b7ac532261be$var$tagHeightUnitless;
const $1dd8b7ac532261be$export$982d4a1a6de11130 = `${$1dd8b7ac532261be$export$2e3bcb01bf928995}px`;
const $1dd8b7ac532261be$export$35d5d1e251b985cf = `${$1dd8b7ac532261be$var$borderRadiusValue}px`;
const $1dd8b7ac532261be$export$c49771100fee18c8 = `${$1dd8b7ac532261be$export$c6f3ea2b4cffd0ca / 2}px`;
const $1dd8b7ac532261be$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
const $1dd8b7ac532261be$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
const $1dd8b7ac532261be$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $1dd8b7ac532261be$var$gridSizeValue}px`})`;
const $1dd8b7ac532261be$export$b824cac86306f7a2 = $1dd8b7ac532261be$export$5b2b1030a679f37;
const $1dd8b7ac532261be$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $5b444d8505b9cc3c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $e6s40 = parcelRequire("e6s40");
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$829f609a65d26a98$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    red: `var(--ds-background-accent-red-subtle, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
    green: `var(--ds-background-accent-green-subtle, ${$829f609a65d26a98$export$747d86715d4175de})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$829f609a65d26a98$export$6011520a64d9a187})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$829f609a65d26a98$export$b34b069eff244586})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$829f609a65d26a98$export$776c9c497ef08533})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$829f609a65d26a98$export$b34b069eff244586})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$829f609a65d26a98$export$776c9c497ef08533})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$829f609a65d26a98$export$eece5f492e429f08})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$829f609a65d26a98$export$363e4475840015bb})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$829f609a65d26a98$export$363e4475840015bb})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$829f609a65d26a98$export$747d86715d4175de})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$829f609a65d26a98$export$6011520a64d9a187})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$829f609a65d26a98$export$8754fc7e6d8b3000})`
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`;
const $5b444d8505b9cc3c$export$7a57f79000377ca2 = {
    default: (0, $e6s40.defaultBorderRadius),
    rounded: (0, $e6s40.defaultRoundedBorderRadius)
};
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
const $5b444d8505b9cc3c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
const $5b444d8505b9cc3c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`;
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    limeLight: `var(--ds-text-accent-lime, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    orangeLight: `var(--ds-text-accent-orange, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-text-danger, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    magenta: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    orange: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    grey: `var(--ds-text-danger, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    magentaLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    orangeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    greyLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};

});


parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");
function $4b11e671062d0fc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4b11e671062d0fc5$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $e6s40.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $VSDnB.fg)('platform-component-visual-refresh') ? $4b11e671062d0fc5$var$beforeElementStyles : $4b11e671062d0fc5$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");
function $c46b06918fbe54e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $e6s40.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $e6s40.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $e6s40.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $c46b06918fbe54e8$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $e6s40.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $e6s40.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $c46b06918fbe54e8$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $c46b06918fbe54e8$var$hasAfterStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $e6s40.maxTextWidthUnitless) - (0, $e6s40.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $e6s40.textPaddingRight)
});
const $c46b06918fbe54e8$var$hasAfterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $e6s40.maxTextWidthUnitless) - (0, $e6s40.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $e6s40.textMarginLeft)
});
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $f8Sb3.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$linkStyles : $c46b06918fbe54e8$var$linkStylesOld,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});


parcelRegister("6UXEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c2d1dcb54418fac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2c2d1dcb54418fac$var$baseStyles = null;
const $2c2d1dcb54418fac$var$justifyStartStyles = null;
const $2c2d1dcb54418fac$var$justifyEndStyles = null;
/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */ const $2c2d1dcb54418fac$var$TagGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ])
    }, children);
});
var $2c2d1dcb54418fac$export$2e2bcd8739ae039 = $2c2d1dcb54418fac$var$TagGroup;

});

parcelRegister("dP9y2", function(module, exports) {

$parcel$export(module.exports, "CopyToClipboard", () => $1b270298f114fca4$export$2e6ef246283472d6);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3bDjY = parcelRequire("3bDjY");

var $aEDih = parcelRequire("aEDih");

var $t5tEY = parcelRequire("t5tEY");
const $1b270298f114fca4$export$2e6ef246283472d6 = ({ value: value, tooltip: tooltip = (0, $aEDih.default).defaultCopyMessage, children: children })=>{
    const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
    const updateTooltip = (0, $5uXOq.useRef)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const content = (0, $5uXOq.useMemo)(()=>{
        return formatMessage(isCopied ? (0, $aEDih.default).copiedMessage : tooltip);
    }, [
        formatMessage,
        isCopied,
        tooltip
    ]);
    // recalculate tooltip position on content change
    // https://atlassian.design/components/tooltip/examples#updating-tooltip-position
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        content
    ]);
    const copy = (0, $5uXOq.useCallback)(async (event)=>{
        event.preventDefault();
        const clipboard = window.navigator.clipboard;
        await clipboard.writeText(value);
        setCopied(true);
    }, [
        value
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isCopied) {
            const timeout = setTimeout(()=>{
                setCopied(false);
            }, 5000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        isCopied
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $t5tEY.Container), {
        onClick: copy,
        className: "copy-to-clipboard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return content;
        }
    }, children({
        isCopied: isCopied
    }))));
};

});
parcelRegister("aEDih", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d74e4604924d103$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $0d74e4604924d103$var$messages = (0, $7VHMR.defineMessages)({
    defaultCopyMessage: {
        id: 'eoc.copy-to-clipboard.default.copy.no-translate',
        defaultMessage: 'Copy to clipboard',
        description: 'Text will be displayed as tooltip on the copy icon if none provided'
    },
    copiedMessage: {
        id: 'eoc.copy-to-clipboard.copied.no-translate',
        defaultMessage: 'Copied!',
        description: 'Text will be displayed as tooltip after copy is clicked'
    }
});
var $0d74e4604924d103$export$2e2bcd8739ae039 = $0d74e4604924d103$var$messages;

});

parcelRegister("t5tEY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $7a568a45a027d4c5$export$42a852a2b6b56249);

var $bWGt6 = parcelRequire("bWGt6");
function $7a568a45a027d4c5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a568a45a027d4c5$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ezdnbem0"
})({
    name: "e0dnmk",
    styles: "cursor:pointer"
});

});


parcelRegister("gILJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a17abc8711014b3e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lj8SI = parcelRequire("lj8SI");

var $kgoHi = parcelRequire("kgoHi");

var $jeNGJ = parcelRequire("jeNGJ");
function $a17abc8711014b3e$export$2e2bcd8739ae039({ priority: priority }) {
    const { label: label, ...lozengeProps } = (0, $jeNGJ.PRIORITIES)[priority];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), lozengeProps, priority));
}

});
parcelRegister("jeNGJ", function(module, exports) {

$parcel$export(module.exports, "PRIORITIES", () => $5bc4c76c82cbc0b9$export$19868e2467c966ad);
const $5bc4c76c82cbc0b9$export$19868e2467c966ad = {
    P1: {
        label: 'Critical',
        appearance: 'removed',
        isBold: true
    },
    P2: {
        label: 'High',
        appearance: 'removed',
        isBold: false
    },
    P3: {
        label: 'Moderate',
        appearance: 'moved',
        isBold: false
    },
    P4: {
        label: 'Low',
        appearance: 'success',
        isBold: false
    },
    P5: {
        label: 'Informational',
        appearance: 'success',
        isBold: true
    }
};

});


parcelRegister("diw6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8121f16d7c4329$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8icyj = parcelRequire("8icyj");
const $cf8121f16d7c4329$var$ResponderName = ({ responder: responder, fallback: fallback })=>{
    const name = (0, $5uXOq.useMemo)(()=>'name' in responder ? responder.name || responder.id : undefined, [
        responder
    ]);
    if (responder.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: 5
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, name || fallback || '');
};
var $cf8121f16d7c4329$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($cf8121f16d7c4329$var$ResponderName);

});
parcelRegister("8icyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c1f30f978a2dd2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $66W34 = parcelRequire("66W34");
const $35c1f30f978a2dd2$var$defaultDimensions = {
    line: [
        24,
        1.5
    ],
    circle: [
        3,
        3
    ],
    square: [
        3,
        3
    ]
};
const $35c1f30f978a2dd2$var$Skeleton = ({ width: width, height: height, variant: variant = 'line' })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $66W34.StyledWrapper), {
        variant: variant,
        dimensions: {
            width: width ?? $35c1f30f978a2dd2$var$defaultDimensions[variant][0],
            height: height ?? $35c1f30f978a2dd2$var$defaultDimensions[variant][1]
        },
        "data-testid": "eoc-skeleton"
    });
var $35c1f30f978a2dd2$export$2e2bcd8739ae039 = $35c1f30f978a2dd2$var$Skeleton;

});
parcelRegister("66W34", function(module, exports) {

$parcel$export(module.exports, "StyledWrapper", () => $9529eb8091350071$export$1f99da106a398c44);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
const $9529eb8091350071$var$colors = {
    base: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
    shimmer: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`
};
/**
 * @param val specifies the dimension value before conversion
 * @returns the CSS value for dimension
 */ const $9529eb8091350071$var$getDimensionValue = (val)=>{
    return typeof val === 'string' ? val : `${(0, $k5uoT.gridSize)() * val}px`;
};
const $9529eb8091350071$var$waveKeyframes = (0, $f8Sb3.keyframes)({
    '0%': {
        backgroundPosition: '-400px 0'
    },
    '100%': {
        backgroundPosition: '400px 0'
    }
});
const $9529eb8091350071$export$1f99da106a398c44 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1s9j7ip0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ dimensions: dimensions })=>{
    return {
        display: 'block',
        backgroundColor: $9529eb8091350071$var$colors.base,
        background: `linear-gradient(to right, ${$9529eb8091350071$var$colors.base} 10%, ${$9529eb8091350071$var$colors.shimmer} 25%, ${$9529eb8091350071$var$colors.base} 40%)`,
        backgroundSize: '800px 64px',
        width: $9529eb8091350071$var$getDimensionValue(dimensions.width),
        height: $9529eb8091350071$var$getDimensionValue(dimensions.height),
        animation: `${$9529eb8091350071$var$waveKeyframes} 1.25s linear infinite forwards`,
        borderRadius: '4px',
        flexShrink: 0
    };
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ variant: variant })=>{
    if (variant === 'line') return {
        flexShrink: 1
    };
    if (variant === 'circle') return {
        borderRadius: '100%'
    };
});

});



parcelRegister("ikN1y", function(module, exports) {

$parcel$export(module.exports, "DeleteModal", () => $ec981dec84e8e4e1$export$73392e09138fecd6);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $h8yj2 = parcelRequire("h8yj2");

var $jhsQL = parcelRequire("jhsQL");
const $ec981dec84e8e4e1$export$73392e09138fecd6 = ({ onDelete: onDelete, onDeleteAttemptCancel: onDeleteAttemptCancel, isDeleteDialogOpen: isDeleteDialogOpen, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isDeleteDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: onDeleteAttemptCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $jhsQL.messages).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $jhsQL.messages).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $jhsQL.messages).warning)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: (_, analyticsEvent)=>{
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'closeDeleteModalButton');
            return onDeleteAttemptCancel();
        },
        autoFocus: true
    }, formatMessage((0, $jhsQL.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        isLoading: isLoading,
        appearance: "warning",
        onClick: onDelete
    }, formatMessage((0, $jhsQL.messages).delete)))));
};

});
parcelRegister("jhsQL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0e7c0b624c3d3016$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0e7c0b624c3d3016$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.heartbeats.delete-modal.title.no-translate',
        defaultMessage: 'Delete heartbeat?',
        description: 'The text will be displayed in the delete modal title'
    },
    description: {
        id: 'eoc.heartbeats.delete-modal.description.no-translate',
        defaultMessage: "This will permanently delete the heartbeat, and we\u2019ll not send alerts when this heartbeat becomes unresponsive",
        description: 'The text will be displayed in the delete modal body description'
    },
    warning: {
        id: 'eoc.heartbeats.delete-modal.warning.no-translate',
        defaultMessage: "If you\u2019re not sure, you can turn off the heartbeat instead.",
        description: 'The text will be displayed in the delete modal body description for warning'
    },
    cancel: {
        id: 'eoc.heartbeats.delete-modal.cancel-button.no-translate',
        defaultMessage: 'Cancel',
        description: 'The text will be displayed in the delete modal footer for cancel button.'
    },
    delete: {
        id: 'eoc.heartbeats.extra-property.delete-modal.delete-button.no-translate',
        defaultMessage: 'Delete',
        description: 'The text will be displayed in the delete modal footer for delete button.'
    }
});

});


parcelRegister("aSfpo", function(module, exports) {

$parcel$export(module.exports, "HeartbeatStatus", () => $5377e69cf62615e9$export$53088ba4000d01c3);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $lytIi = parcelRequire("lytIi");
const $5377e69cf62615e9$export$53088ba4000d01c3 = ({ heartbeat: heartbeat, isTransitioning: isTransitioning })=>{
    const { status: status } = heartbeat;
    const showOptimalTooling = isTransitioning && (0, $VSDnB.getBooleanFF)('platform.show-optimal-tooling_brgom');
    switch(status){
        case 'Pending':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lytIi.PendingStatus), {
                showOptimalTooling: showOptimalTooling
            });
        case 'Responsive':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lytIi.ResponsiveStatus), {
                showOptimalTooling: showOptimalTooling
            });
        case 'Unresponsive':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lytIi.UnresponsiveStatus), {
                showOptimalTooling: showOptimalTooling
            });
        case 'Off':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lytIi.OffStatus), {
                showOptimalTooling: showOptimalTooling
            });
        default:
            return null;
    }
};

});
parcelRegister("lytIi", function(module, exports) {

$parcel$export(module.exports, "PendingStatus", () => $70eeae57bf0f5445$export$4160540944c60679);
$parcel$export(module.exports, "ResponsiveStatus", () => $70eeae57bf0f5445$export$324134c8f431d77f);
$parcel$export(module.exports, "UnresponsiveStatus", () => $70eeae57bf0f5445$export$368cc4effe701207);
$parcel$export(module.exports, "OffStatus", () => $70eeae57bf0f5445$export$641692f5d3d722d8);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lj8SI = parcelRequire("lj8SI");

var $3bDjY = parcelRequire("3bDjY");

var $eXrMc = parcelRequire("eXrMc");
const $70eeae57bf0f5445$export$4160540944c60679 = /*#__PURE__*/ (0, $5uXOq.memo)(({ showOptimalTooling: showOptimalTooling })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return showOptimalTooling ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $eXrMc.default).pendingTooltip),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "moved"
    }, formatMessage((0, $eXrMc.default).pending))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "moved"
    }, formatMessage((0, $eXrMc.default).pending));
});
const $70eeae57bf0f5445$export$324134c8f431d77f = /*#__PURE__*/ (0, $5uXOq.memo)(({ showOptimalTooling: showOptimalTooling })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return showOptimalTooling ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $eXrMc.default).responsiveTooltip),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "success"
    }, formatMessage((0, $eXrMc.default).responsive))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "success"
    }, formatMessage((0, $eXrMc.default).responsive));
});
const $70eeae57bf0f5445$export$368cc4effe701207 = /*#__PURE__*/ (0, $5uXOq.memo)(({ showOptimalTooling: showOptimalTooling })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return showOptimalTooling ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $eXrMc.default).unresponsiveTooltip),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "removed"
    }, formatMessage((0, $eXrMc.default).unresponsive))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: "removed"
    }, formatMessage((0, $eXrMc.default).unresponsive));
});
const $70eeae57bf0f5445$export$641692f5d3d722d8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ showOptimalTooling: showOptimalTooling })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return showOptimalTooling ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $eXrMc.default).offTooltip),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), null, formatMessage((0, $eXrMc.default).off))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), null, formatMessage((0, $eXrMc.default).off));
});

});
parcelRegister("eXrMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1acd486c95b8820b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $1acd486c95b8820b$var$messages = (0, $7VHMR.defineMessages)({
    pending: {
        id: 'eoc.heartbeats.status-lozenge.pending.no-translate',
        defaultMessage: 'Pending',
        description: 'Lozenge text to indicate pending status of a heartbeat.'
    },
    pendingTooltip: {
        id: 'eoc.heartbeats.status-lozenge.pending-tooltip.no-translate',
        defaultMessage: 'Heartbeat is awaiting a response.',
        description: 'Tooltip text for pending status of a heartbeat.'
    },
    responsive: {
        id: 'eoc.heartbeats.status-lozenge.responsive.no-translate',
        defaultMessage: 'Responsive',
        description: 'Lozenge text to indicate responsive status of a heartbeat.'
    },
    responsiveTooltip: {
        id: 'eoc.heartbeats.status-lozenge.responsive-tooltip.no-translate',
        defaultMessage: 'Heartbeat has received a ping within the interval',
        description: 'Tooltip text for responsive status of a heartbeat.'
    },
    unresponsive: {
        id: 'eoc.heartbeats.status-lozenge.unresponsive.no-translate',
        defaultMessage: 'Unresponsive',
        description: 'Lozenge text to indicate unresponsive status of a heartbeat.'
    },
    unresponsiveTooltip: {
        id: 'eoc.heartbeats.status-lozenge.unresponsive-tooltip.no-translate',
        defaultMessage: "Heartbeat didn\u2019t receive a ping within the interval",
        description: 'Tooltip text for unresponsive status of a heartbeat.'
    },
    off: {
        id: 'eoc.heartbeats.status-lozenge.off.no-translate',
        defaultMessage: 'Off',
        description: 'Lozenge text to indicate off status of a heartbeat.'
    },
    offTooltip: {
        id: 'eoc.heartbeats.status-lozenge.off-tooltip.no-translate',
        defaultMessage: 'Heartbeat is turned off',
        description: 'Tooltip text for off status of a heartbeat.'
    }
});
var $1acd486c95b8820b$export$2e2bcd8739ae039 = $1acd486c95b8820b$var$messages;

});



parcelRegister("34X01", function(module, exports) {

$parcel$export(module.exports, "SwitchModal", () => $549a3f7653d0e536$export$17cfb64e91e4f8bb);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eCeGD = parcelRequire("eCeGD");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $cgL5K = parcelRequire("cgL5K");

var $h8yj2 = parcelRequire("h8yj2");

var $xNdpE = parcelRequire("xNdpE");

var $4NGvo = parcelRequire("4NGvo");
const $549a3f7653d0e536$export$17cfb64e91e4f8bb = ({ onSwitch: onSwitch, onSwitchAttemptCancel: onSwitchAttemptCancel, isSwitchDialogOpen: isSwitchDialogOpen, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isSwitchDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        onClose: onSwitchAttemptCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "warning"
    }, formatMessage((0, $4NGvo.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $4NGvo.default).description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: (_, analyticsEvent)=>{
            (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'closeSwitchModalButton');
            return onSwitchAttemptCancel();
        },
        autoFocus: true
    }, formatMessage((0, $xNdpE.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        isLoading: isLoading,
        appearance: "warning",
        onClick: onSwitch
    }, formatMessage((0, $4NGvo.default).turnOff)))));
};

});
parcelRegister("4NGvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0d09dc7635e6359$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a0d09dc7635e6359$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.heartbeats.switch-modal.title.no-translate',
        defaultMessage: 'Turn off heartbeat?',
        description: 'The text will be displayed in the switch modal title'
    },
    description: {
        id: 'eoc.heartbeats.switch-modal.description.no-translate',
        defaultMessage: "We\u2019ll stop monitoring the connectivity of your system and won\u2019t send an alert for this heartbeat. You can turn it back on when required.",
        description: 'The text will be displayed in the switch modal body description'
    },
    turnOff: {
        id: 'eoc.heartbeats.extra-property.switch-modal.switch-button.no-translate',
        defaultMessage: 'Turn off',
        description: 'The text will be displayed in the switch modal footer for turn-off button.'
    }
});
var $a0d09dc7635e6359$export$2e2bcd8739ae039 = $a0d09dc7635e6359$var$messages;

});


parcelRegister("jrQLn", function(module, exports) {

$parcel$export(module.exports, "useDeleteModalController", () => $5a6ca61cb62e10c6$export$82353b85e9dc976);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $hem2I = parcelRequire("hem2I");

var $jjjoR = parcelRequire("jjjoR");

var $90XDC = parcelRequire("90XDC");
const $5a6ca61cb62e10c6$export$82353b85e9dc976 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { isDeleting: isDeleting, deleteHeartbeat: deleteHeartbeat } = (0, $jjjoR.useHeartbeatsService)();
    const { update: update } = (0, $hem2I.default)((0, $90XDC.heartbeatsResource));
    const [deletingItem, setDeletingItem] = (0, $5uXOq.useState)();
    const [isDeleteModalOpen, setDeleteModalOpen] = (0, $5uXOq.useState)(false);
    const handleDeleteClick = (0, $5uXOq.useCallback)((heartbeat)=>{
        const event = createAnalyticsEvent({});
        (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'deleteButton');
        setDeletingItem(heartbeat);
        setDeleteModalOpen(true);
    }, [
        createAnalyticsEvent
    ]);
    const handleModalClose = (0, $5uXOq.useCallback)(()=>{
        setDeleteModalOpen(false);
        setDeletingItem(undefined);
    }, []);
    const handleDelete = (0, $5uXOq.useCallback)(()=>{
        (0, $hmVmJ.assert)(!!deletingItem, new (0, $dH6Pi.AssertionError)('useDeleteModalController', 'deleting item should not be undefined!'));
        return deleteHeartbeat(deletingItem.name).then(()=>{
            update((data)=>{
                (0, $hmVmJ.assert)(!!data, new (0, $dH6Pi.AssertionError)('useDeleteModalController', "heartbeat's resource data should no be undefined!"));
                return {
                    ...data,
                    heartbeats: data.heartbeats.filter(({ name: name })=>name !== deletingItem.name)
                };
            });
            handleModalClose();
        }).then(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'heartbeatDelete succeeded');
        }).catch(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'heartbeatDelete failed');
        });
    }, [
        createAnalyticsEvent,
        deleteHeartbeat,
        deletingItem,
        handleModalClose,
        update
    ]);
    return {
        deletingItem: deletingItem,
        isDeleteModalOpen: isDeleteModalOpen,
        handleDeleteClick: handleDeleteClick,
        handleModalClose: handleModalClose,
        isDeleting: isDeleting,
        handleDelete: handleDelete
    };
};

});
parcelRegister("jjjoR", function(module, exports) {

$parcel$export(module.exports, "useHeartbeatsService", () => $ad81071a2a0f52af$export$a5b14fa46f51bf03);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bmKPg = parcelRequire("bmKPg");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $xNdpE = parcelRequire("xNdpE");

var $6dFjI = parcelRequire("6dFjI");

var $kckOM = parcelRequire("kckOM");
const $ad81071a2a0f52af$export$a5b14fa46f51bf03 = ()=>{
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const [validateLoading, setValidateLoading] = (0, $5uXOq.useState)(false);
    const [isSwitchLoading, setSwitchLoading] = (0, $5uXOq.useState)(false);
    const [isDeleting, setDeleting] = (0, $5uXOq.useState)(false);
    const flagApi = (0, $2tKfK.default)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    const validateName = (heartbeatName)=>{
        setValidateLoading(true);
        return (0, $6dFjI.validateHeartbeatNameEndpoint)(heartbeatName, teamId).catch(defaultCatch({
            id: 'useHeartbeatsService-validateHeartbeatName',
            httpErrorHandler: (err)=>{
                if (err.response?.status > 499) flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    description: err.message,
                    title: formatMessage((0, $xNdpE.default).errorTitle)
                });
                throw err;
            }
        })).finally(()=>{
            setValidateLoading(false);
        });
    };
    const create = (data)=>{
        return (0, $6dFjI.createHeartbeatEndpoint)(data, teamId).catch(defaultCatch({
            id: 'useHeartbeatsService-createHeartbeat',
            httpErrorHandler: (err)=>{
                flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    description: err.message,
                    title: formatMessage((0, $kckOM.default).createErrorTitle)
                });
                throw err;
            }
        }));
    };
    const edit = (data)=>{
        return (0, $6dFjI.updateHeartbeatEndpoint)(data, teamId).then((res)=>res).catch(defaultCatch({
            id: 'useHeartbeatsService-updateHeartbeat',
            httpErrorHandler: (err)=>{
                flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    description: err.message,
                    title: formatMessage((0, $kckOM.default).editErrorTitle)
                });
                throw err;
            }
        }));
    };
    const switchHeartbeat = (enable, name)=>{
        setSwitchLoading(true);
        return (0, $6dFjI.switchHeartbeatEndpoint)(enable, name, teamId).then((res)=>{
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: formatMessage((0, $kckOM.default).switchSuccessTitle, {
                    enable: enable
                })
            });
            return res;
        }).catch(defaultCatch({
            id: 'useHeartbeatsService-switchHeartbeat',
            httpErrorHandler: (err)=>{
                flagApi.showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    description: err.message,
                    title: formatMessage((0, $kckOM.default).switchErrorTitle, {
                        enable: enable
                    })
                });
                throw err;
            }
        })).finally(()=>{
            setSwitchLoading(false);
        });
    };
    const deleteHeartbeat = (0, $5uXOq.useCallback)((name)=>{
        setDeleting(true);
        return (0, $6dFjI.deleteHeartbeatEndpoint)(name, teamId).then(()=>{
            flagApi.showFlag({
                ...(0, $8eCQi.infoToastProps)(),
                description: formatMessage((0, $kckOM.default).deleteSuccessDescription),
                title: formatMessage((0, $kckOM.default).deleteSuccessTitle, {
                    heartbeatName: name
                })
            });
        }).catch((e)=>{
            defaultCatch({
                id: 'deleteHeartbeatAction',
                httpErrorHandler: (error)=>{
                    flagApi.showFlag({
                        ...(0, $8eCQi.errorToastProps)(),
                        description: error.message,
                        title: formatMessage((0, $kckOM.default).deleteErrorTitle)
                    });
                }
            }, e);
            throw e;
        }).finally(()=>{
            setDeleting(false);
        });
    }, [
        defaultCatch,
        flagApi,
        formatMessage,
        teamId
    ]);
    return {
        isDeleting: isDeleting,
        validateLoading: validateLoading,
        isSwitchLoading: isSwitchLoading,
        validateName: validateName,
        create: create,
        edit: edit,
        switchHeartbeat: switchHeartbeat,
        deleteHeartbeat: deleteHeartbeat
    };
};

});
parcelRegister("kckOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e2f44ed1e651bea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $5e2f44ed1e651bea$var$messages = (0, $7VHMR.defineMessages)({
    createErrorTitle: {
        id: 'eoc-heartbeats.services.store.create-heartbeat-error-title',
        defaultMessage: "We couldn\u2019t create the heartbeat",
        description: `This message will be shown when the request for creating the heartbeat fails and it will be shown
    on the error flag title`
    },
    editErrorTitle: {
        id: 'eoc-heartbeats.services.store.edit-heartbeat-error-title',
        defaultMessage: "We couldn\u2019t edit the heartbeat",
        description: `This message will be shown when the request for editing the heartbeat fails and it will be shown
    on the error flag title`
    },
    deleteErrorTitle: {
        id: 'eoc-heartbeats.services.store.delete-heartbeat-error-title',
        defaultMessage: "We couldn\u2019t delete the heartbeat",
        description: `This message will be shown when the request for deleting the heartbeat fails and it will be shown
    on the error flag title`
    },
    deleteSuccessTitle: {
        id: 'eoc-heartbeats.services.store.delete-heartbeat-success-title',
        defaultMessage: 'Heartbeat {heartbeatName} is deleted',
        description: `This message will be shown when the request for deleting the heartbeat succeeded and it will be shown
    on the success flag title`
    },
    deleteSuccessDescription: {
        id: 'eoc-heartbeats.services.store.delete-heartbeat-success-description',
        defaultMessage: "We'll no longer monitor the sender system and send alerts for this",
        description: `This message will be shown when the request for deleting the heartbeat succeeded and it will be shown
    on the success flag description`
    },
    switchSuccessTitle: {
        id: 'eoc-heartbeats.services.store.switch-heartbeat-success-title',
        defaultMessage: 'Heartbeat {enable, select, true {turned on} other {turned off}} successfully.',
        description: `This message will be shown when the request for turning the heartbeat on/off succeeded and it will be shown
    on the success flag title`
    },
    switchErrorTitle: {
        id: 'eoc-heartbeats.services.store.switch-heartbeat-error-title',
        defaultMessage: "We couldn't {enable, select, true {turn on} other {turn off}} the heartbeat.",
        description: `This message will be shown when the request for turn on/off the heartbeat fails and it will be shown
    on the error flag title`
    }
});
var $5e2f44ed1e651bea$export$2e2bcd8739ae039 = $5e2f44ed1e651bea$var$messages;

});



parcelRegister("7mCor", function(module, exports) {

$parcel$export(module.exports, "useSwitchController", () => $69de32161ff94ca6$export$896c190f8960fa94);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $hem2I = parcelRequire("hem2I");

var $jjjoR = parcelRequire("jjjoR");

var $90XDC = parcelRequire("90XDC");
const $69de32161ff94ca6$export$896c190f8960fa94 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: heartbeatsData, update: update } = (0, $hem2I.default)((0, $90XDC.heartbeatsResource));
    const { isSwitchLoading: isSwitchLoading, switchHeartbeat: switchHeartbeat } = (0, $jjjoR.useHeartbeatsService)();
    const [switchingItem, setSwitchingItem] = (0, $5uXOq.useState)();
    const [isSwitchModalOpen, setSwitchModalOpen] = (0, $5uXOq.useState)(false);
    const handleModalClose = (0, $5uXOq.useCallback)(()=>{
        setSwitchModalOpen(false);
        setSwitchingItem(undefined);
    }, []);
    (0, $hmVmJ.assert)(!!heartbeatsData, new (0, $dH6Pi.AssertionError)('useSwitchController', 'heartbeats data should not be undefined!'));
    const handleSwitch = (0, $5uXOq.useCallback)((heartbeat)=>{
        (0, $hmVmJ.assert)(!!(switchingItem || heartbeat), new (0, $dH6Pi.AssertionError)('useSwitchController', 'switching item should not be undefined!'));
        const enable = switchingItem?.status === 'Off' || heartbeat.status === 'Off';
        return switchHeartbeat(enable, switchingItem?.name || heartbeat.name).then((res)=>{
            const newData = {
                ...heartbeatsData
            };
            newData.heartbeats.find((heartbeat, index)=>{
                if (heartbeat.name === res?.name) newData.heartbeats[index] = res;
            });
            update(()=>newData);
            handleModalClose();
        }).then(()=>{
            const event = createAnalyticsEvent({});
            if (enable) (0, $h8yj2.fireTrackAnalytics)(event, 'heartbeatTurnedOn succeeded');
            else (0, $h8yj2.fireTrackAnalytics)(event, 'heartbeatTurnedOff succeeded');
        }).catch(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'heartbeatSwitch failed');
        });
    }, [
        switchingItem,
        switchHeartbeat,
        heartbeatsData,
        update,
        handleModalClose,
        createAnalyticsEvent
    ]);
    const handleSwitchClick = (0, $5uXOq.useCallback)((heartbeat)=>{
        if (heartbeat.status === 'Off') handleSwitch(heartbeat);
        else {
            setSwitchingItem(heartbeat);
            setSwitchModalOpen(true);
        }
    }, [
        handleSwitch
    ]);
    return {
        switchingItem: switchingItem,
        isSwitchModalOpen: isSwitchModalOpen,
        isSwitchLoading: isSwitchLoading,
        handleSwitchClick: handleSwitchClick,
        handleModalClose: handleModalClose,
        handleSwitch: handleSwitch
    };
};

});

parcelRegister("5g2ZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf10d0ed56243da$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $cbf10d0ed56243da$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.heartbeats.detail.title.no-translate',
        defaultMessage: 'Heartbeat settings',
        description: 'Title of heartbeat detail focus state'
    },
    settingsDescription: {
        id: 'eoc.heartbeats.detail.description.no-translate',
        defaultMessage: 'Continuously check the connectivity of your systems by using the <linkRestApi>Rest API</linkRestApi> or sending an email. <linkLearnMore>Learn more</linkLearnMore>.',
        description: 'Title of heartbeat detail focus state'
    },
    turOnButton: {
        id: 'eoc.heartbeats.detail.turnOn-button.no-translate',
        defaultMessage: 'Turn on heartbeat',
        description: 'Primary action button which will enable heartbeat.'
    },
    turOffButton: {
        id: 'eoc.heartbeats.detail.turnOff-button.no-translate',
        defaultMessage: 'Turn off heartbeat',
        description: 'Primary action button which will disable heartbeat.'
    },
    close: {
        id: 'eoc.heartbeats.detail.close-button.no-translate',
        defaultMessage: 'Close',
        description: 'Close button.'
    },
    edit: {
        id: 'eoc.heartbeats.detail.edit-button.no-translate',
        defaultMessage: 'Edit',
        description: 'Edit button.'
    },
    delete: {
        id: 'eoc.heartbeats.detail.delete-button.no-translate',
        defaultMessage: 'Delete',
        description: 'Delete button.'
    },
    name: {
        id: 'eoc.heartbeats.detail.name-label.no-translate',
        defaultMessage: 'Name',
        description: 'Name label will indicate the heartbeat name.'
    },
    description: {
        id: 'eoc.heartbeats.detail.description-label.no-translate',
        defaultMessage: 'Description',
        description: 'Description label will indicate the heartbeat description.'
    },
    assignedTeam: {
        id: 'eoc.heartbeats.detail.assigned-team-label.no-translate',
        defaultMessage: 'Assigned team',
        description: 'Assigned team label will indicate the which team the heartbeat belongs.'
    },
    lastPinged: {
        id: 'eoc.heartbeats.detail.last-pinged-label.no-translate',
        defaultMessage: 'Last pinged',
        description: 'Last pinged label will indicate the last time heartbeat is pinged.'
    },
    nextPing: {
        id: 'eoc.heartbeats.detail.next-ping-label.no-translate',
        defaultMessage: 'Next ping',
        description: 'Next ping label will indicate the closest time the heartbeat will be pinged.'
    },
    pingInterval: {
        id: 'eoc.heartbeats.detail.ping-interval-label.no-translate',
        defaultMessage: 'Ping interval',
        description: 'Ping interval label will indicate the interval of the heartbeat is pinged.'
    },
    status: {
        id: 'eoc.heartbeats.detail.status-label.no-translate',
        defaultMessage: 'Status',
        description: 'Status label will indicate the heartbeat status.'
    },
    alertMessage: {
        id: 'eoc.heartbeats.detail.alert-message-label.no-translate',
        defaultMessage: 'Alert message',
        description: 'Alert message label will indicate the priority and message of the alert.'
    },
    alertTags: {
        id: 'eoc.heartbeats.detail.alert-tags-label.no-translate',
        defaultMessage: 'Alert tags',
        description: 'Alert tags label will indicate the tags of alert.'
    },
    instructions: {
        id: 'eoc.heartbeats.detail.instructions.no-translate',
        defaultMessage: 'Instructions',
        description: 'Text will be displayed at the top of the instruction panel to understand user how to use heartbeat'
    },
    apiInstruction: {
        id: 'eoc.heartbeats.detail.api-instruction.no-translate',
        defaultMessage: 'Follow the steps below to send pings to this heartbeat with the Heartbeats API.',
        description: 'Text will give info to user about API heartbeat instructions'
    },
    apiInstructionFirstBullet: {
        id: 'eoc.heartbeats.detail.api-instruction.second-bullet.no-translate',
        defaultMessage: ' from Atlassian Account to authenticate your sender system',
        description: 'Api heartbeat second instruction'
    },
    apiInstructionSecondBullet: {
        id: 'eoc.heartbeats.detail.api-instruction.first-bullet.no-translate',
        defaultMessage: 'Add the relevant information as explained in the <linkApiDocumentation>API documentation</linkApiDocumentation> and make a GET request to the following URL:',
        description: 'Api heartbeat first instruction'
    },
    apiInstructionSecondBulletCreateToken: {
        id: 'eoc.heartbeats.detail.api-instruction.second-bullet.create-token.no-translate',
        defaultMessage: 'Create an API token',
        description: 'Link will redirect user to API token creation page'
    },
    apiInstructionThirdBullet: {
        id: 'eoc.heartbeats.detail.api-instruction.third-bullet.no-translate',
        defaultMessage: 'Use this token and the heartbeat details to complete the information in the GET request.',
        description: 'Api heartbeat third instruction'
    },
    apiInstructionFourthBullet: {
        id: 'eoc.heartbeats.detail.api-instruction.fourth-bullet.no-translate',
        defaultMessage: 'Send pings before the ping interval exceeds the limit to prevent the heartbeat from becoming unresponsive.',
        description: 'Api heartbeat fourth instruction'
    },
    copy: {
        id: 'eoc.heartbeats.detail.copy.no-translate',
        defaultMessage: 'Learn more about creating a heartbeat with an API token',
        description: 'Learn more link about API instructions'
    },
    apiTabTitle: {
        id: 'eoc.heartbeats.detail.api-tab-title.no-translate',
        defaultMessage: 'Heartbeats API',
        description: 'Title of the first tab which holds the instruction about API heartbeat'
    },
    emailTabTitle: {
        id: 'eoc.heartbeats.detail.email-tab-title.no-translate',
        defaultMessage: 'Built-in Email',
        description: 'Title of the second tab which holds the instruction about Built-in email heartbeat'
    },
    emailInstruction: {
        id: 'eoc.heartbeats.detail.email-instruction.no-translate',
        defaultMessage: 'Follow the steps below to send pings to this heartbeat by an email.',
        description: 'Title of the second tab which holds the instruction about Built-in email heartbeat'
    },
    emailInstructionFirstBullet: {
        id: 'eoc.heartbeats.detail.email-instruction.first-bullet.no-translate',
        defaultMessage: 'Keep the heartbeat responsive by sending an email to the following email address:',
        description: 'Email heartbeat first instruction'
    },
    emailInstructionSecondBullet: {
        id: 'eoc.heartbeats.detail.email-instruction.first-bullet.no-translate',
        defaultMessage: 'Send pings before the ping interval exceeds the limit to prevent the heartbeat from becoming unresponsive.',
        description: 'Email heartbeat first instruction'
    },
    emailInstructionLearnMore: {
        id: 'eoc.heartbeats.detail.email-instruction.learn-more.no-translate',
        defaultMessage: 'Read more about creating a heartbeat with a built-in email',
        description: 'Learn more link about Email instructions'
    },
    emailCustomerName: {
        id: 'eoc.heartbeats.detail.email-instruction.customer-name.no-translate',
        defaultMessage: 'customer-name',
        description: 'Email heartbeat customer name'
    },
    transitioningTitle: {
        id: 'eoc.heartbeats.detail.email-instruction.transitioning-title.no-translate',
        defaultMessage: 'Opsgenie heartbeats are now in Jira Service Management',
        description: 'Title of the section message for transitioning customers'
    },
    transitioningMessage: {
        id: 'eoc.heartbeats.detail.email-instruction.transitioning-message.no-translate',
        defaultMessage: "We\u2019ve automatically switched any Opsgenie heartbeat email domains to jsmheartbeats.atlassian.net. Your heartbeats will continue to be operational. If you\u2019ve been using any scripts with the Opsgenie heartbeat email, please update your scripts with the new domain.",
        description: 'Content of the section message for transitioning customers'
    }
});
var $cbf10d0ed56243da$export$2e2bcd8739ae039 = $cbf10d0ed56243da$var$messages;

});

parcelRegister("5J8sV", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $9b1436ca8c3f96e6$export$2e0a83ec2e27ecbb);
$parcel$export(module.exports, "StyledCode", () => $9b1436ca8c3f96e6$export$a44a6f4ac586d259);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $O2UjQ = parcelRequire("O2UjQ");


var $bWGt6 = parcelRequire("bWGt6");
function $9b1436ca8c3f96e6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9b1436ca8c3f96e6$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $bWGt6.default)("hr", {
    target: "ebx9s8n1"
})({
    marginTop: "var(--ds-space-400, 32px)",
    marginBottom: "var(--ds-space-400, 32px)",
    marginLeft: 0,
    marginRight: 0,
    border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`
});
const $9b1436ca8c3f96e6$export$a44a6f4ac586d259 = /*#__PURE__*/ (0, $bWGt6.default)((0, $O2UjQ.default), {
    target: "ebx9s8n0"
})({
    name: "1tjylrs",
    styles: "width:fit-content"
});

});
parcelRegister("O2UjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c9c981a54265bdd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");

var $lBXbx = parcelRequire("lBXbx");

var $1HkQx = parcelRequire("1HkQx");
const $4c9c981a54265bdd$var$styles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline',
    padding: '2px 0.5ch',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $lBXbx.VAR_CODE_BG_COLOR)}, ${"var(--ds-background-neutral, #091E420F)"})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderStyle: 'none',
    boxDecorationBreak: 'clone',
    color: "var(--ds-text, #172B4D)",
    font: "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'inherit',
    overflow: 'auto',
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap'
});
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $4c9c981a54265bdd$var$Code = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $f8Sb3.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    }, children) : children;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        css: $4c9c981a54265bdd$var$styles,
        ...otherProps
    }, decoratedChildren));
}));
function $4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $31cgS.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        if ($4c9c981a54265bdd$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $f8Sb3.jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, replacedChildren);
}
function $4c9c981a54265bdd$var$isReactElement(child) {
    return !!child.type;
}
$4c9c981a54265bdd$var$Code.displayName = 'Code';
var $4c9c981a54265bdd$export$2e2bcd8739ae039 = $4c9c981a54265bdd$var$Code;

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $59fdc1b7b0ae96c9$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", null, bidiCharacterCode)));
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("lBXbx", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $6ec31795911692d1$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $6ec31795911692d1$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $6ec31795911692d1$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $6ec31795911692d1$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $6ec31795911692d1$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $6ec31795911692d1$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $6ec31795911692d1$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
const $6ec31795911692d1$export$82ea42e772d49e5b = (0, $k5uoT.gridSize)();
const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("1HkQx", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $a9c1aabaca189fa1$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $a9c1aabaca189fa1$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lBXbx = parcelRequire("lBXbx");

var $8CJbG = parcelRequire("8CJbG");
const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $lBXbx.SPACING}px !important`,
        paddingLeft: (0, $lBXbx.SPACING),
        marginRight: (0, $lBXbx.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: "var(--ds-font-weight-bold, 700)"
            }
        }
    });
const $a9c1aabaca189fa1$export$ee58a26b5d612ac1 = (theme)=>({
        fontSize: (0, $lBXbx.CODE_FONT_SIZE),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: theme.fontFamily,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(${0, $lBXbx.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $lBXbx.SPACING}px 0` : (0, $lBXbx.SPACING),
                tabSize: 4
            },
            display: 'flex',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $lBXbx.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme),
            ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                marginRight: `-${0, $lBXbx.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $lBXbx.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $lBXbx.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $8CJbG.getBaseTheme)();
    const baseStyles = $a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $8CJbG.getBaseTheme)(),
        ...(0, $8CJbG.getColorPalette)(),
        lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("8CJbG", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $eac5fe855702cfc1$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $eac5fe855702cfc1$export$fe2a6478976e8b17);

var $8QpSo = parcelRequire("8QpSo");


var $kTHGn = parcelRequire("kTHGn");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $eac5fe855702cfc1$var$T800 = '#067384';
const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $kTHGn.default)('font.family.code')}`,
        backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
    });
const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, $8QpSo.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
    };
});
const $eac5fe855702cfc1$var$getTheme = ()=>({
        ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
        ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
    });
var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;

});





parcelRegister("bxZSn", function(module, exports) {

$parcel$export(module.exports, "Form", () => $2d85d9efb1ef4dec$export$a7fed597f4b8afd8);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ldJSL = parcelRequire("ldJSL");

var $eCeGD = parcelRequire("eCeGD");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $c8Oei = parcelRequire("c8Oei");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");
var $b9dFI = parcelRequire("b9dFI");

var $kY99m = parcelRequire("kY99m");

var $h8yj2 = parcelRequire("h8yj2");

var $jDgon = parcelRequire("jDgon");
var $gcpT9 = parcelRequire("gcpT9");
var $iMJ36 = parcelRequire("iMJ36");
var $8jRgk = parcelRequire("8jRgk");

var $gILJi = parcelRequire("gILJi");
var $jeNGJ = parcelRequire("jeNGJ");

var $awLan = parcelRequire("awLan");

var $xNdpE = parcelRequire("xNdpE");

var $69P3Z = parcelRequire("69P3Z");

var $eBqFt = parcelRequire("eBqFt");

var $81ruP = parcelRequire("81ruP");

var $a0WdN = parcelRequire("a0WdN");

var $6TrP1 = parcelRequire("6TrP1");

var $dq1En = parcelRequire("dq1En");
const $2d85d9efb1ef4dec$var$AlertPropertiesHeaderContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.400'
});
const $2d85d9efb1ef4dec$var$ExpectFieldSelectStyles = (0, $8CUq3.xcss)({
    width: '120px'
});
const $2d85d9efb1ef4dec$var$StringDescriptionStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.300',
    color: 'color.text.subtle'
});
const $2d85d9efb1ef4dec$export$a7fed597f4b8afd8 = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { focusState: focusState } = (0, $eBqFt.useHeartbeatsContext)();
    const { handleSubmit: handleSubmit } = (0, $69P3Z.useFormController)();
    const initialValueAlertMessage = (0, $5uXOq.useMemo)(()=>({
            alertPriority: data?.alertPriority || 'P3',
            alertMessage: data?.alertMessage
        }), [
        data?.alertMessage,
        data?.alertPriority
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcpT9.EocForm), {
        subscription: {
            submitting: true
        },
        onSubmit: handleSubmit
    }, ({ submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "large"
        }, focusState.mode === 'edit' ? formatMessage((0, $a0WdN.default).editFormHeader) : formatMessage((0, $a0WdN.default).createFormHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6TrP1.NameInput), {
            initialValue: data?.name || ''
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "description",
            label: formatMessage((0, $a0WdN.default).descriptionLabel),
            initialValue: data?.description
        }, ({ input: input })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                autoComplete: "off",
                placeholder: formatMessage((0, $a0WdN.default).descriptionPlaceholder),
                ...input
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $81ruP.AssignedTeamInput), {
            ownerTeamId: data?.ownerTeamId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            "aria-required": true,
            name: "expect",
            label: formatMessage((0, $a0WdN.default).expectLabel),
            isRequired: true,
            initialValue: {
                interval: data?.interval !== undefined ? data.interval.toString() : '',
                unit: data?.intervalUnit ? {
                    label: data.intervalUnit,
                    value: data.intervalUnit
                } : undefined
            },
            validate: (value)=>{
                if (value.interval === '0') return formatMessage((0, $a0WdN.default).invalidExpectErrorText);
                if (!value.interval) return formatMessage((0, $a0WdN.default).expectIntervalErrorText);
                if (!value.unit) return formatMessage((0, $a0WdN.default).expectUnitErrorText);
                if (value.interval && value.unit) {
                    // 5 years === 1826 days
                    const limit = (0, $awLan.MAX_INTERVAL_TIME_YEARS) * 365 + 1;
                    const minuteLimit = limit * 1440;
                    const dayLimit = limit * 24;
                    const unit = value.unit.value;
                    const interval = parseInt(value.interval, 10);
                    if (unit === 'minutes' && interval > minuteLimit) return formatMessage((0, $a0WdN.default).invalidInterval, {
                        max: minuteLimit,
                        unit: unit
                    });
                    if (unit === 'hours' && interval > dayLimit) return formatMessage((0, $a0WdN.default).invalidInterval, {
                        max: dayLimit,
                        unit: unit
                    });
                    if (unit === 'days' && interval > limit) return formatMessage((0, $a0WdN.default).invalidInterval, {
                        max: limit,
                        unit: unit
                    });
                }
            }
        }, ({ input: input, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                space: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...input,
                placeholder: "1",
                value: input.value.interval,
                autoComplete: "off",
                width: 120,
                onChange: (e)=>{
                    const value = e.currentTarget.value;
                    if (!(0, $dq1En.isNumeric)(value)) return;
                    input.onChange({
                        ...input.value,
                        interval: value
                    });
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $2d85d9efb1ef4dec$var$ExpectFieldSelectStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                ...input,
                value: input.value.unit,
                options: (0, $dq1En.getIntervalUnitOptions)(),
                onChange: (value)=>{
                    input.onChange({
                        ...input.value,
                        unit: value
                    });
                }
            }))), meta.touched && meta.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJ36.ErrorMessage), null, meta.error))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $2d85d9efb1ef4dec$var$AlertPropertiesHeaderContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "medium"
        }, formatMessage((0, $a0WdN.default).alertPropertiesTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "p",
            xcss: $2d85d9efb1ef4dec$var$StringDescriptionStyles
        }, formatMessage((0, $a0WdN.default).alertPropertiesDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            "aria-required": true,
            name: "alertMessage",
            label: formatMessage((0, $a0WdN.default).alertMessageLabel),
            isRequired: true,
            initialValue: initialValueAlertMessage,
            validate: (value)=>{
                if (!value?.alertMessage) return 'error';
            }
        }, ({ input: input, meta: meta })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...input,
                value: input.value.alertMessage,
                elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
                    searchThreshold: undefined,
                    options: Object.entries((0, $jeNGJ.PRIORITIES)).map(([key, value])=>{
                        return {
                            value: key,
                            label: value.label
                        };
                    }),
                    formatOptionLabel: (option)=>{
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                            alignBlock: "center",
                            space: "space.100"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gILJi.default), {
                            priority: option.value
                        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, option.label));
                    },
                    target: ({ isOpen: isOpen, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                            ...triggerProps,
                            appearance: "subtle",
                            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gILJi.default), {
                                priority: input.value.alertPriority
                            }),
                            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                                color: "currentColor",
                                label: formatMessage((0, $xNdpE.default).chevronDownIconLabel)
                            })
                        }),
                    onChange: (selection)=>{
                        input.onChange({
                            ...input.value,
                            alertPriority: selection?.value
                        });
                        input.onBlur();
                    }
                }),
                onChange: (e)=>{
                    input.onChange({
                        ...input.value,
                        alertMessage: e.currentTarget.value
                    });
                    input.onBlur();
                }
            }), meta.touched && meta.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJ36.ErrorMessage), null, formatMessage((0, $a0WdN.default).alertMessageErrorText)));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
            name: "tags",
            label: formatMessage((0, $a0WdN.default).tagsLabel),
            initialValue: data?.alertTags ? data.alertTags.map((tag)=>({
                    label: tag,
                    value: tag
                })) : []
        }, ({ input: input })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iOwNT.default), {
                ...input,
                placeholder: formatMessage((0, $a0WdN.default).tagsPlaceholder),
                isClearable: true,
                isMulti: true,
                noOptionsMessage: ()=>null,
                components: {
                    DropdownIndicator: ()=>null
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8jRgk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "subtle",
            onClick: (_, analyticsEvent)=>{
                (0, $h8yj2.fireUIAnalytics)(analyticsEvent, 'closeHeartbeatFormButton');
                focusState.close();
            }
        }, formatMessage((0, $xNdpE.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            type: "submit",
            appearance: "primary",
            isLoading: submitting
        }, focusState.mode === 'edit' ? formatMessage((0, $a0WdN.default).editHeartbeat) : formatMessage((0, $a0WdN.default).createHeartbeat))))));
};

});
parcelRegister("jDgon", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $65f495d59743786f$export$3c4232819458a302);
$parcel$export(module.exports, "EocField", () => $65f495d59743786f$export$35d248c78341e61);

var $5uXOq = parcelRequire("5uXOq");

var $31kPh = parcelRequire("31kPh");

var $8e3lA = parcelRequire("8e3lA");

var $2x3Cb = parcelRequire("2x3Cb");

var $f5TWP = parcelRequire("f5TWP");

var $8xY2r = parcelRequire("8xY2r");

var $5kG7a = parcelRequire("5kG7a");

var $1XCut = parcelRequire("1XCut");
const $65f495d59743786f$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $65f495d59743786f$export$35d248c78341e61 = ({ id: id, children: children, hint: hint, isRequired: isRequired, label: label, name: name, helperMessageComponent: helperMessageComponent, ...restFieldProps })=>{
    const fieldId = (0, $5uXOq.useMemo)(()=>id ? id : `${name}-${(0, $8e3lA.uid)({
            id: name
        })}`, [
        id,
        name
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31kPh.Field), {
        name: name,
        ...restFieldProps
    }, (fieldRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1XCut.Container), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "baseline"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
            id: `${fieldId}-label`,
            htmlFor: fieldId
        }, label, isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1XCut.Required), null)), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5kG7a.HintPopup), {
            hint: hint,
            label: label
        }), helperMessageComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65f495d59743786f$export$3c4232819458a302.Provider, {
            value: fieldId
        }, (0, $8xY2r.default)(children, {
            input: {
                id: fieldId,
                isInvalid: fieldRenderProps.meta.touched && !fieldRenderProps.meta.valid,
                'aria-invalid': !!fieldRenderProps.meta.error ? true : undefined,
                'aria-labelledby': `${fieldId}-label`,
                'aria-describedby': `${fieldId}-helper ${fieldId}-valid ${fieldId}-error`,
                'aria-required': isRequired,
                ...fieldRenderProps.input
            },
            meta: fieldRenderProps.meta
        }))));
};

});
parcelRegister("31kPh", function(module, exports) {

$parcel$export(module.exports, "Form", () => $23319eb72bd68064$export$a7fed597f4b8afd8);
$parcel$export(module.exports, "useForm", () => $23319eb72bd68064$export$87c0cf8eb5a167e0);
$parcel$export(module.exports, "useFormState", () => $23319eb72bd68064$export$606f11b2eb45ecc6);
$parcel$export(module.exports, "FormSpy", () => $23319eb72bd68064$export$d2e89184086487cb);
$parcel$export(module.exports, "useField", () => $23319eb72bd68064$export$294aa081a6c6f55d);
$parcel$export(module.exports, "Field", () => $23319eb72bd68064$export$a455218a85c89869);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");
var $23319eb72bd68064$var$_excluded$3 = [
    "render",
    "children",
    "component"
];
// shared logic between components that use either render prop,
// children render function, or component prop
function $23319eb72bd68064$var$renderComponent(props, lazyProps, name) {
    var render = props.render, children = props.children, component = props.component, rest = (0, $ddEsc.default)(props, $23319eb72bd68064$var$_excluded$3);
    if (component) return /*#__PURE__*/ $5uXOq.createElement(component, Object.assign(lazyProps, rest, {
        children: children,
        render: render
    }));
    if (render) return render(children === undefined ? Object.assign(lazyProps, rest) : Object.assign(lazyProps, rest, {
        children: children
    }));
    if (typeof children !== "function") throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
    return children(Object.assign(lazyProps, rest));
}
function $23319eb72bd68064$var$useWhenValueChanges(value, callback, isEqual) {
    if (isEqual === void 0) isEqual = function isEqual(a, b) {
        return a === b;
    };
    var previous = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(function() {
        if (!isEqual(value, previous.current)) {
            callback();
            previous.current = value;
        }
    });
}
/**
 * A simple hook to create a constant value that lives for
 * the lifetime of the component.
 *
 * Plagiarized from https://github.com/Andarist/use-constant
 *
 * Do NOT reuse this code unless you know what you're doing.
 * Use Andarist's hook; it's more fault tolerant to things like
 * falsy values.
 *
 * @param {Function} init - A function to generate the value
 */ function $23319eb72bd68064$var$useConstant(init) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    if (!ref.current) ref.current = init();
    return ref.current;
}
var $23319eb72bd68064$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
var $23319eb72bd68064$var$isSyntheticEvent = function isSyntheticEvent(candidate) {
    return !!(candidate && typeof candidate.stopPropagation === "function");
};
var $23319eb72bd68064$var$ReactFinalFormContext = /*#__PURE__*/ $5uXOq.createContext();
function $23319eb72bd68064$var$useLatest(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(function() {
        ref.current = value;
    });
    return ref;
}
var $23319eb72bd68064$export$83d89fbfd8236492 = "6.5.8";
var $23319eb72bd68064$var$addLazyState = function addLazyState(dest, state, keys) {
    keys.forEach(function(key) {
        Object.defineProperty(dest, key, {
            get: function get() {
                return state[key];
            },
            enumerable: true
        });
    });
};
var $23319eb72bd68064$var$addLazyFormState = function addLazyFormState(dest, state) {
    return $23319eb72bd68064$var$addLazyState(dest, state, [
        "active",
        "dirty",
        "dirtyFields",
        "dirtySinceLastSubmit",
        "dirtyFieldsSinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ]);
};
var $23319eb72bd68064$var$addLazyFieldMetaState = function addLazyFieldMetaState(dest, state) {
    return $23319eb72bd68064$var$addLazyState(dest, state, [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "visited"
    ]);
};
var $23319eb72bd68064$var$_excluded$2 = [
    "debug",
    "decorators",
    "destroyOnUnregister",
    "form",
    "initialValues",
    "initialValuesEqual",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "subscription",
    "validate",
    "validateOnBlur"
];
var $23319eb72bd68064$var$versions = {
    "final-form": (0, $lqWDn.version),
    "react-final-form": $23319eb72bd68064$export$83d89fbfd8236492
};
var $23319eb72bd68064$var$all$1 = (0, $lqWDn.formSubscriptionItems).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
function $23319eb72bd68064$export$a7fed597f4b8afd8(_ref) {
    var debug = _ref.debug, _ref$decorators = _ref.decorators, decorators = _ref$decorators === void 0 ? [] : _ref$decorators, destroyOnUnregister = _ref.destroyOnUnregister, alternateFormApi = _ref.form, initialValues = _ref.initialValues, initialValuesEqual = _ref.initialValuesEqual, keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize, mutators = _ref.mutators, onSubmit = _ref.onSubmit, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $23319eb72bd68064$var$all$1 : _ref$subscription, validate = _ref.validate, validateOnBlur = _ref.validateOnBlur, rest = (0, $ddEsc.default)(_ref, $23319eb72bd68064$var$_excluded$2);
    var config = {
        debug: debug,
        destroyOnUnregister: destroyOnUnregister,
        initialValues: initialValues,
        keepDirtyOnReinitialize: keepDirtyOnReinitialize,
        mutators: mutators,
        onSubmit: onSubmit,
        validate: validate,
        validateOnBlur: validateOnBlur
    };
    var form = $23319eb72bd68064$var$useConstant(function() {
        var f = alternateFormApi || (0, $lqWDn.createForm)(config); // pause validation until children register all fields on first render (unpaused in useEffect() below)
        f.pauseValidation();
        return f;
    }); // synchronously register and unregister to query form state for our subscription on first render
    var _React$useState = $5uXOq.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1]; // save a copy of state that can break through the closure
    // on the shallowEqual() line below.
    var stateRef = $23319eb72bd68064$var$useLatest(state);
    $5uXOq.useEffect(function() {
        // We have rendered, so all fields are now registered, so we can unpause validation
        form.isValidationPaused() && form.resumeValidation();
        var unsubscriptions = [
            form.subscribe(function(s) {
                if (!$23319eb72bd68064$var$shallowEqual(s, stateRef.current)) setState(s);
            }, subscription)
        ].concat(decorators ? decorators.map(function(decorator) {
            return(// istanbul ignore next
            decorator(form));
        }) : []);
        return function() {
            form.pauseValidation(); // pause validation so we don't revalidate on every field deregistration
            unsubscriptions.reverse().forEach(function(unsubscribe) {
                return unsubscribe();
            }); // don't need to resume validation here; either unmounting, or will re-run this hook with new deps
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, decorators); // warn about decorator changes
    $23319eb72bd68064$var$useWhenValueChanges(debug, function() {
        form.setConfig("debug", debug);
    });
    $23319eb72bd68064$var$useWhenValueChanges(destroyOnUnregister, function() {
        form.destroyOnUnregister = !!destroyOnUnregister;
    });
    $23319eb72bd68064$var$useWhenValueChanges(keepDirtyOnReinitialize, function() {
        form.setConfig("keepDirtyOnReinitialize", keepDirtyOnReinitialize);
    });
    $23319eb72bd68064$var$useWhenValueChanges(initialValues, function() {
        form.setConfig("initialValues", initialValues);
    }, initialValuesEqual || $23319eb72bd68064$var$shallowEqual);
    $23319eb72bd68064$var$useWhenValueChanges(mutators, function() {
        form.setConfig("mutators", mutators);
    });
    $23319eb72bd68064$var$useWhenValueChanges(onSubmit, function() {
        form.setConfig("onSubmit", onSubmit);
    });
    $23319eb72bd68064$var$useWhenValueChanges(validate, function() {
        form.setConfig("validate", validate);
    });
    $23319eb72bd68064$var$useWhenValueChanges(validateOnBlur, function() {
        form.setConfig("validateOnBlur", validateOnBlur);
    });
    var handleSubmit = function handleSubmit(event) {
        if (event) {
            // sometimes not true, e.g. React Native
            if (typeof event.preventDefault === "function") event.preventDefault();
            if (typeof event.stopPropagation === "function") // prevent any outer forms from receiving the event too
            event.stopPropagation();
        }
        return form.submit();
    };
    var renderProps = {
        form: (0, $bS32t.default)({}, form, {
            reset: function reset(eventOrValues) {
                if ($23319eb72bd68064$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                form.reset();
                else form.reset(eventOrValues);
            }
        }),
        handleSubmit: handleSubmit
    };
    $23319eb72bd68064$var$addLazyFormState(renderProps, state);
    return /*#__PURE__*/ $5uXOq.createElement($23319eb72bd68064$var$ReactFinalFormContext.Provider, {
        value: form
    }, $23319eb72bd68064$var$renderComponent((0, $bS32t.default)({}, rest, {
        __versions: $23319eb72bd68064$var$versions
    }), renderProps, "ReactFinalForm"));
}
function $23319eb72bd68064$export$87c0cf8eb5a167e0(componentName) {
    var form = $5uXOq.useContext($23319eb72bd68064$var$ReactFinalFormContext);
    if (!form) throw new Error((componentName || "useForm") + " must be used inside of a <Form> component");
    return form;
}
function $23319eb72bd68064$export$606f11b2eb45ecc6(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, onChange = _ref.onChange, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $23319eb72bd68064$var$all$1 : _ref$subscription;
    var form = $23319eb72bd68064$export$87c0cf8eb5a167e0("useFormState");
    var firstRender = $5uXOq.useRef(true);
    var onChangeRef = $5uXOq.useRef(onChange);
    onChangeRef.current = onChange; // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $5uXOq.useState(function() {
        var initialState = {};
        form.subscribe(function(state) {
            initialState = state;
        }, subscription)();
        if (onChange) onChange(initialState);
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $5uXOq.useEffect(function() {
        return form.subscribe(function(newState) {
            if (firstRender.current) firstRender.current = false;
            else {
                setState(newState);
                if (onChangeRef.current) onChangeRef.current(newState);
            }
        }, subscription);
    }, []);
    var lazyState = {};
    $23319eb72bd68064$var$addLazyFormState(lazyState, state);
    return lazyState;
}
var $23319eb72bd68064$var$_excluded$1 = [
    "onChange",
    "subscription"
];
function $23319eb72bd68064$export$d2e89184086487cb(_ref) {
    var onChange = _ref.onChange, subscription = _ref.subscription, rest = (0, $ddEsc.default)(_ref, $23319eb72bd68064$var$_excluded$1);
    var reactFinalForm = $23319eb72bd68064$export$87c0cf8eb5a167e0("FormSpy");
    var state = $23319eb72bd68064$export$606f11b2eb45ecc6({
        onChange: onChange,
        subscription: subscription
    });
    if (onChange) return null;
    var renderProps = {
        form: (0, $bS32t.default)({}, reactFinalForm, {
            reset: function reset(eventOrValues) {
                if ($23319eb72bd68064$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                reactFinalForm.reset();
                else reactFinalForm.reset(eventOrValues);
            }
        })
    };
    return $23319eb72bd68064$var$renderComponent((0, $bS32t.default)({}, rest, renderProps), state, "FormSpy");
}
var $23319eb72bd68064$var$isReactNative = typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative";
var $23319eb72bd68064$var$getSelectedValues = function getSelectedValues(options) {
    var result = [];
    if (options) for(var index = 0; index < options.length; index++){
        var option = options[index];
        if (option.selected) result.push(option.value);
    }
    return result;
};
var $23319eb72bd68064$var$getValue = function getValue(event, currentValue, valueProp, isReactNative) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) return event.nativeEvent.text;
    if (isReactNative && event.nativeEvent) return event.nativeEvent.text;
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target, type = _detypedEvent$target.type, value = _detypedEvent$target.value, checked = _detypedEvent$target.checked;
    switch(type){
        case "checkbox":
            if (valueProp !== undefined) {
                // we are maintaining an array, not just a boolean
                if (checked) // add value to current array value
                return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [
                    valueProp
                ];
                else {
                    // remove value from current array value
                    if (!Array.isArray(currentValue)) return currentValue;
                    var index = currentValue.indexOf(valueProp);
                    if (index < 0) return currentValue;
                    else return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
                }
            } else // it's just a boolean
            return !!checked;
        case "select-multiple":
            return $23319eb72bd68064$var$getSelectedValues(event.target.options);
        default:
            return value;
    }
};
/**
 * Creates a callback, even with closures, that will be
 * instance === for the lifetime of the component, always
 * calling the most recent version of the function and its
 * closures.
 */ function $23319eb72bd68064$var$useConstantCallback(callback) {
    var ref = $5uXOq.useRef(callback);
    $5uXOq.useEffect(function() {
        ref.current = callback;
    });
    return $5uXOq.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(null, args);
    }, []);
}
var $23319eb72bd68064$var$all = (0, $lqWDn.fieldSubscriptionItems).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
var $23319eb72bd68064$var$defaultFormat = function defaultFormat(value, name) {
    return value === undefined ? "" : value;
};
var $23319eb72bd68064$var$defaultParse = function defaultParse(value, name) {
    return value === "" ? undefined : value;
};
var $23319eb72bd68064$var$defaultIsEqual = function defaultIsEqual(a, b) {
    return a === b;
};
function $23319eb72bd68064$export$294aa081a6c6f55d(name, config) {
    if (config === void 0) config = {};
    var _config = config, afterSubmit = _config.afterSubmit, allowNull = _config.allowNull, component = _config.component, data = _config.data, defaultValue = _config.defaultValue, _config$format = _config.format, format = _config$format === void 0 ? $23319eb72bd68064$var$defaultFormat : _config$format, formatOnBlur = _config.formatOnBlur, initialValue = _config.initialValue, multiple = _config.multiple, _config$parse = _config.parse, parse = _config$parse === void 0 ? $23319eb72bd68064$var$defaultParse : _config$parse, _config$subscription = _config.subscription, subscription = _config$subscription === void 0 ? $23319eb72bd68064$var$all : _config$subscription, type = _config.type, validateFields = _config.validateFields, _value = _config.value;
    var form = $23319eb72bd68064$export$87c0cf8eb5a167e0("useField");
    var configRef = $23319eb72bd68064$var$useLatest(config);
    var register = function register(callback, silent) {
        return(// because they would refer `state` from current execution context
        // whereas actual `state` would defined in the subsequent `useField` hook
        // execution
        // (that would be caused by `setState` call performed in `register` callback)
        form.registerField(name, callback, subscription, {
            afterSubmit: afterSubmit,
            beforeSubmit: function beforeSubmit() {
                var _configRef$current = configRef.current, beforeSubmit = _configRef$current.beforeSubmit, formatOnBlur = _configRef$current.formatOnBlur, _configRef$current$fo = _configRef$current.format, format = _configRef$current$fo === void 0 ? $23319eb72bd68064$var$defaultFormat : _configRef$current$fo;
                if (formatOnBlur) {
                    var _ref = form.getFieldState(name), value = _ref.value;
                    var formatted = format(value, name);
                    if (formatted !== value) form.change(name, formatted);
                }
                return beforeSubmit && beforeSubmit();
            },
            data: data,
            defaultValue: defaultValue,
            getValidator: function getValidator() {
                return configRef.current.validate;
            },
            initialValue: initialValue,
            isEqual: function isEqual(a, b) {
                return (configRef.current.isEqual || $23319eb72bd68064$var$defaultIsEqual)(a, b);
            },
            silent: silent,
            validateFields: validateFields
        }));
    };
    var firstRender = $5uXOq.useRef(true); // synchronously register and unregister to query field state for our subscription on first render
    var _React$useState = $5uXOq.useState(function() {
        var initialState = {}; // temporarily disable destroyOnUnregister
        // temporarily disable destroyOnUnregister
        var destroyOnUnregister = form.destroyOnUnregister;
        form.destroyOnUnregister = false;
        register(function(state) {
            initialState = state;
        }, true)(); // return destroyOnUnregister to its original value
        // return destroyOnUnregister to its original value
        form.destroyOnUnregister = destroyOnUnregister;
        return initialState;
    }), state = _React$useState[0], setState = _React$useState[1];
    $5uXOq.useEffect(function() {
        return register(function(state) {
            if (firstRender.current) firstRender.current = false;
            else setState(state);
        }, false);
    }, [
        name,
        data,
        defaultValue,
        // cannot reregister field every time validate function !==.
        // validate,
        initialValue // The validateFields array is often passed as validateFields={[]}, creating
    ]);
    var meta = {};
    $23319eb72bd68064$var$addLazyFieldMetaState(meta, state);
    var input = {
        name: name,
        get value () {
            var value = state.value;
            if (formatOnBlur) {
                if (component === "input") value = $23319eb72bd68064$var$defaultFormat(value);
            } else value = format(value, name);
            if (value === null && !allowNull) value = "";
            if (type === "checkbox" || type === "radio") return _value;
            else if (component === "select" && multiple) return value || [];
            return value;
        },
        get checked () {
            var value1 = state.value;
            if (type === "checkbox") {
                value1 = format(value1, name);
                if (_value === undefined) return !!value1;
                else return !!(Array.isArray(value1) && ~value1.indexOf(_value));
            } else if (type === "radio") return format(value1, name) === _value;
            return undefined;
        },
        onBlur: $23319eb72bd68064$var$useConstantCallback(function(event) {
            state.blur();
            if (formatOnBlur) {
                /**
         * Here we must fetch the value directly from Final Form because we cannot
         * trust that our `state` closure has the most recent value. This is a problem
         * if-and-only-if the library consumer has called `onChange()` immediately
         * before calling `onBlur()`, but before the field has had a chance to receive
         * the value update from Final Form.
         */ var fieldState = form.getFieldState(state.name);
                state.change(format(fieldState.value, state.name));
            }
        }),
        onChange: $23319eb72bd68064$var$useConstantCallback(function(event) {
            var targetType, unknown, _value2;
            var value = event && event.target ? $23319eb72bd68064$var$getValue(event, state.value, _value, $23319eb72bd68064$var$isReactNative) : event;
            state.change(parse(value, name));
        }),
        onFocus: $23319eb72bd68064$var$useConstantCallback(function(event) {
            return state.focus();
        })
    };
    if (multiple) input.multiple = multiple;
    if (type !== undefined) input.type = type;
    var renderProps = {
        input: input,
        meta: meta
    }; // assign to force Flow check
    return renderProps;
}
var $23319eb72bd68064$var$_excluded = [
    "afterSubmit",
    "allowNull",
    "beforeSubmit",
    "children",
    "component",
    "data",
    "defaultValue",
    "format",
    "formatOnBlur",
    "initialValue",
    "isEqual",
    "multiple",
    "name",
    "parse",
    "subscription",
    "type",
    "validate",
    "validateFields",
    "value"
];
var $23319eb72bd68064$export$a455218a85c89869 = /*#__PURE__*/ $5uXOq.forwardRef(function Field(_ref, ref) {
    var afterSubmit = _ref.afterSubmit, allowNull = _ref.allowNull, beforeSubmit = _ref.beforeSubmit, children = _ref.children, component = _ref.component, data = _ref.data, defaultValue = _ref.defaultValue, format = _ref.format, formatOnBlur = _ref.formatOnBlur, initialValue = _ref.initialValue, isEqual = _ref.isEqual, multiple = _ref.multiple, name = _ref.name, parse = _ref.parse, subscription = _ref.subscription, type = _ref.type, validate = _ref.validate, validateFields = _ref.validateFields, value = _ref.value, rest = (0, $ddEsc.default)(_ref, $23319eb72bd68064$var$_excluded);
    var field = $23319eb72bd68064$export$294aa081a6c6f55d(name, {
        afterSubmit: afterSubmit,
        allowNull: allowNull,
        beforeSubmit: beforeSubmit,
        children: children,
        component: component,
        data: data,
        defaultValue: defaultValue,
        format: format,
        formatOnBlur: formatOnBlur,
        initialValue: initialValue,
        isEqual: isEqual,
        multiple: multiple,
        parse: parse,
        subscription: subscription,
        type: type,
        validate: validate,
        validateFields: validateFields,
        value: value
    });
    if (typeof children === "function") return children((0, $bS32t.default)({}, field, rest));
    if (typeof component === "string") // ignore meta, combine input with any other props
    return /*#__PURE__*/ $5uXOq.createElement(component, (0, $bS32t.default)({}, field.input, {
        children: children,
        ref: ref
    }, rest));
    if (!name) throw new Error("prop name cannot be undefined in <Field> component");
    return $23319eb72bd68064$var$renderComponent((0, $bS32t.default)({
        children: children,
        component: component,
        ref: ref
    }, rest), field, "Field(" + name + ")");
});
function $23319eb72bd68064$export$38f9b05178901e14() {
    return {
        Form: $23319eb72bd68064$export$a7fed597f4b8afd8,
        FormSpy: $23319eb72bd68064$export$d2e89184086487cb
    };
}

});

parcelRegister("8xY2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e8a33635366e45e$export$2e2bcd8739ae039);
function $7e8a33635366e45e$export$2e2bcd8739ae039(children, props) {
    // Check if the component got 'function as child' more than once
    if (Array.isArray(children)) {
        const countFunctions = children.reduce((accumulator, child)=>typeof child === 'function' ? accumulator += 1 : accumulator, 0);
        if (countFunctions > 1) throw new Error(`Component expected 1 function as child but got ${countFunctions}.`);
    }
    return typeof children === 'function' ? children(props) : children;
}

});

parcelRegister("5kG7a", function(module, exports) {

$parcel$export(module.exports, "HintPopup", () => $efd1ec63f145ef22$export$c393d844e85461b7);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $820Wv = parcelRequire("820Wv");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $k5uoT = parcelRequire("k5uoT");

var $2R2uW = parcelRequire("2R2uW");
const $efd1ec63f145ef22$var$popupStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.100',
    paddingInline: 'space.200',
    maxWidth: '360px'
});
const $efd1ec63f145ef22$export$c393d844e85461b7 = ({ hint: hint, label: label })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onKeyDown: (e)=>{
            if (e.key === 'Escape' && isOpen) {
                e.nativeEvent.stopImmediatePropagation();
                setIsOpen(false);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isOpen,
        placement: "right",
        zIndex: (0, $k5uoT.layers).tooltip(),
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $efd1ec63f145ef22$var$popupStyles
            }, hint),
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...triggerProps,
                label: formatMessage((0, $2R2uW.HintPopupMessages).MoreInfoIconLabel, {
                    fieldName: label
                }),
                appearance: "subtle",
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($820Wv))), {
                        ...iconProps,
                        color: "currentColor",
                        LEGACY_size: "small"
                    }),
                "aria-haspopup": "true",
                "aria-expanded": isOpen,
                spacing: "compact"
            })
    }));
};

});
parcelRegister("820Wv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8b47c8580de559edd6a7f4245d87179>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d8f3dcf908a8bd0$var$_react = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5d8f3dcf908a8bd0$var$_information = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("jxZHv")));

var $5d8f3dcf908a8bd0$var$_panel = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("kkuz9")));
function $5d8f3dcf908a8bd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d8f3dcf908a8bd0$var$InformationIcon = (props)=>/*#__PURE__*/ $5d8f3dcf908a8bd0$var$_react.default.createElement($5d8f3dcf908a8bd0$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $5d8f3dcf908a8bd0$var$_panel.default
    }, props));
$5d8f3dcf908a8bd0$var$InformationIcon.Name = 'InformationIconMigration';
var $5d8f3dcf908a8bd0$var$_default = module.exports.default = $5d8f3dcf908a8bd0$var$InformationIcon;

});
parcelRegister("jxZHv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27668a0671d09dc2613ff96651c1fef4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3b0f5e112f2bb60$var$_react = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e3b0f5e112f2bb60$var$_baseNew = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e3b0f5e112f2bb60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3b0f5e112f2bb60$var$InformationIcon = (props)=>/*#__PURE__*/ $e3b0f5e112f2bb60$var$_react.default.createElement($e3b0f5e112f2bb60$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-7.5-.75H6a.75.75 0 0 1 .75.75v4h-1.5V6.75H4.5zM6 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$e3b0f5e112f2bb60$var$InformationIcon.displayName = 'InformationIcon';
var $e3b0f5e112f2bb60$var$_default = module.exports.default = $e3b0f5e112f2bb60$var$InformationIcon;

});


parcelRegister("2R2uW", function(module, exports) {

$parcel$export(module.exports, "HintPopupMessages", () => $6fff9f970361f592$export$f691ce5de7f63949);

var $7VHMR = parcelRequire("7VHMR");
const $6fff9f970361f592$export$f691ce5de7f63949 = (0, $7VHMR.defineMessages)({
    MoreInfoIconLabel: {
        id: `eoc.form.field.hint-popup.more-info-icon-label`,
        defaultMessage: 'More about {fieldName}',
        description: "The label for the 'More info' icon in the hint popup"
    }
});

});


parcelRegister("1XCut", function(module, exports) {

$parcel$export(module.exports, "Container", () => $714eca9a836db56d$export$42a852a2b6b56249);
$parcel$export(module.exports, "Required", () => $714eca9a836db56d$export$1788c381af06add2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $714eca9a836db56d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $714eca9a836db56d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "e45w2f82"
})({
    name: "jatx3t",
    styles: "margin-top:var(--ds-space-100, 8px);font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);flex-direction:column"
});
const $714eca9a836db56d$export$1788c381af06add2 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e45w2f81"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        content: "'*'",
        marginLeft: "var(--ds-space-025, 2px)",
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
    }
});
const $714eca9a836db56d$export$78bef78bf8eeb36a = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e45w2f80"
})({
    name: "1hyq6d",
    styles: "margin-left:var(--ds-space-025, 2px)"
});

});
parcelRegister("dY87H", function(module, exports) {

$parcel$export(module.exports, "Flex", () => $2ce7fa80ca46705d$export$f51f4c4ede09e011);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");

var $bWGt6 = parcelRequire("bWGt6");
const $2ce7fa80ca46705d$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e18obzhx0"
})("display:flex;flex:", ({ flex: flex })=>flex, ";flex-basis:", ({ flexBasis: flexBasis })=>flexBasis, ";flex-direction:", ({ flexDirection: flexDirection })=>flexDirection, ";flex-flow:", ({ flexFlow: flexFlow })=>flexFlow, ";flex-grow:", ({ flexGrow: flexGrow })=>flexGrow, ";flex-shrink:", ({ flexShrink: flexShrink })=>flexShrink, ";flex-wrap:", ({ flexWrap: flexWrap })=>flexWrap, ";align-content:", ({ alignContent: alignContent })=>alignContent, ";align-items:", ({ alignItems: alignItems })=>alignItems, ";align-self:", ({ alignSelf: alignSelf })=>alignSelf, ";justify-content:", ({ justifyContent: justifyContent })=>justifyContent, ";order:", ({ order: order })=>order, ";place-items:", ({ placeItems: placeItems })=>placeItems, ";place-self:", ({ placeSelf: placeSelf })=>placeSelf, ";place-content:", ({ placeContent: placeContent })=>placeContent, ";row-gap:", ({ rowGap: rowGap })=>typeof rowGap === 'number' ? `${rowGap * (0, $k5uoT.gridSize)()}px` : rowGap, ";column-gap:", ({ columnGap: columnGap })=>typeof columnGap === 'number' ? `${columnGap * (0, $k5uoT.gridSize)()}px` : columnGap, ";");

});



parcelRegister("gcpT9", function(module, exports) {

$parcel$export(module.exports, "EocForm", () => $fa592090fbbbee9c$export$58fc96a19659d9da);

var $5uXOq = parcelRequire("5uXOq");

var $31kPh = parcelRequire("31kPh");

var $8xY2r = parcelRequire("8xY2r");
const $fa592090fbbbee9c$export$58fc96a19659d9da = ({ children: children, subscription: subscription, ...restFormProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31kPh.Form), {
        ...restFormProps,
        subscription: subscription ? subscription : {}
    }, (formRenderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            onReset: formRenderProps.form.reset,
            onSubmit: formRenderProps.handleSubmit
        }, (0, $8xY2r.default)(children, formRenderProps)));
};

});

parcelRegister("iMJ36", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $aedef8af3acf03a3$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $aedef8af3acf03a3$export$915e9e7bd4f0f96d);

var $5uXOq = parcelRequire("5uXOq");

var $059q9 = parcelRequire("059q9");

var $g4M8x = parcelRequire("g4M8x");

var $jDgon = parcelRequire("jDgon");

var $cl7nI = parcelRequire("cl7nI");
const $aedef8af3acf03a3$export$8fbe3c7d0ed2c683 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cl7nI.StyledHelperMessage), {
            id: fieldId ? `${fieldId}-helper` : undefined
        }, children));
};
const $aedef8af3acf03a3$export$5505afb209a532c8 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cl7nI.StyledValidMessage), {
            id: fieldId ? `${fieldId}-valid` : undefined,
            "aria-live": "polite",
            "aria-atomic": "true",
            columnGap: "6px"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g4M8x))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        }), children));
};
const $aedef8af3acf03a3$export$915e9e7bd4f0f96d = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cl7nI.StyledErrorMessage), {
            id: fieldId ? `${fieldId}-error` : undefined,
            "aria-live": "polite",
            "aria-atomic": "true",
            columnGap: "6px"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }), children));
};

});
parcelRegister("cl7nI", function(module, exports) {

$parcel$export(module.exports, "StyledErrorMessage", () => $2489c90ca43e7dbb$export$7e30077cd8dfa6f4);
$parcel$export(module.exports, "StyledValidMessage", () => $2489c90ca43e7dbb$export$36686146fb9443bb);
$parcel$export(module.exports, "StyledHelperMessage", () => $2489c90ca43e7dbb$export$bf92826cd426065b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $dY87H = parcelRequire("dY87H");

var $bWGt6 = parcelRequire("bWGt6");
function $2489c90ca43e7dbb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2489c90ca43e7dbb$var$commonStyles = {
    name: "1a210gq",
    styles: "font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-top:var(--ds-space-050, 4px);justify-content:baseline;align-items:center"
};
const $2489c90ca43e7dbb$export$7e30077cd8dfa6f4 = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "enawqf62"
})($2489c90ca43e7dbb$var$commonStyles, "color:var(--ds-text-danger, #AE2A19);");
const $2489c90ca43e7dbb$export$36686146fb9443bb = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "enawqf61"
})($2489c90ca43e7dbb$var$commonStyles, "color:var(--ds-text-success, #216E4E);");
const $2489c90ca43e7dbb$export$bf92826cd426065b = /*#__PURE__*/ (0, $bWGt6.default)((0, $dY87H.Flex), {
    target: "enawqf60"
})($2489c90ca43e7dbb$var$commonStyles, {
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
});

});


parcelRegister("69P3Z", function(module, exports) {

$parcel$export(module.exports, "useFormController", () => $a396049ff39cd4f5$export$f3ae7d3e787bbfcb);

var $5uXOq = parcelRequire("5uXOq");

var $iCBcG = parcelRequire("iCBcG");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $h8yj2 = parcelRequire("h8yj2");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $aI12f = parcelRequire("aI12f");

var $hem2I = parcelRequire("hem2I");

var $8iO1t = parcelRequire("8iO1t");

var $jjjoR = parcelRequire("jjjoR");

var $90XDC = parcelRequire("90XDC");

var $eBqFt = parcelRequire("eBqFt");

var $gbs59 = parcelRequire("gbs59");
const $a396049ff39cd4f5$export$f3ae7d3e787bbfcb = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: heartbeatsData, update: update } = (0, $hem2I.default)((0, $90XDC.heartbeatsResource));
    const { memoize: memoize } = (0, $8iO1t.useAsyncValidationMemo)();
    const [isValidateError, setIsValidateError] = (0, $5uXOq.useState)(false);
    const { validateLoading: validateLoading, validateName: validateName, create: create, edit: edit } = (0, $jjjoR.useHeartbeatsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { focusState: focusState } = (0, $eBqFt.useHeartbeatsContext)();
    (0, $hmVmJ.assert)(!!heartbeatsData, new (0, $dH6Pi.AssertionError)('useFormController', 'useFormController should not rendered before data is fetched'));
    const handleAsyncValidate = ()=>memoize(async (value)=>{
            if (!value || focusState.mode === 'edit') return undefined;
            setIsValidateError(false);
            try {
                await validateHeartbeatName(value);
                return undefined;
            } catch (error) {
                setIsValidateError(true);
                if ((0, $aI12f.isHTTPError)(error)) return error.message;
                else return formatMessage((0, $gbs59.default).unknownErrorOccurred);
            }
        });
    const validateHeartbeatName = (0, (/*@__PURE__*/$parcel$interopDefault($iCBcG)))(async (value)=>{
        await validateName(value);
    }, 1000);
    const handleSubmit = (data)=>{
        switch(focusState.mode){
            case 'create':
            case 'duplicate':
                return handleCreate(data);
            case 'edit':
                return handleEdit(data);
            default:
                break;
        }
    };
    const handleCreate = (data)=>{
        const request = getRequestFromFormData(data);
        return create(request).then((res)=>{
            const newData = {
                ...heartbeatsData
            };
            newData.heartbeats?.push(res);
            update(()=>newData);
            focusState.open({
                data: res,
                mode: 'view'
            });
        });
    };
    const handleEdit = (data)=>{
        const request = getRequestFromFormData(data);
        return edit(request).then((res)=>{
            const newData = {
                ...heartbeatsData
            };
            newData.heartbeats.forEach((heartbeat, index)=>{
                if (heartbeat.name === res?.name) {
                    newData.heartbeats[index] = res;
                    return;
                }
            });
            update(()=>newData);
            focusState.open({
                data: res,
                mode: 'view'
            });
        }).then(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'heartbeatEdit succeded');
        }).catch(()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireTrackAnalytics)(event, 'heartbeatEdit failed');
        });
    };
    const getRequestFromFormData = (formData)=>{
        const request = {
            name: formData.name,
            description: formData.description || '',
            ownerTeamId: formData.assignedTeam.atlassianIdentifier,
            interval: parseInt(formData.expect.interval?.toString() || ''),
            intervalUnit: formData.expect.unit.value,
            alertPriority: formData.alertMessage.alertPriority,
            alertMessage: formData.alertMessage.alertMessage?.toString() || '',
            alertTags: formData.tags?.length ? formData.tags.map((fieldValue)=>fieldValue.value) : []
        };
        return request;
    };
    return {
        validateLoading: validateLoading,
        isValidateError: isValidateError,
        handleAsyncValidate: handleAsyncValidate,
        handleSubmit: handleSubmit
    };
};

});
parcelRegister("iCBcG", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $d8e8a274648ab511$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $d8e8a274648ab511$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $d8e8a274648ab511$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $d8e8a274648ab511$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});

parcelRegister("8iO1t", function(module, exports) {

$parcel$export(module.exports, "useAsyncValidationMemo", () => $cfac93285b1245bc$export$8d10f40de37cfb42);

var $5uXOq = parcelRequire("5uXOq");
const $cfac93285b1245bc$export$8d10f40de37cfb42 = ()=>{
    const lastArg = (0, $5uXOq.useRef)(undefined);
    const lastResult = (0, $5uXOq.useRef)(undefined);
    const memoize = (0, $5uXOq.useCallback)((fn)=>{
        return async (arg)=>{
            if (arg !== lastArg.current) {
                lastArg.current = arg;
                lastResult.current = await fn(arg);
            }
            return lastResult.current;
        };
    }, []);
    return {
        memoize: memoize
    };
};

});

parcelRegister("gbs59", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c53ca2250b807c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $3c53ca2250b807c2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unknownErrorOccurred: {
        id: `eoc.heartbeats.name-input.unknown-error-occurred.no-translate`,
        defaultMessage: 'An unknown error occurred',
        description: `The text will be displayed if an unknown error occurs`
    }
});
var $3c53ca2250b807c2$export$2e2bcd8739ae039 = $3c53ca2250b807c2$export$defe85febe8b728c;

});


parcelRegister("81ruP", function(module, exports) {

$parcel$export(module.exports, "AssignedTeamInput", () => $bb40859da52f0a22$export$5a6fa00d85bec1f2);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bmKPg = parcelRequire("bmKPg");

var $VSDnB = parcelRequire("VSDnB");

var $koJmi = parcelRequire("koJmi");
var $6TYWC = parcelRequire("6TYWC");

var $jDgon = parcelRequire("jDgon");
var $iMJ36 = parcelRequire("iMJ36");

var $fXc9u = parcelRequire("fXc9u");

var $8Js2i = parcelRequire("8Js2i");

var $jxoTa = parcelRequire("jxoTa");
const $bb40859da52f0a22$export$5a6fa00d85bec1f2 = ({ ownerTeamId: ownerTeamId })=>{
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [responderTeam] = (0, $fXc9u.useResponderNames)(teamId ? [
        {
            type: 'team',
            id: teamId
        }
    ] : ownerTeamId ? [
        {
            type: 'team',
            id: ownerTeamId
        }
    ] : []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
        "aria-required": true,
        name: "assignedTeam",
        label: formatMessage((0, $8Js2i.default).assignedTeamLabel),
        isRequired: true,
        initialValue: responderTeam && 'name' in responderTeam ? {
            ...responderTeam,
            label: responderTeam.name,
            value: responderTeam.atlassianIdentifier || responderTeam.id
        } : undefined,
        validate: (value)=>{
            if (!value) return 'error';
        }
    }, ({ input: input, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koJmi.AutoComplete), {
            ...input,
            inputId: input.id,
            endpoints: [
                (0, $6TYWC.getTeams)
            ],
            components: {
                DropdownIndicator: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
                Control: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxoTa.SelectControl), {
                        responder: responderTeam,
                        ...props
                    })
            },
            placeholder: "",
            isOptionSelected: ()=>false,
            isLoading: responderTeam?.isLoading,
            isDisabled: (0, $VSDnB.fg)('global_heartbeats') ? !!teamId : true
        }), meta.touched && meta.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJ36.ErrorMessage), null, formatMessage((0, $8Js2i.default).assignedTeamErrorText))));
};

});
parcelRegister("koJmi", function(module, exports) {

$parcel$export(module.exports, "AutoComplete", () => $7c56771a8e963d5b$export$6b41f50dc0c59fb3);

var $5uXOq = parcelRequire("5uXOq");

var $d7FF4 = parcelRequire("d7FF4");

var $jZpi1 = parcelRequire("jZpi1");

var $5IIdi = parcelRequire("5IIdi");
const $7c56771a8e963d5b$export$6b41f50dc0c59fb3 = (props)=>{
    const getAutoCompleteOptions = (0, $5IIdi.useAutoCompleteOptions)(props.endpoints);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        menuPosition: "absolute",
        // @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
        loadOptions: getAutoCompleteOptions,
        ...props,
        components: {
            Option: (0, $jZpi1.AutoCompleteCustomOption),
            ...props.components
        }
    });
};

});
parcelRegister("jZpi1", function(module, exports) {

$parcel$export(module.exports, "AutoCompleteCustomOption", () => $2379c76481a40a8a$export$1af480cd27f881cb);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7sUFC = parcelRequire("7sUFC");
var $ujWmd = parcelRequire("ujWmd");

var $fTQ6p = parcelRequire("fTQ6p");

var $bZNwM = parcelRequire("bZNwM");

var $4hqZ5 = parcelRequire("4hqZ5");

var $bChGW = parcelRequire("bChGW");

var $liax7 = parcelRequire("liax7");
const $2379c76481a40a8a$export$1af480cd27f881cb = (props)=>{
    const { data: data } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const responderOption = (0, $5uXOq.useMemo)(()=>{
        let defaultConfig = {
            primaryText: data.label
        };
        switch(data.type){
            case 'user':
                return {
                    ...defaultConfig,
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "small",
                        src: data.avatarUrl
                    }),
                    secondaryText: data.email
                };
            case 'escalation':
                return {
                    ...defaultConfig,
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
                        color: "currentColor",
                        label: formatMessage((0, $liax7.messages).escalation),
                        spacing: "spacious"
                    })
                };
            case 'schedule':
                return {
                    ...defaultConfig,
                    avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fTQ6p))), {
                        label: formatMessage((0, $liax7.messages).schedule),
                        spacing: "spacious"
                    })
                };
            case 'group':
            case 'team':
                return {
                    ...defaultConfig,
                    avatar: data.avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                        size: "small",
                        src: data.avatarUrl
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
                        label: formatMessage((0, $liax7.messages).team),
                        spacing: "spacious"
                    })
                };
            default:
                throw new Error('Incorrect data type is provided or it is missing!');
        }
    }, [
        data.avatarUrl,
        data.email,
        data.label,
        data.type,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7sUFC.default), {
        avatar: responderOption.avatar,
        primaryText: responderOption.primaryText,
        secondaryText: responderOption.secondaryText
    }));
};

});
parcelRegister("fTQ6p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cac5a72d7466b1013dda7da8cfdf1ce3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9346889cb60921a$var$_react = $b9346889cb60921a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b9346889cb60921a$var$_calendar = $b9346889cb60921a$var$_interopRequireDefault((parcelRequire("3fesp")));

var $b9346889cb60921a$var$_calendarFilled = $b9346889cb60921a$var$_interopRequireDefault((parcelRequire("bm9C8")));
function $b9346889cb60921a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b9346889cb60921a$var$CalendarIcon = (props)=>/*#__PURE__*/ $b9346889cb60921a$var$_react.default.createElement($b9346889cb60921a$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $b9346889cb60921a$var$_calendarFilled.default
    }, props));
$b9346889cb60921a$var$CalendarIcon.Name = 'CalendarIconMigration';
var $b9346889cb60921a$var$_default = module.exports.default = $b9346889cb60921a$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3c6678ca49b47a08391fd96c442f9a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("bm9C8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $844934f4eb646769$var$_react = $844934f4eb646769$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $844934f4eb646769$var$_calendar = $844934f4eb646769$var$_interopRequireDefault((parcelRequire("3fesp")));
function $844934f4eb646769$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $844934f4eb646769$var$CalendarFilledIcon = (props)=>/*#__PURE__*/ $844934f4eb646769$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M19 5h.005C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5H5v1c0 1.112.895 2 2 2 1.112 0 2-.895 2-2V5h6v1c0 1.112.895 2 2 2 1.112 0 2-.895 2-2z"/><path fill="inherit" d="M7 13h2v-2H7zm0 4h2v-2H7zm4-4h2v-2h-2zm0 4h2v-2h-2zm4-4h2v-2h-2zm0 4h2v-2h-2z"/><path fill="currentcolor" d="M16 6V5h2v1a1 1 0 0 1-2 0m0-2a1 1 0 0 1 2 0v1h-2zM6 4a1 1 0 0 1 2 0v1H6zm0 2V5h2v1a1 1 0 0 1-2 0"/></g></svg>`
    }, props, {
        newIcon: $844934f4eb646769$var$_calendar.default
    }));
$844934f4eb646769$var$CalendarFilledIcon.displayName = 'CalendarFilledIcon';
var $844934f4eb646769$var$_default = module.exports.default = $844934f4eb646769$var$CalendarFilledIcon;

});


parcelRegister("bZNwM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3be954ea5d070f5903d5961389b0e8fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bbbcf5ce8764439$var$_react = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bbbcf5ce8764439$var$_chartTrend = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("7EZ5v")));

var $8bbbcf5ce8764439$var$_graphLine = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("gSPJV")));
function $8bbbcf5ce8764439$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bbbcf5ce8764439$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $8bbbcf5ce8764439$var$_react.default.createElement($8bbbcf5ce8764439$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $8bbbcf5ce8764439$var$_graphLine.default
    }, props));
$8bbbcf5ce8764439$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $8bbbcf5ce8764439$var$_default = module.exports.default = $8bbbcf5ce8764439$var$ChartTrendIcon;

});
parcelRegister("7EZ5v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3611c0152bc32ad7e4a8e40b5d90bbb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $593ba794a5c6525a$var$_react = $593ba794a5c6525a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $593ba794a5c6525a$var$_baseNew = $593ba794a5c6525a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $593ba794a5c6525a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $593ba794a5c6525a$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $593ba794a5c6525a$var$_react.default.createElement($593ba794a5c6525a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 1v9.75M15 14.25H3c-.69 0-1.25-.56-1.25-1.25v-2.25m0 0 4.5-4.5L8.5 8.5l5.25-5.25m.5 3.75V2.75H10"/>`
    }, props));
$593ba794a5c6525a$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $593ba794a5c6525a$var$_default = module.exports.default = $593ba794a5c6525a$var$ChartTrendIcon;

});

parcelRegister("gSPJV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4a9d2eb82ff139c$var$_react = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c4a9d2eb82ff139c$var$_chartTrend = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("7EZ5v")));
function $c4a9d2eb82ff139c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c4a9d2eb82ff139c$var$GraphLineIcon = (props)=>/*#__PURE__*/ $c4a9d2eb82ff139c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $c4a9d2eb82ff139c$var$_chartTrend.default
    }));
$c4a9d2eb82ff139c$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $c4a9d2eb82ff139c$var$_default = module.exports.default = $c4a9d2eb82ff139c$var$GraphLineIcon;

});


parcelRegister("liax7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d851cfba5f716e38$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d851cfba5f716e38$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    team: {
        id: 'eoc.auto-complete.custom-option.team-icon.no-translate',
        defaultMessage: 'Group',
        description: 'Label of group icon that indicates responder is a group'
    },
    schedule: {
        id: 'eoc.auto-complete.custom-option.schedule-icon.no-translate',
        defaultMessage: 'Calendar',
        description: 'Label of calendar icon that indicates responder is a schedule'
    },
    escalation: {
        id: 'eoc.auto-complete.custom-option.escalation-icon.no-translate',
        defaultMessage: 'Chart',
        description: 'Label of chart icon that indicates responder is a escalation'
    },
    user: {
        id: 'eoc.auto-complete.custom-option.user-icon.no-translate',
        defaultMessage: 'User',
        description: 'Label of user icon that indicates responder is a user'
    }
});

});


parcelRegister("5IIdi", function(module, exports) {

$parcel$export(module.exports, "useAutoCompleteOptions", () => $735d26251c8e20ba$export$f95737357eb49713);

var $iCBcG = parcelRequire("iCBcG");

var $2VYEV = parcelRequire("2VYEV");

var $8eCQi = parcelRequire("8eCQi");

var $aI12f = parcelRequire("aI12f");
var $2tKfK = parcelRequire("2tKfK");
const $735d26251c8e20ba$export$f95737357eb49713 = (endpoints)=>{
    const { showFlag: showFlag } = (0, $2tKfK.default)();
    const defaultCatch = (0, $2VYEV.useDefaultCatch)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($iCBcG)))((inputValue)=>{
        return Promise.all(endpoints.map((endpoint)=>{
            return endpoint({
                keyword: inputValue
            });
        })).then((response)=>response.flatMap((r)=>r.values).map((r)=>({
                    label: r.name,
                    value: r.id,
                    ...r
                }))).catch((error)=>{
            // If we cancel one of the request we shouldn't display toast
            if ((0, $aI12f.isNetworkError)(error) && error.cause instanceof DOMException) return;
            throw error;
        }).catch(defaultCatch({
            id: 'useAutoCompleteOptions',
            httpErrorHandler: (error)=>{
                showFlag({
                    ...(0, $8eCQi.errorToastProps)(),
                    title: error.message,
                    isAutoDismiss: true
                });
            }
        }));
    }, 300);
};

});


parcelRegister("6TYWC", function(module, exports) {

$parcel$export(module.exports, "getSchedules", () => $fce90edcc1d0a2e4$export$db731c12fd4796f8);
$parcel$export(module.exports, "getEscalations", () => $fce90edcc1d0a2e4$export$300727380b60aeb4);
$parcel$export(module.exports, "getUsers", () => $fce90edcc1d0a2e4$export$925a4945a6cd0f3e);
$parcel$export(module.exports, "getTeams", () => $fce90edcc1d0a2e4$export$5a622455e94bac3);
$parcel$export(module.exports, "getResponders", () => $fce90edcc1d0a2e4$export$a7fc05d077ca06b5);

var $j74qU = parcelRequire("j74qU");
const $fce90edcc1d0a2e4$export$eae9a4162e9fa557 = '50';
const $fce90edcc1d0a2e4$export$daf3f4a975b45a66 = (types)=>{
    return ({ keyword: keyword }, signalParam, limit = $fce90edcc1d0a2e4$export$eae9a4162e9fa557)=>{
        const params = new URLSearchParams({
            ...types && {
                types: types.join(',')
            },
            ...keyword && {
                keyword: keyword
            },
            limit: limit
        });
        return (0, $j74qU.eocFetch)(`/v1/alerts/responders/auto-complete?${params.toString()}`, signalParam);
    };
};
const $fce90edcc1d0a2e4$export$db731c12fd4796f8 = $fce90edcc1d0a2e4$export$daf3f4a975b45a66([
    'schedule'
]);
const $fce90edcc1d0a2e4$export$300727380b60aeb4 = $fce90edcc1d0a2e4$export$daf3f4a975b45a66([
    'escalation'
]);
const $fce90edcc1d0a2e4$export$925a4945a6cd0f3e = $fce90edcc1d0a2e4$export$daf3f4a975b45a66([
    'user'
]);
const $fce90edcc1d0a2e4$export$5a622455e94bac3 = $fce90edcc1d0a2e4$export$daf3f4a975b45a66([
    'team'
]);
const $fce90edcc1d0a2e4$export$a7fc05d077ca06b5 = $fce90edcc1d0a2e4$export$daf3f4a975b45a66();

});

parcelRegister("8Js2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $aec3e6f8104084c7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $aec3e6f8104084c7$var$messages = (0, $7VHMR.defineMessages)({
    assignedTeamLabel: {
        id: 'eoc.heartbeats.form.assigned-team-label.no-translate',
        defaultMessage: 'Assigned team',
        description: 'Label of assigned team field.'
    },
    assignedTeamErrorText: {
        id: 'eoc.heartbeats.form.assigned-team-error-text.no-translate',
        defaultMessage: 'Enter assigned team.',
        description: 'Error text of the assigned team field.'
    }
});
var $aec3e6f8104084c7$export$2e2bcd8739ae039 = $aec3e6f8104084c7$var$messages;

});

parcelRegister("jxoTa", function(module, exports) {

$parcel$export(module.exports, "SelectControl", () => $176d36a51d8c81c8$export$bf14d6d11521c08e);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $8k22Y = parcelRequire("8k22Y");
const $176d36a51d8c81c8$export$bf14d6d11521c08e = ({ children: children, responder: responder, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, props, responder && !props.selectProps.inputValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8k22Y.default), {
        responder: responder,
        size: "small"
    }), children);
};

});
parcelRegister("8k22Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57b99ed8f2cadab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8icyj = parcelRequire("8icyj");

var $aIXQ3 = parcelRequire("aIXQ3");

var $gdpBI = parcelRequire("gdpBI");
const $f57b99ed8f2cadab$var$ResponderAvatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { responder: responder, size: size } = props;
    if (responder.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: (0, $aIXQ3.DIMENSIONS)[size],
        height: (0, $aIXQ3.DIMENSIONS)[size],
        variant: "circle"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gdpBI.LoadedResponderAvatar), {
        avatarRef: ref,
        ...props
    });
});
var $f57b99ed8f2cadab$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f57b99ed8f2cadab$var$ResponderAvatar);

});
parcelRegister("aIXQ3", function(module, exports) {

$parcel$export(module.exports, "DIMENSIONS", () => $fd790a5c37255dd7$export$d67ac355184b7646);
$parcel$export(module.exports, "ICON_SIZE_MAPPER", () => $fd790a5c37255dd7$export$958e13c28bb9605e);
const $fd790a5c37255dd7$export$d67ac355184b7646 = {
    xsmall: 2,
    small: 3,
    medium: 4,
    large: 5
};
const $fd790a5c37255dd7$export$958e13c28bb9605e = {
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};

});

parcelRegister("gdpBI", function(module, exports) {

$parcel$export(module.exports, "LoadedResponderAvatar", () => $7a7b255aa33dc30a$export$63d9675085ad4c01);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $ujWmd = parcelRequire("ujWmd");

var $42CjB = parcelRequire("42CjB");

var $fTQ6p = parcelRequire("fTQ6p");

var $bZNwM = parcelRequire("bZNwM");

var $4hqZ5 = parcelRequire("4hqZ5");

var $aIXQ3 = parcelRequire("aIXQ3");

var $8LW0E = parcelRequire("8LW0E");
const $7a7b255aa33dc30a$var$AvatarWithDefault = ({ responder: responder, size: size, avatarRef: avatarRef, labelDescriptor: labelDescriptor, iconComponent: IconComponent, ...props })=>{
    const intlApi = (0, $koVbs.default)();
    const avatarUrl = 'avatarUrl' in responder ? responder.avatarUrl : undefined;
    if (avatarUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        label: intlApi.formatMessage(labelDescriptor),
        ...props,
        ref: avatarRef,
        size: size,
        src: avatarUrl
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        ...props,
        ref: avatarRef,
        label: intlApi.formatMessage(labelDescriptor),
        size: size
    }, ({ 'aria-label': label, ref: ref, ...avatarProps })=>{
        return avatarProps.onClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            label: label,
            ...avatarProps,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconComponent, {
                    ...iconProps,
                    size: (0, $aIXQ3.ICON_SIZE_MAPPER)[size]
                })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconComponent, {
            label: intlApi.formatMessage(labelDescriptor),
            size: (0, $aIXQ3.ICON_SIZE_MAPPER)[size]
        });
    });
};
const $7a7b255aa33dc30a$var$UserResponderAvatar = ({ responder: responder, size: size, avatarRef: avatarRef, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        ref: avatarRef,
        label: formatMessage((0, $8LW0E.default).user),
        ...props,
        size: size,
        src: 'avatarUrl' in responder ? responder.avatarUrl : undefined
    });
};
const $7a7b255aa33dc30a$export$63d9675085ad4c01 = (props)=>{
    const responder = props.responder;
    switch(responder.type){
        case 'user':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a7b255aa33dc30a$var$UserResponderAvatar, props);
        case 'team':
        case 'group':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a7b255aa33dc30a$var$AvatarWithDefault, {
                labelDescriptor: (0, $8LW0E.default).team,
                iconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))),
                ...props
            });
        case 'schedule':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a7b255aa33dc30a$var$AvatarWithDefault, {
                labelDescriptor: (0, $8LW0E.default).schedule,
                iconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fTQ6p))),
                ...props
            });
        case 'escalation':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a7b255aa33dc30a$var$AvatarWithDefault, {
                labelDescriptor: (0, $8LW0E.default).escalation,
                iconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
                ...props
            });
    }
};

});
parcelRegister("8LW0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $468472130aa2cf0b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $468472130aa2cf0b$var$messages = (0, $7VHMR.defineMessages)({
    team: {
        id: 'eoc.alert-common.custom-option.team-icon.no-translate',
        defaultMessage: 'Group',
        description: 'Label of group icon that indicates responder is a group'
    },
    schedule: {
        id: 'eoc.alert-common.custom-option.schedule-icon.no-translate',
        defaultMessage: 'Calendar',
        description: 'Label of calendar icon that indicates responder is a schedule'
    },
    escalation: {
        id: 'eoc.alert-common.custom-option.escalation-icon.no-translate',
        defaultMessage: 'Chart',
        description: 'Label of chart icon that indicates responder is a escalation'
    },
    user: {
        id: 'eoc.alert-common.custom-option.user-icon.no-translate',
        defaultMessage: 'User',
        description: 'Label of user icon that indicates responder is a user'
    }
});
var $468472130aa2cf0b$export$2e2bcd8739ae039 = $468472130aa2cf0b$var$messages;

});





parcelRegister("a0WdN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f970d99ba5dd3f6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4f970d99ba5dd3f6$var$messages = (0, $7VHMR.defineMessages)({
    createFormHeader: {
        id: 'eoc.heartbeats.form.create-header.no-translate',
        defaultMessage: 'Create heartbeat',
        description: 'Header of create heartbeat form.'
    },
    editFormHeader: {
        id: 'eoc.heartbeats.form.edit-header.no-translate',
        defaultMessage: 'Edit heartbeat',
        description: 'Header of edit heartbeat form.'
    },
    descriptionLabel: {
        id: 'eoc.heartbeats.form.description-label.no-translate',
        defaultMessage: 'Description',
        description: 'Label of description field.'
    },
    descriptionPlaceholder: {
        id: 'eoc.heartbeats.form.description-placeholder.no-translate',
        defaultMessage: 'Give more details about this heartbeat',
        description: 'Placeholder of description field.'
    },
    expectLabel: {
        id: 'eoc.heartbeats.form.expect-label.no-translate',
        defaultMessage: 'Ping interval',
        description: 'Label of expect field.'
    },
    expectIntervalErrorText: {
        id: 'eoc.heartbeats.form.expect-error-text.no-translate',
        defaultMessage: 'Enter 1 or above',
        description: 'Error text of expect field interval section.'
    },
    expectUnitErrorText: {
        id: 'eoc.heartbeats.form.expect-error-text.no-translate',
        defaultMessage: 'Enter heartbeat interval',
        description: 'Error text of expect field unit section.'
    },
    invalidExpectErrorText: {
        id: 'eoc.heartbeats.form.invalid-expect-error-text.no-translate',
        defaultMessage: 'Enter 1 or above.',
        description: 'Error text of invalid expect field.'
    },
    invalidInterval: {
        id: 'eoc.heartbeats.form.invalid-interval.no-translate',
        defaultMessage: `Enter an interval lesser than {max} {unit, select,
      minutes {minutes}
      hours {hours}
      other {days}
    }`,
        description: 'The error message will be shown when heartbeat interval is invalid'
    },
    alertPropertiesTitle: {
        id: 'eoc.heartbeats.form.alert-properties-title.no-translate',
        defaultMessage: 'Alert properties',
        description: 'Title of the alert properties section inside form.'
    },
    alertPropertiesDescription: {
        id: 'eoc.heartbeats.form.alert-properties-description.no-translate',
        defaultMessage: 'Provide the alert details that will be generated if the heartbeat ping is not received within the specified interval.',
        description: 'Description of the alert properties section inside form.'
    },
    alertMessageLabel: {
        id: 'eoc.heartbeats.form.alert-properties-alert-message-label.no-translate',
        defaultMessage: 'Alert message',
        description: 'Label of alert message field.'
    },
    alertMessageValue: {
        id: 'eoc.heartbeats.form.alert-properties-alert-message-placeholder.no-translate',
        defaultMessage: 'Heartbeat {name} is down',
        description: 'placeholder of alert message field.'
    },
    alertMessageErrorText: {
        id: 'eoc.heartbeats.form.alert-properties-alert-message-error-text.no-translate',
        defaultMessage: 'Enter an alert message.',
        description: 'Error text of the alert message field.'
    },
    tagsLabel: {
        id: 'eoc.heartbeats.form.alert-properties-tags-label.no-translate',
        defaultMessage: 'Tags',
        description: 'Label of tags field.'
    },
    tagsPlaceholder: {
        id: 'eoc.heartbeats.form.alert-properties-tags-placeholder.no-translate',
        defaultMessage: 'Type and press Enter',
        description: 'Placeholder of tags field.'
    },
    createHeartbeat: {
        id: 'eoc.heartbeats.form.create-heartbeat.no-translate',
        defaultMessage: 'Create heartbeat',
        description: 'Text of create heartbeat button.'
    },
    editHeartbeat: {
        id: 'eoc.heartbeats.form.edit-heartbeat.no-translate',
        defaultMessage: 'Save',
        description: 'Text of edit heartbeat button.'
    }
});
var $4f970d99ba5dd3f6$export$2e2bcd8739ae039 = $4f970d99ba5dd3f6$var$messages;

});

parcelRegister("6TrP1", function(module, exports) {

$parcel$export(module.exports, "NameInput", () => $391e243319e7d32f$export$e1eb8cd79d1ad2f8);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $kY99m = parcelRequire("kY99m");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $5XoGW = parcelRequire("5XoGW");

var $jDgon = parcelRequire("jDgon");
var $iMJ36 = parcelRequire("iMJ36");
var $31kPh = parcelRequire("31kPh");

var $hem2I = parcelRequire("hem2I");

var $69P3Z = parcelRequire("69P3Z");

var $eBqFt = parcelRequire("eBqFt");

var $90XDC = parcelRequire("90XDC");

var $l6m1k = parcelRequire("l6m1k");

var $igo9B = parcelRequire("igo9B");
const $391e243319e7d32f$var$SpinnerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    right: `${"var(--ds-space-negative-300, -24px)"}`
});
const $391e243319e7d32f$var$FlexStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
});
const $391e243319e7d32f$export$e1eb8cd79d1ad2f8 = ({ initialValue: initialValue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: data } = (0, $hem2I.default)((0, $90XDC.heartbeatsResource));
    const { validateLoading: validateLoading, isValidateError: isValidateError, handleAsyncValidate: handleAsyncValidate } = (0, $69P3Z.useFormController)();
    const { focusState: focusState } = (0, $eBqFt.useHeartbeatsContext)();
    const { resumeValidation: resumeValidation } = (0, $31kPh.useForm)();
    (0, $hmVmJ.assert)(!!data, new (0, $dH6Pi.AssertionError)('NameInput', 'NameInput component rendered before data is fetched'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDgon.EocField), {
        "aria-required": true,
        name: "name",
        id: "name",
        label: formatMessage((0, $igo9B.default).name),
        isRequired: true,
        initialValue: initialValue,
        validate: (0, $5XoGW.useValidators)([
            (0, $5XoGW.isRequired)(formatMessage((0, $igo9B.default).emptyNameErrorMessage)),
            handleAsyncValidate
        ])
    }, ({ input: input, meta: meta })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $391e243319e7d32f$var$FlexStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            ...input,
            isDisabled: focusState.mode === 'edit',
            autoComplete: "off",
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6m1k.AfterElements), {
                domain: data.heartbeatEmailDomain,
                currentValue: input.value
            }),
            placeholder: formatMessage((0, $igo9B.default).placeholder),
            // This is for fixing the https://github.com/final-form/react-final-form/issues/676
            // It can be removed when final-form is upgraded to 4.20.2
            onBlur: ()=>{
                resumeValidation();
            }
        }), (validateLoading || meta.validating) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $391e243319e7d32f$var$SpinnerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        }))), (meta.touched || meta.dirty) && isValidateError && meta.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMJ36.ErrorMessage), null, meta.error)));
};

});
parcelRegister("5XoGW", function(module, exports) {

$parcel$export(module.exports, "isRequired", () => $fb82f1a21cb63744$export$669b575c90eb8624);
$parcel$export(module.exports, "isMaxCharacterCount", () => $fb82f1a21cb63744$export$979681787ea99873);
$parcel$export(module.exports, "useValidators", () => $fb82f1a21cb63744$export$eeef3a222667930f);
$parcel$export(module.exports, "isValidEmail", () => $fb82f1a21cb63744$export$371e338370561054);
$parcel$export(module.exports, "isValidUrl", () => $fb82f1a21cb63744$export$bef94a5618bf18bf);
$parcel$export(module.exports, "matchesRegex", () => $fb82f1a21cb63744$export$c0225c6191cf5821);

var $koVbs = parcelRequire("koVbs");

var $5cy7c = parcelRequire("5cy7c");
function $fb82f1a21cb63744$export$fce6876652108ab(value) {
    return typeof value === 'undefined';
}
function $fb82f1a21cb63744$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
const $fb82f1a21cb63744$export$7fbbfbca30081d0 = (value)=>{
    const regExp = new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i);
    return regExp.test(value);
};
const $fb82f1a21cb63744$export$8304a22d431f958 = (value)=>{
    try {
        new URL(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $fb82f1a21cb63744$export$a0a81dc3380ce7d3 = (value)=>Number(value).valueOf();
const $fb82f1a21cb63744$export$669b575c90eb8624 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
            if (value === null || typeof value === 'undefined' || value === '') return message ?? formatMessage((0, $5cy7c.messages).requiredMessage);
            if ($fb82f1a21cb63744$export$43bee75e5e14138e(value) && value.length === 0) return message ?? formatMessage((0, $5cy7c.messages).requiredMessage);
        };
const $fb82f1a21cb63744$export$979681787ea99873 = (limit, message)=>({ formatMessage: formatMessage })=>(value)=>$fb82f1a21cb63744$export$fce6876652108ab(value) || value.length <= limit ? undefined : message ?? formatMessage((0, $5cy7c.messages).validMaxLengthMessage);
const $fb82f1a21cb63744$export$eeef3a222667930f = (validators)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (value)=>{
        if (!validators?.length) return;
        return validators.reduce((acc, validator)=>acc.then((error)=>error || validator({
                    formatMessage: formatMessage
                })(value)), Promise.resolve(undefined));
    };
};
const $fb82f1a21cb63744$export$371e338370561054 = (message)=>({ formatMessage: formatMessage })=>(value)=>value === '' || $fb82f1a21cb63744$export$7fbbfbca30081d0(value) ? undefined : message ?? formatMessage((0, $5cy7c.messages).invalidEmailMessage);
const $fb82f1a21cb63744$export$bef94a5618bf18bf = (message)=>({ formatMessage: formatMessage })=>(value)=>$fb82f1a21cb63744$export$fce6876652108ab(value) || value === '' || $fb82f1a21cb63744$export$8304a22d431f958(value) ? undefined : message ?? formatMessage((0, $5cy7c.messages).invalidUrlMessage);
const $fb82f1a21cb63744$export$c0225c6191cf5821 = (regex, message)=>({ formatMessage: formatMessage })=>(value)=>!$fb82f1a21cb63744$export$fce6876652108ab(value) && regex.test(value) ? undefined : formatMessage(message);

});
parcelRegister("5cy7c", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d1058a39353dc677$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d1058a39353dc677$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    requiredMessage: {
        id: `eoc.common.validators.requiredMessage`,
        defaultMessage: `This field is required`,
        description: 'The text will be displayed in required form fields'
    },
    validMaxLengthMessage: {
        id: `eoc.common.validators.validMaxLengthMessage`,
        defaultMessage: `You have exceeded the maximum character limit`,
        description: 'The text will be displayed when maximum length for given text in form fields'
    },
    invalidEmailMessage: {
        id: `eoc.common.validators.invalidEmailMessage`,
        defaultMessage: `Please enter a valid e-mail`,
        description: 'The text will be displayed when given email is invalid in form fields'
    },
    invalidUrlMessage: {
        id: `eoc.common.validators.invalidUrlMessage`,
        defaultMessage: `Please enter a valid url`,
        description: 'The text will be displayed when given url is invalid in form fields'
    }
});

});


parcelRegister("l6m1k", function(module, exports) {

$parcel$export(module.exports, "AfterElements", () => $2866ef7e3790c30d$export$8a0a6b67337dd6fa);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $42CjB = parcelRequire("42CjB");

var $3Fq5M = parcelRequire("3Fq5M");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $c9CNW = parcelRequire("c9CNW");
const $2866ef7e3790c30d$var$ContainerStyles = (0, $8CUq3.xcss)({
    width: 'max-content',
    marginRight: 'space.050'
});
const $2866ef7e3790c30d$var$DomainContainerStyles = (0, $8CUq3.xcss)({
    maxWidth: '300px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $2866ef7e3790c30d$export$8a0a6b67337dd6fa = ({ domain: domain, currentValue: currentValue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const textRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    const [isTruncated, setIsTruncated] = (0, $5uXOq.useState)(false);
    const [copyButtonLabel, setCopyButtonLabel] = (0, $5uXOq.useState)((0, $c9CNW.default).copy);
    (0, $5uXOq.useEffect)(()=>{
        if (textRef.current !== null) {
            const isTextTruncated = textRef.current.scrollWidth > textRef.current.clientWidth;
            if (isTruncated !== isTextTruncated) setIsTruncated(isTextTruncated);
        }
    }, [
        isTruncated
    ]);
    function copyToClipboard() {
        const clipboard = window.navigator.clipboard;
        clipboard.writeText(currentValue + domain).then(()=>{
            setCopyButtonLabel((0, $c9CNW.default).copied);
        });
    }
    const TooltipEl = isTruncated ? (0, $3bDjY.default) : (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment;
    const tooltipProps = isTruncated ? {
        content: domain
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        alignBlock: "center",
        separator: "|"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TooltipEl, tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: textRef,
        xcss: [
            $2866ef7e3790c30d$var$ContainerStyles,
            $2866ef7e3790c30d$var$DomainContainerStyles
        ]
    }, domain)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2866ef7e3790c30d$var$ContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage(copyButtonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        label: formatMessage((0, $c9CNW.default).copyIcon),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
        onClick: (e)=>{
            e.stopPropagation();
            copyToClipboard();
        }
    })))));
};

});
parcelRegister("c9CNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5974270a54ee62b2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $5974270a54ee62b2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    copyIcon: {
        id: 'eoc.heartbeats.name-input.copy-button.no-translate',
        defaultMessage: 'Copy heartbeat name',
        description: 'Icon label inside button.'
    },
    copy: {
        id: `eoc.heartbeats.name-input.copy.no-translate`,
        defaultMessage: 'Copy',
        description: "The text will be displayed at the copy button's tooltip"
    },
    copied: {
        id: `eoc.heartbeats.name-input.copied.no-translate`,
        defaultMessage: 'Copied',
        description: "The text will be displayed at the copy button's tooltip"
    }
});
var $5974270a54ee62b2$export$2e2bcd8739ae039 = $5974270a54ee62b2$export$defe85febe8b728c;

});


parcelRegister("igo9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $1535f4eafbba2caa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $1535f4eafbba2caa$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    name: {
        id: 'eoc.heartbeats.name-input.no-translate',
        defaultMessage: 'Name',
        description: 'Label of the name input field.'
    },
    placeholder: {
        id: 'eoc.heartbeats.name-input-placeholder.no-translate',
        defaultMessage: 'Enter a name',
        description: 'Placeholder of the name input field.'
    },
    emptyNameErrorMessage: {
        id: 'eoc.heartbeats.name-input-error-message.no-translate',
        defaultMessage: 'Heartbeat name can not be empty.',
        description: 'Error text name input field.'
    }
});
var $1535f4eafbba2caa$export$2e2bcd8739ae039 = $1535f4eafbba2caa$export$defe85febe8b728c;

});


parcelRegister("dq1En", function(module, exports) {

$parcel$export(module.exports, "isNumeric", () => $e66a358f4cd94e3a$export$e90fb89750dba83f);
$parcel$export(module.exports, "getIntervalUnitOptions", () => $e66a358f4cd94e3a$export$baf5b3d87459c33);
function $e66a358f4cd94e3a$export$e90fb89750dba83f(input) {
    // https://www.ascii-code.com
    for(let i = 0; i < input.length; i++){
        const ascii = input.charCodeAt(i);
        if (ascii < 48 || ascii > 57) return false;
    }
    return true;
}
function $e66a358f4cd94e3a$export$baf5b3d87459c33() {
    return [
        {
            label: 'minutes',
            value: 'minutes'
        },
        {
            label: 'hours',
            value: 'hours'
        },
        {
            label: 'days',
            value: 'days'
        }
    ];
}

});



parcelRegister("aNseN", function(module, exports) {

$parcel$export(module.exports, "Header", () => $369e62b9da05dc31$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $57MwZ = parcelRequire("57MwZ");

var $1JB21 = parcelRequire("1JB21");

var $hCji4 = parcelRequire("hCji4");
const $369e62b9da05dc31$export$8b251419efc915eb = ({ bottomBar: bottomBar, actionButtons: actionButtons, breadcrumbs: breadcrumbs })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isHorizontalNav = (0, $1JB21.useIsNewNavigation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        breadcrumbs: !isHorizontalNav ? breadcrumbs : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        actions: actionButtons,
        bottomBar: bottomBar
    }, !isHorizontalNav && formatMessage((0, $hCji4.default).title)));
};

});
parcelRegister("hCji4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3632a5ee584aeef8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $3632a5ee584aeef8$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.heartbeats.header.page-header',
        defaultMessage: 'Heartbeats',
        description: 'Page title.'
    }
});
var $3632a5ee584aeef8$export$2e2bcd8739ae039 = $3632a5ee584aeef8$var$messages;

});


parcelRegister("kzba1", function(module, exports) {

$parcel$export(module.exports, "ActionButtons", () => $d543cdfc0726e119$export$88c65d2d98aab183);

var $5uXOq = parcelRequire("5uXOq");

var $bmKPg = parcelRequire("bmKPg");

var $ldJSL = parcelRequire("ldJSL");

var $VSDnB = parcelRequire("VSDnB");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");

var $hem2I = parcelRequire("hem2I");

var $bfQPa = parcelRequire("bfQPa");

var $9w3gY = parcelRequire("9w3gY");

var $90XDC = parcelRequire("90XDC");
const $d543cdfc0726e119$export$88c65d2d98aab183 = ()=>{
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const { data: rights } = (0, $hem2I.default)((0, $90XDC.heartbeatsUserRightsResource));
    (0, $hmVmJ.assert)(!!rights, new (0, $dH6Pi.AssertionError)('ActionButtons', 'User right should be set in parent component, but somehow it is not set.'));
    if (!rights.hasEditRight) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, (teamId || !(0, $VSDnB.fg)('global_heartbeats')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bfQPa.AutoCreateButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9w3gY.CreateButton), null));
};

});

parcelRegister("RYkVo", function(module, exports) {

$parcel$export(module.exports, "BottomBar", () => $421452c265b8d0e1$export$baad9f01dbfd9b39);

var $5uXOq = parcelRequire("5uXOq");

var $kn6nR = parcelRequire("kn6nR");

var $c2ZIb = parcelRequire("c2ZIb");
const $421452c265b8d0e1$export$baad9f01dbfd9b39 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kn6nR.Description), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2ZIb.Filter), null));
};

});
parcelRegister("kn6nR", function(module, exports) {

$parcel$export(module.exports, "Description", () => $d5fa5f587cf9b7e9$export$393edc798c47379d);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $2NMNM = parcelRequire("2NMNM");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $h8yj2 = parcelRequire("h8yj2");

var $dcaj2 = parcelRequire("dcaj2");

var $xNdpE = parcelRequire("xNdpE");

var $a9Nfh = parcelRequire("a9Nfh");

var $eBqFt = parcelRequire("eBqFt");
const $d5fa5f587cf9b7e9$var$ContainerStyles = (0, $8CUq3.xcss)({
    maxWidth: '950px'
});
const $d5fa5f587cf9b7e9$export$393edc798c47379d = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { supportUrls: supportUrls } = (0, $eBqFt.useHeartbeatsContext)();
    const heartbeatsAPIUrl = supportUrls[(0, $a9Nfh.SupportUrlKeys).HEARTBEATS_API];
    const whatAreHeartbeatsUrl = supportUrls[(0, $a9Nfh.OptionalSupportUrlKeys).WHAT_ARE_HEARTBEATS];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d5fa5f587cf9b7e9$var$ContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $xNdpE.default).description,
        values: {
            linkRestApi: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
                    href: heartbeatsAPIUrl,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, msg),
            linkReadMore: (msg)=>whatAreHeartbeatsUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
                    href: whatAreHeartbeatsUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: (e)=>{
                        e.stopPropagation();
                        const event = createAnalyticsEvent({});
                        (0, $h8yj2.fireUIAnalytics)(event, 'link clicked', 'learnMore');
                    }
                }, msg) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcaj2.IPHAnchor), {
                    id: "heartbeats-list-description",
                    requiresDot: true,
                    onClick: (e)=>{
                        e.stopPropagation();
                        const event = createAnalyticsEvent({});
                        (0, $h8yj2.fireUIAnalytics)(event, 'link clicked', 'learnMore');
                    }
                }, msg)
        }
    }));
};

});

parcelRegister("c2ZIb", function(module, exports) {

$parcel$export(module.exports, "Filter", () => $25cbe76d0e20fe30$export$ec91da630f36d5ea);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $h8yj2 = parcelRequire("h8yj2");

var $5OsUW = parcelRequire("5OsUW");

var $1JB21 = parcelRequire("1JB21");

var $eBqFt = parcelRequire("eBqFt");

var $cmi28 = parcelRequire("cmi28");

var $i6QL5 = parcelRequire("i6QL5");

var $10cJx = parcelRequire("10cJx");
const $25cbe76d0e20fe30$export$7d4209ff166fcb41 = [
    {
        label: 'Pending',
        value: 'Pending'
    },
    {
        label: 'Responsive',
        value: 'Responsive'
    },
    {
        label: 'Unresponsive',
        value: 'Unresponsive'
    },
    {
        label: 'Off',
        value: 'Off'
    }
];
const $25cbe76d0e20fe30$export$ec91da630f36d5ea = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { filters: filters } = (0, $eBqFt.useHeartbeatsContext)();
    const isHorizontalNav = (0, $1JB21.useIsNewNavigation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: !isHorizontalNav && $25cbe76d0e20fe30$var$containerStyles,
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10cJx.WrapperTextField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        isCompact: true,
        value: filters.searchText,
        placeholder: formatMessage((0, $cmi28.default).searchPlaceholderText),
        "aria-label": "Filter",
        onChange: (e)=>filters.handleSearchTextChange(e.currentTarget.value),
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'searchField clicked');
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5OsUW.FilterSelect), {
        onChange: (value)=>filters.handleStatusesChange(value),
        onClear: ()=>filters.handleStatusesChange([]),
        value: filters.statuses,
        options: $25cbe76d0e20fe30$export$7d4209ff166fcb41,
        label: formatMessage((0, $cmi28.default).statusLabel),
        "aria-label": formatMessage((0, $cmi28.default).statusAriaLabel),
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i6QL5.Option), {
                option: option
            })
    }));
};
const $25cbe76d0e20fe30$var$containerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.600'
});

});
parcelRegister("5OsUW", function(module, exports) {

$parcel$export(module.exports, "FilterSelect", () => $c758eb47f233848e$export$92fd2cf1e922f57b);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $16T6Y = parcelRequire("16T6Y");

var $eCeGD = parcelRequire("eCeGD");

var $c8Oei = parcelRequire("c8Oei");

var $cgL5K = parcelRequire("cgL5K");

var $dY87H = parcelRequire("dY87H");

var $eLpcr = parcelRequire("eLpcr");

var $7xBHs = parcelRequire("7xBHs");

var $azUyf = parcelRequire("azUyf");

var $HNK4f = parcelRequire("HNK4f");

var $69Tgh = parcelRequire("69Tgh");
const $c758eb47f233848e$export$92fd2cf1e922f57b = function({ onChange: onChange, onClear: onClear, onFullList: onFullList, onRetry: onRetry, onShowMore: onShowMore, onInputChange: onInputChange, options: options, value: selectValue, label: label, isError: isError, isLoading: isLoading, isPaginationLoading: isPaginationLoading, totalCount: totalCount = null, searchThreshold: searchThreshold, onClose: onClose, formatOptionLabel: formatOptionLabel, isFullList: isFullList = false, target: target, onMenuOpen: onMenuOpen, defaultIsOpen: defaultIsOpen, closeMenuOnSelect: closeMenuOnSelect, filterOption: filterOption, 'aria-label': ariaLabel, ariaLiveMessages: ariaLiveMessages, hasNextPage: hasNextPage, components: components, placeholder: placeholder, shouldRenderToParent: shouldRenderToParent, onKeyDown: onKeyDown, isMulti: isMulti }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const ref = (0, $5uXOq.useRef)(null);
    const itemCount = (0, $5uXOq.useMemo)(()=>{
        if (options) return options.flatMap((option)=>option.options).length;
        return 0;
    }, [
        options
    ]);
    const handleInputChange = (newValue, meta)=>{
        if (onInputChange) onInputChange(newValue, meta);
    };
    const value = (0, $HNK4f.cleanValue)(selectValue);
    const hasValue = value?.length > 0;
    const defaultTarget = ({ isOpen: isOpen, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))),
            isSelected: isOpen || hasValue,
            ...triggerProps
        }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), {
            alignItems: "center",
            columnGap: 0.5
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dY87H.Flex), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            weight: "bold"
        }, label, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.StyledValue), null, value[0].label)), value.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), null, "+", value.length - 1)) : label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eLpcr.GenericSelect), {
        ref: ref,
        isMulti: isMulti,
        onKeyDown: onKeyDown,
        searchThreshold: searchThreshold,
        options: options,
        onChange: onChange,
        value: value,
        onInputChange: handleInputChange,
        placeholder: placeholder || formatMessage((0, $69Tgh.default).placeholder),
        target: target ?? defaultTarget,
        isError: isError,
        onRetry: onRetry,
        onShowMore: onShowMore,
        isLoading: isLoading,
        isPaginationLoading: isPaginationLoading,
        formatOptionLabel: formatOptionLabel,
        "aria-label": ariaLabel,
        ariaLiveMessages: ariaLiveMessages,
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7xBHs.Footer), {
            isFullList: isFullList,
            hasValue: hasValue,
            itemCount: itemCount,
            onClear: onClear,
            onFullList: onFullList,
            totalCount: totalCount,
            isLoading: isLoading,
            searchThreshold: searchThreshold
        }),
        hasNextPage: hasNextPage,
        onClose: onClose,
        onMenuOpen: onMenuOpen,
        defaultIsOpen: defaultIsOpen,
        closeMenuOnSelect: closeMenuOnSelect,
        filterOption: filterOption,
        shouldRenderToParent: shouldRenderToParent,
        components: components
    });
};

});
parcelRegister("eLpcr", function(module, exports) {

$parcel$export(module.exports, "GenericSelect", () => $d448dac4dff4f052$export$501d723e84033d70);

var $5uXOq = parcelRequire("5uXOq");

var $itpgN = parcelRequire("itpgN");
var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $bi488 = parcelRequire("bi488");

var $2bzUF = parcelRequire("2bzUF");

var $4xeuB = parcelRequire("4xeuB");
const $d448dac4dff4f052$export$501d723e84033d70 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onChange: onChange, onRetry: onRetry, onShowMore: onShowMore, onInputChange: onInputChange, options: options, value: value, isError: isError, isLoading: isLoading, isPaginationLoading: isPaginationLoading, components: components, target: target, footer: footer, searchThreshold: searchThreshold = 5, placeholder: placeholder, hasNextPage: hasNextPage, onClose: onClose, isInvalid: isInvalid, isDisabled: isDisabled, formatOptionLabel: formatOptionLabel, onMenuOpen: onMenuOpen, isMulti: isMulti = true, closeMenuOnSelect: closeMenuOnSelect = !isMulti, defaultIsOpen: defaultIsOpen, filterOption: filterOption, 'aria-label': ariaLabel, ariaLiveMessages: ariaLiveMessages, shouldRenderToParent: shouldRenderToParent = false, onKeyDown: onKeyDown }, ref)=>{
    const [inputValue, setInputValue] = (0, $5uXOq.useState)('');
    const handleInputChange = (newValue, meta)=>{
        const filteredActions = [
            'set-value',
            'input-blur',
            'menu-close'
        ];
        if (filteredActions.includes(meta.action) && !newValue.length) return;
        setInputValue(newValue);
        if (onInputChange) onInputChange(newValue, meta);
    };
    const handleClose = ()=>{
        setInputValue('');
        if (onClose) onClose();
    };
    // To render the popup next to the trigger element to achieve DOM order
    const popupStrategy = shouldRenderToParent ? 'fixed' : 'absolute';
    const getOptionComponent = ()=>{
        return isMulti ? (0, $itpgN.CheckboxOption) : (0, $bChGW.components).Option;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        ref: ref,
        autoFocus: true,
        isMulti: isMulti,
        onKeyDown: onKeyDown,
        defaultIsOpen: defaultIsOpen,
        searchThreshold: searchThreshold,
        inputValue: inputValue,
        placeholder: placeholder,
        hideSelectedOptions: false,
        controlShouldRenderValue: false,
        backspaceRemovesValue: false,
        closeMenuOnSelect: closeMenuOnSelect,
        cacheOptions: false,
        blurInputOnSelect: false,
        options: options,
        isClearable: false,
        onChange: onChange,
        value: value,
        minMenuWidth: 298,
        onInputChange: handleInputChange,
        filterOption: filterOption,
        label: ariaLabel,
        ariaLiveMessages: ariaLiveMessages,
        target: target,
        formatOptionLabel: formatOptionLabel,
        shouldCloseMenuOnTab: false,
        components: {
            Option: getOptionComponent(),
            Control: $bi488.Control,
            MenuList: $2bzUF.MenuList,
            NoOptionsMessage: $4xeuB.NoOptionsMessage,
            ...components
        },
        footer: footer,
        onClose: handleClose,
        onMenuOpen: onMenuOpen,
        isInvalid: isInvalid,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isPaginationLoading: isPaginationLoading,
        hasNextPage: hasNextPage,
        isError: isError,
        onRetry: onRetry,
        onShowMore: onShowMore,
        popperProps: {
            strategy: popupStrategy
        }
    });
});

});
parcelRegister("bi488", function(module, exports) {

$parcel$export(module.exports, "Control", () => $d612b13d1815f3cd$export$7a7fa4424cb20976);

var $5uXOq = parcelRequire("5uXOq");

var $9bXnK = parcelRequire("9bXnK");
const $d612b13d1815f3cd$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9bXnK.StyledControl), {
        ref: innerRef ?? undefined,
        ...innerProps
    }, children);

});
parcelRegister("9bXnK", function(module, exports) {

$parcel$export(module.exports, "StyledControl", () => $dcdaf9bc681c029b$export$5c7b7f0e517b89f8);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $dcdaf9bc681c029b$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ek74mf0"
})({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    boxShadow: `0 2px 0 ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
    position: 'relative',
    zIndex: 1
});

});


parcelRegister("2bzUF", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $130acce431df5c36$export$d4c4e98c5044dc8);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $eZJjh = parcelRequire("eZJjh");

var $azUyf = parcelRequire("azUyf");

var $afXBB = parcelRequire("afXBB");

var $bBNXO = parcelRequire("bBNXO");

var $lLLCK = parcelRequire("lLLCK");
const $130acce431df5c36$export$d4c4e98c5044dc8 = (props)=>{
    const { selectProps: selectProps } = props;
    /**
	 * the following props are not included in the native MenuList
	 * to pass props to a custom component override without re-rendering,
	 * you must use select props.
	 */ const isLoading = selectProps?.isLoading;
    const isPaginationLoading = selectProps?.isPaginationLoading;
    const onShowMore = selectProps?.onShowMore;
    const hasNextPage = selectProps?.hasNextPage;
    const isError = selectProps?.isError;
    const onRetry = selectProps?.onRetry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, props, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBNXO.LoadingMessage), null), !isLoading && isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $afXBB.ErrorMessage), {
        onRetry: onRetry
    }), !isLoading && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children, isPaginationLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        testId: "pagination-loader"
    })), hasNextPage && !isPaginationLoading && onShowMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLLCK.ShowMoreButton), {
        onShowMore: onShowMore
    })));
};

});
parcelRegister("azUyf", function(module, exports) {

$parcel$export(module.exports, "StyledValue", () => $0c0345aeed72dab8$export$e0f5bb31be8f4e30);
$parcel$export(module.exports, "LoadingWrapper", () => $0c0345aeed72dab8$export$43a792a870d28db2);
$parcel$export(module.exports, "StyledBox", () => $0c0345aeed72dab8$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $0c0345aeed72dab8$export$31ea92f3997410dd);
$parcel$export(module.exports, "InvalidButton", () => $0c0345aeed72dab8$export$332fba2134818c97);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $fVnbM = parcelRequire("fVnbM");


var $bWGt6 = parcelRequire("bWGt6");
const $0c0345aeed72dab8$export$e0f5bb31be8f4e30 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e14s14cg4"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':not(:only-child)': {
        marginRight: "var(--ds-space-050, 4px)"
    },
    marginLeft: "var(--ds-space-050, 4px)",
    maxWidth: `${200}px`,
    textOverflow: 'ellipsis',
    display: 'inline-block',
    overflow: 'hidden'
});
const $0c0345aeed72dab8$export$43a792a870d28db2 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14s14cg3"
})({
    display: 'flex',
    justifyContent: 'center',
    margin: `${"var(--ds-space-075, 6px)"} 0`
});
const $0c0345aeed72dab8$export$d675f139b342d51a = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14s14cg2"
})("align-items:center;display:flex;flex-direction:column;height:", (props)=>props.height ? props.height : 128, "px;justify-content:center;", ({ iconSize: iconSize })=>iconSize ? `svg {
        width: ${iconSize}px;
        height: ${iconSize}px;
      }` : '', ";");
const $0c0345aeed72dab8$export$31ea92f3997410dd = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14s14cg1"
})({
    marginTop: "var(--ds-space-100, 8px)",
    maxWidth: '248px',
    textAlign: 'center',
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
});
const $0c0345aeed72dab8$export$332fba2134818c97 = /*#__PURE__*/ (0, $bWGt6.default)((0, $fVnbM.default), {
    target: "e14s14cg0"
})("color:", `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`, "!important;background-color:", `var(--ds-background-danger-hovered, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`, "!important;&:hover,&:focus{color:", `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`, "!important;background-color:", `var(--ds-background-danger-hovered, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`, "!important;}");

});

parcelRegister("afXBB", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $c80b5882bb6033d0$export$915e9e7bd4f0f96d);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");


var $azUyf = parcelRequire("azUyf");

var $2QHsa = parcelRequire("2QHsa");
const $c80b5882bb6033d0$export$915e9e7bd4f0f96d = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.StyledBox), {
        height: 144
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.StyledBox), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.StyledText), null, formatMessage((0, $2QHsa.default).errorMessage)), onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onRetry,
        // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
        // https://product-fabric.atlassian.net/browse/DSP-19035
        appearance: "link"
    }, formatMessage((0, $2QHsa.default).retryMessage)));
};

});
parcelRegister("2QHsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f15e15e7552421$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f3f15e15e7552421$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        id: 'eoc.alert-list.common.generic-select.menu-list.error-message.error-message',
        defaultMessage: "Couldn't retrieve data",
        description: 'The text for when an error occurs when loading options'
    },
    retryMessage: {
        id: 'eoc.alert-list.common.generic-select.menu-list.error-message.retry-message',
        defaultMessage: 'Click to retry',
        description: 'The text for button to reload options'
    }
});

});


parcelRegister("bBNXO", function(module, exports) {

$parcel$export(module.exports, "LoadingMessage", () => $deabc1cf23eae5de$export$e928a71d039d3102);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eZJjh = parcelRequire("eZJjh");

var $azUyf = parcelRequire("azUyf");

var $kq03R = parcelRequire("kq03R");
const $deabc1cf23eae5de$export$e928a71d039d3102 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.StyledBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.StyledBox), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.StyledText), null, formatMessage((0, $kq03R.default).loadingMessage)));
};

});
parcelRegister("kq03R", function(module, exports) {

$parcel$export(module.exports, "default", () => $007b2e500a6e75c3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $007b2e500a6e75c3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadingMessage: {
        id: 'eoc.alert-list.common.generic-select.menu-list.loading-message.loading-message',
        defaultMessage: 'Loading...',
        description: 'The text for when options are being loaded in dropdown'
    }
});

});


parcelRegister("lLLCK", function(module, exports) {

$parcel$export(module.exports, "ShowMoreButton", () => $d6ceac6a4bb7bde7$export$e41c325c8b11c297);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $fVnbM = parcelRequire("fVnbM");

var $cn2pY = parcelRequire("cn2pY");
const $d6ceac6a4bb7bde7$export$e41c325c8b11c297 = ({ onShowMore: onShowMore })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onShowMore,
        // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
        // https://product-fabric.atlassian.net/browse/DSP-19035
        appearance: "link"
    }, formatMessage((0, $cn2pY.default).showMoreButtonText));
};

});
parcelRegister("cn2pY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1db3eec1d3c9095b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1db3eec1d3c9095b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMoreButtonText: {
        id: 'eoc.alert-list.common.generic-select.menu-list.show-more-button.show-more-button-text',
        defaultMessage: 'Show more',
        description: 'Clicking this button will load more items into the dropdown'
    }
});

});



parcelRegister("4xeuB", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4fdaa8e813217cfe$export$d58b72b7d3c4072c);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dD7Zc = parcelRequire("dD7Zc");


var $azUyf = parcelRequire("azUyf");

var $7ks9w = parcelRequire("7ks9w");
const $4fdaa8e813217cfe$export$d58b72b7d3c4072c = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasInputValue = props.selectProps.inputValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.StyledBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.StyledBox), {
        height: 72,
        iconSize: 36
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "none",
        color: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        LEGACY_size: "xlarge",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azUyf.StyledText), null, hasInputValue ? formatMessage((0, $7ks9w.default).noOptionsMessage) : formatMessage((0, $7ks9w.default).noOptionsWithNoValueMessage)));
};

});
parcelRegister("7ks9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $119c45550bebc3a5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $119c45550bebc3a5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noOptionsMessage: {
        id: 'eoc.alert-list.common.generic-select.no-options-message.no-options-message',
        defaultMessage: "We couldn\u2019t match with what you\u2019ve typed. Check the spelling.",
        description: 'The text for when no matches are found in dropdown'
    },
    noOptionsWithNoValueMessage: {
        id: 'eoc.alert-list.common.generic-select.no-options-message-with-no-value-message.no-options-message',
        defaultMessage: 'Start typing to search.',
        description: 'The text for when no matches are found in dropdown'
    }
});

});



parcelRegister("7xBHs", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $5a2cd81036244f86$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $fVnbM = parcelRequire("fVnbM");

var $5eJyV = parcelRequire("5eJyV");

var $d2k5C = parcelRequire("d2k5C");

var $3XHxb = parcelRequire("3XHxb");
const $5a2cd81036244f86$export$a06f1c675e846f6f = ({ isFullList: isFullList, hasValue: hasValue, onClear: onClear, onFullList: onFullList, itemCount: itemCount, totalCount: totalCount, isLoading: isLoading, isError: isError, searchThreshold: searchThreshold = 5 })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (isLoading || isError) return null;
    const shouldShowPagination = itemCount && totalCount && (totalCount <= searchThreshold || isFullList);
    const shouldShowFooter = hasValue && onClear || !hasValue && !isFullList && onFullList && itemCount || shouldShowPagination;
    if (!shouldShowFooter) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3XHxb.StyledFooter), {
        "data-testid": "footer"
    }, hasValue && onClear && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClear,
        // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
        // https://product-fabric.atlassian.net/browse/DSP-19035
        appearance: "subtle-link"
    }, formatMessage((0, $5eJyV.default).clearSelection)), !hasValue && !isFullList && onFullList && itemCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onFullList,
        // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
        // https://product-fabric.atlassian.net/browse/DSP-19035
        appearance: "subtle-link"
    }, formatMessage((0, $5eJyV.default).showFullList)), shouldShowPagination ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d2k5C.PaginationDetails), {
        itemsCount: itemCount,
        totalCount: totalCount
    }) : '');
};

});
parcelRegister("5eJyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d1c01aa97e26067$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7d1c01aa97e26067$var$messages = (0, $7VHMR.defineMessages)({
    clearSelection: {
        id: `eoc.alert-list.common.generic-select.footer.clear-selection`,
        defaultMessage: 'Clear selection',
        description: 'The label of clear selection button'
    },
    showFullList: {
        id: `eoc.alert-list.common.generic-select.footer.show-full-list`,
        defaultMessage: 'Show full list',
        description: 'The label of show full list button'
    }
});
var $7d1c01aa97e26067$export$2e2bcd8739ae039 = $7d1c01aa97e26067$var$messages;

});

parcelRegister("d2k5C", function(module, exports) {

$parcel$export(module.exports, "PaginationDetails", () => $e08cd3ae91a94a4b$export$33eb0288c0936a84);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $kietM = parcelRequire("kietM");

var $7WCSD = parcelRequire("7WCSD");
const $e08cd3ae91a94a4b$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7WCSD.PaginationDetailsStyled), null, formatMessage((0, $kietM.default).ofTotalCount, {
        itemsCount: itemsCount,
        totalCount: totalCount
    }));
};

});
parcelRegister("kietM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7fa8642e23fc021$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c7fa8642e23fc021$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ofTotalCount: {
        id: 'eoc.alert-list.common.generic-select.footer.pagination-details.of-total-count',
        defaultMessage: '{itemsCount} of {totalCount}',
        description: 'Total count of items.'
    }
});

});

parcelRegister("7WCSD", function(module, exports) {

$parcel$export(module.exports, "PaginationDetailsStyled", () => $a1c82dfd12ed57b3$export$fff9218028c24180);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $a1c82dfd12ed57b3$export$fff9218028c24180 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "ek4z8nc0"
})({
    textAlign: 'right',
    margin: `${"var(--ds-space-075, 6px)"} ${10}px`,
    font: `${"var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"}`,
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
    flex: 1
});

});


parcelRegister("3XHxb", function(module, exports) {

$parcel$export(module.exports, "StyledFooter", () => $0b6575d929edcdb6$export$61905ae62c7860fb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $0b6575d929edcdb6$export$61905ae62c7860fb = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1tii4xk0"
})({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    boxShadow: `0 -2px 0 ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`}`,
    position: 'relative',
    zIndex: 1,
    alignItems: 'center',
    minHeight: '40px',
    boxSizing: 'border-box'
});

});


parcelRegister("HNK4f", function(module, exports) {

$parcel$export(module.exports, "cleanValue", () => $19d02fac2d8e40dc$export$33f062f47f21a01);
function $19d02fac2d8e40dc$var$isArray(arg) {
    return Array.isArray(arg);
}
const $19d02fac2d8e40dc$export$33f062f47f21a01 = (value)=>{
    if ($19d02fac2d8e40dc$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};

});

parcelRegister("69Tgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a2dfe7d7d925117$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4a2dfe7d7d925117$var$messages = (0, $7VHMR.defineMessages)({
    placeholder: {
        id: `eoc.alert-list.common.select.plceholder`,
        defaultMessage: 'Search',
        description: 'The label of input that searchs inside team.'
    }
});
var $4a2dfe7d7d925117$export$2e2bcd8739ae039 = $4a2dfe7d7d925117$var$messages;

});


parcelRegister("cmi28", function(module, exports) {

$parcel$export(module.exports, "default", () => $1221bda55ad728cb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $1221bda55ad728cb$var$messages = (0, $7VHMR.defineMessages)({
    searchPlaceholderText: {
        id: 'eoc.heartbeats.filter.search-placeholder-text.no-translate',
        defaultMessage: 'Search heartbeats',
        description: 'Placeholder text of a search text field.'
    },
    statusLabel: {
        id: 'eoc.heartbeats.filter.filter-placeholder-text.no-translate',
        defaultMessage: 'Status',
        description: 'Label text of a status dropdown field.'
    },
    statusAriaLabel: {
        id: 'eoc.heartbeats.filter.filter-placeholder-text.no-translate',
        defaultMessage: 'Select status',
        description: 'Aria label text of a status dropdown field.'
    }
});
var $1221bda55ad728cb$export$2e2bcd8739ae039 = $1221bda55ad728cb$var$messages;

});

parcelRegister("i6QL5", function(module, exports) {

$parcel$export(module.exports, "Option", () => $73595949582bd05a$export$36d18380658d5d20);

var $5uXOq = parcelRequire("5uXOq");

var $lytIi = parcelRequire("lytIi");
const $73595949582bd05a$export$36d18380658d5d20 = ({ option: option })=>{
    switch(option.value){
        case 'Pending':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lytIi.PendingStatus), null);
        case 'Responsive':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lytIi.ResponsiveStatus), null);
        case 'Unresponsive':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lytIi.UnresponsiveStatus), null);
        case 'Off':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lytIi.OffStatus), null);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    }
};

});

parcelRegister("10cJx", function(module, exports) {

$parcel$export(module.exports, "WrapperTextField", () => $113c10dd64499ea6$export$c927d415428a8196);

var $bWGt6 = parcelRequire("bWGt6");
function $113c10dd64499ea6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $113c10dd64499ea6$export$c927d415428a8196 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "egliwc30"
})({
    name: "1tpdvqq",
    styles: "width:240px"
});

});



parcelRegister("1li9a", function(module, exports) {

$parcel$export(module.exports, "List", () => $2dbfb67f0bcdadb3$export$54c2e3dc7acea9f5);

var $5uXOq = parcelRequire("5uXOq");

var $3jBDv = parcelRequire("3jBDv");

var $koVbs = parcelRequire("koVbs");

var $bmKPg = parcelRequire("bmKPg");

var $k3qRI = parcelRequire("k3qRI");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $VSDnB = parcelRequire("VSDnB");

var $awLan = parcelRequire("awLan");

var $ikN1y = parcelRequire("ikN1y");

var $aSfpo = parcelRequire("aSfpo");

var $34X01 = parcelRequire("34X01");

var $5AXpX = parcelRequire("5AXpX");

var $jrQLn = parcelRequire("jrQLn");

var $mfkbx = parcelRequire("mfkbx");

var $eBqFt = parcelRequire("eBqFt");

var $7mCor = parcelRequire("7mCor");

var $hueR6 = parcelRequire("hueR6");

var $ewKxY = parcelRequire("ewKxY");

var $hTHJX = parcelRequire("hTHJX");

var $2iYCT = parcelRequire("2iYCT");

var $3pHgf = parcelRequire("3pHgf");
const $2dbfb67f0bcdadb3$export$54c2e3dc7acea9f5 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { heartbeats: heartbeats, timezone: timezone } = (0, $mfkbx.useListController)();
    const { focusState: focusState, isTransitioning: isTransitioning } = (0, $eBqFt.useHeartbeatsContext)();
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const { isDeleteModalOpen: isDeleteModalOpen, handleDelete: handleDelete, handleDeleteClick: handleDeleteClick, isDeleting: isDeleting, handleModalClose: handleDeleteModalClose } = (0, $jrQLn.useDeleteModalController)();
    const { handleSwitchClick: handleSwitchClick, handleSwitch: handleSwitch, isSwitchModalOpen: isSwitchModalOpen, isSwitchLoading: isSwitchLoading, handleModalClose: handleSwitchModalClose } = (0, $7mCor.useSwitchController)();
    const head = (0, $5uXOq.useMemo)(()=>({
            cells: [
                {
                    key: 'name',
                    content: formatMessage((0, $ewKxY.default).name),
                    isSortable: true
                },
                {
                    key: 'last-pinged',
                    content: formatMessage((0, $ewKxY.default).lastPinged),
                    isSortable: true
                },
                {
                    key: 'next-ping',
                    content: formatMessage((0, $ewKxY.default).nextPing),
                    isSortable: true
                },
                ...!teamId && (0, $VSDnB.fg)('global_heartbeats') ? [
                    {
                        key: 'owner-team',
                        content: formatMessage((0, $ewKxY.default).teams)
                    }
                ] : [],
                {
                    key: 'status',
                    content: formatMessage((0, $ewKxY.default).status)
                },
                {
                    key: 'more',
                    content: formatMessage((0, $ewKxY.default).actions)
                }
            ]
        }), [
        formatMessage,
        teamId
    ]);
    const rows = (0, $5uXOq.useMemo)(()=>{
        return heartbeats.map((heartbeat, index)=>{
            const { name: name, lastReceivedAt: lastReceivedAt, willExpireAt: willExpireAt, status: status, ownerTeamId: ownerTeamId } = heartbeat;
            return {
                key: `row-${index}-${name}`,
                onClick: ()=>focusState.open({
                        data: heartbeat,
                        mode: 'view'
                    }),
                cells: [
                    {
                        key: `cell-${index}-${name}`,
                        content: name
                    },
                    {
                        key: `cell-${index}-${lastReceivedAt}`,
                        content: (0, $awLan.MIN_DATE_SHOWN_EPOCH) <= lastReceivedAt && lastReceivedAt <= (0, $5AXpX.getMaxAvailableEpoch)() ? (0, $3jBDv.default)(new Date(lastReceivedAt), timezone, 'MMM d h:mm a') : '-'
                    },
                    {
                        key: `cell-${index}-${willExpireAt}`,
                        content: (0, $awLan.MIN_DATE_SHOWN_EPOCH) <= willExpireAt && willExpireAt <= (0, $5AXpX.getMaxAvailableEpoch)() ? (0, $3jBDv.default)(new Date(willExpireAt), timezone, 'MMM d h:mm a') : '-'
                    },
                    ...!teamId && (0, $VSDnB.fg)('global_heartbeats') ? [
                        {
                            key: `cell-${index}-${ownerTeamId}`,
                            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3pHgf.Team), {
                                ownerTeamId: ownerTeamId
                            })
                        }
                    ] : [],
                    {
                        key: `cell-${index}-${status}`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aSfpo.HeartbeatStatus), {
                            heartbeat: heartbeat,
                            isTransitioning: isTransitioning
                        })
                    },
                    {
                        key: `cell-${index}-more`,
                        content: index === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                            name: (0, $awLan.SPOTLIGHT_NAMES).actions
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hueR6.Action), {
                            heartbeat: heartbeat,
                            onDeleteClick: ()=>handleDeleteClick(heartbeat),
                            onSwitchClick: ()=>handleSwitchClick(heartbeat)
                        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hueR6.Action), {
                            heartbeat: heartbeat,
                            onDeleteClick: ()=>handleDeleteClick(heartbeat),
                            onSwitchClick: ()=>handleSwitchClick(heartbeat)
                        })
                    }
                ]
            };
        });
    }, [
        focusState,
        handleDeleteClick,
        handleSwitchClick,
        heartbeats,
        isTransitioning,
        teamId,
        timezone
    ]);
    if (rows.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTHJX.NoSearchResultEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2iYCT.DynamicTableWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3qRI.default), {
        head: head,
        rows: rows,
        isFixedSize: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikN1y.DeleteModal), {
        onDeleteAttemptCancel: handleDeleteModalClose,
        onDelete: handleDelete,
        isLoading: isDeleting,
        isDeleteDialogOpen: isDeleteModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34X01.SwitchModal), {
        onSwitchAttemptCancel: handleSwitchModalClose,
        onSwitch: handleSwitch,
        isLoading: isSwitchLoading,
        isSwitchDialogOpen: isSwitchModalOpen
    }));
};

});
parcelRegister("k3qRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e4f0159aa1c87c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $gS5Cm = parcelRequire("gS5Cm");

var $dHbUn = parcelRequire("dHbUn");
class $60e4f0159aa1c87c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $eGmKJ.default),
            onSort: (0, $eGmKJ.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHbUn.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $gS5Cm.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("gS5Cm", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $7f55105045703159$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $7f55105045703159$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $7f55105045703159$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $7f55105045703159$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $7f55105045703159$export$c476bbe5da59992d);
const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("dHbUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6422faa785b221$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");


var $gS5Cm = parcelRequire("gS5Cm");

var $hiWL0 = parcelRequire("hiWL0");

var $kF3yx = parcelRequire("kF3yx");

var $fkvnY = parcelRequire("fkvnY");

var $hK8cd = parcelRequire("hK8cd");

var $dDBI6 = parcelRequire("dDBI6");

var $dk72m = parcelRequire("dk72m");

var $50Tma = parcelRequire("50Tma");

var $jlnvO = parcelRequire("jlnvO");
function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
            return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
        case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
            return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $eGmKJ.default), onSort: providedOnSort = (0, $eGmKJ.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $eGmKJ.default), onRankEnd: providedOnRankEnd = (0, $eGmKJ.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
    const tableBodyRef = (0, $5uXOq.useRef)(null);
    const onSort = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $5uXOq.useEffect)(()=>{
        (0, $gS5Cm.validateSortKey)(sortKey, head);
        (0, $gS5Cm.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $gS5Cm.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kF3yx.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kF3yx.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dk72m.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hiWL0.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hiWL0.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlnvO.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hiWL0.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50Tma.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dDBI6.default), {
        isLoading: isLoading,
        spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $cb6422faa785b221$var$RankableTableBody = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("8DmN8")));
const $cb6422faa785b221$var$TableBody = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fkvnY.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hK8cd.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;

});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;

parcelRegister("hiWL0", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $54lmm = parcelRequire("54lmm");
function $3b29b0d00cd7b5c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $3b29b0d00cd7b5c6$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $3b29b0d00cd7b5c6$var$bodyBorder = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $54lmm.tableBorder).borderColor}`
});
const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $54lmm.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $54lmm.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $54lmm.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $54lmm.row).focusOutline
        },
        css: [
            $3b29b0d00cd7b5c6$var$tableStyles,
            isFixedSize && $3b29b0d00cd7b5c6$var$fixedSizeTableStyles,
            hasDataRow && $3b29b0d00cd7b5c6$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $3b29b0d00cd7b5c6$var$captionStyles = {
    name: "h9a27i",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
};
const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("caption", {
        css: $3b29b0d00cd7b5c6$var$captionStyles
    }, children);
const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $3b29b0d00cd7b5c6$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("54lmm", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $b728acac6d8ee4bc$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $b728acac6d8ee4bc$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $b728acac6d8ee4bc$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $b728acac6d8ee4bc$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $b728acac6d8ee4bc$export$38d703b73e2cf64d);

const $b728acac6d8ee4bc$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $b728acac6d8ee4bc$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
};
const $b728acac6d8ee4bc$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
};
const $b728acac6d8ee4bc$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
};
const $b728acac6d8ee4bc$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
};

});


parcelRegister("kF3yx", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $0852c529eaab7231$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $0852c529eaab7231$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $0852c529eaab7231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0852c529eaab7231$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0852c529eaab7231$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $0852c529eaab7231$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $0852c529eaab7231$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("fkvnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $32bba7afdbc8736a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7bJDt = parcelRequire("7bJDt");

var $ggqAE = parcelRequire("ggqAE");
class $32bba7afdbc8736a$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ggqAE.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $32bba7afdbc8736a$var$Body = (0, $7bJDt.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($32bba7afdbc8736a$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;

});
parcelRegister("7bJDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6eeecb3dc05edd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $gS5Cm = parcelRequire("gS5Cm");
const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $gS5Cm.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $gS5Cm.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("ggqAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $136b57fea50cecd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1g0dL = parcelRequire("1g0dL");

var $d9WgS = parcelRequire("d9WgS");
const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9WgS.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1g0dL.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;

});
parcelRegister("1g0dL", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $11c3ea74eda01ab8$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $9GQPi = parcelRequire("9GQPi");
const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $9GQPi.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $9GQPi.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $9GQPi.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $9GQPi.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("9GQPi", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $99c9652c1fab2b08$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $99c9652c1fab2b08$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $99c9652c1fab2b08$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $99c9652c1fab2b08$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $99c9652c1fab2b08$export$f7913df521f684e2);

var $f8Sb3 = parcelRequire("f8Sb3");
function $99c9652c1fab2b08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $99c9652c1fab2b08$export$708a733455f59a29 = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: `var(${$99c9652c1fab2b08$var$CSS_VAR_WIDTH})`
});
const $99c9652c1fab2b08$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $99c9652c1fab2b08$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $99c9652c1fab2b08$export$f7913df521f684e2 = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("d9WgS", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $ba9cb59faf06ce7f$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $hiWL0 = parcelRequire("hiWL0");
const $ba9cb59faf06ce7f$var$rowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $ba9cb59faf06ce7f$var$rowBackgroundStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $hiWL0.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $ba9cb59faf06ce7f$var$rowStyles,
            isHighlighted ? $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles : $ba9cb59faf06ce7f$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("hK8cd", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $883137116243a6a0$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $883137116243a6a0$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("dDBI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4b90b361173610$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $lLAKY = parcelRequire("lLAKY");
class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLAKY.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLAKY.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLAKY.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("lLAKY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d0e2766ad96d94ad$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $d0e2766ad96d94ad$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $d0e2766ad96d94ad$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $f8Sb3 = parcelRequire("f8Sb3");
function $d0e2766ad96d94ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
const $d0e2766ad96d94ad$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d0e2766ad96d94ad$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $d0e2766ad96d94ad$var$contentsContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: `var(${$d0e2766ad96d94ad$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $d0e2766ad96d94ad$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $d0e2766ad96d94ad$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d0e2766ad96d94ad$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("dk72m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba39c903b39a83b1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");


var $4xXH4 = parcelRequire("4xXH4");
class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xXH4.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xXH4.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xXH4.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("4xXH4", function(module, exports) {

$parcel$export(module.exports, "Container", () => $48301faf1109874f$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $48301faf1109874f$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $48301faf1109874f$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $48301faf1109874f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $48301faf1109874f$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $48301faf1109874f$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $48301faf1109874f$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $48301faf1109874f$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $48301faf1109874f$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $48301faf1109874f$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $48301faf1109874f$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $48301faf1109874f$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("50Tma", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d5ee5c6331aeb9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $xBgAj = parcelRequire("xBgAj");
class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xBgAj.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_1yt4ze3t _18s8ze3t",
    paginationMenuItem: "_1pfhze3t",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))) : (0, (/*@__PURE__*/$parcel$interopDefault($6s76W)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15F6T.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBW9.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $8aaadfaafd170b3c$var$styles.paginationMenu
    }, (0, $gRWrA.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBW9.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6122da5228d1f3e4cce8be42702737a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("c0aEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed572e62fc5b1cd0$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $ed572e62fc5b1cd0$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $ed572e62fc5b1cd0$var$Separator = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            $ed572e62fc5b1cd0$var$styles.separator
        ])
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $ed572e62fc5b1cd0$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5uXOq.createElement($ed572e62fc5b1cd0$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $ed572e62fc5b1cd0$var$styles.hug, grow === 'fill' && $ed572e62fc5b1cd0$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$ed572e62fc5b1cd0$var$Inline.displayName = 'Inline';
var $ed572e62fc5b1cd0$export$2e2bcd8739ae039 = $ed572e62fc5b1cd0$var$Inline;

});
parcelRegister("bUmQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ccb72b8ddc20b7$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0ccb72b8ddc20b7$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $d0ccb72b8ddc20b7$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $d0ccb72b8ddc20b7$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $d0ccb72b8ddc20b7$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $d0ccb72b8ddc20b7$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $d0ccb72b8ddc20b7$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $d0ccb72b8ddc20b7$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $d0ccb72b8ddc20b7$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $d0ccb72b8ddc20b7$var$styles.root,
            gap && $d0ccb72b8ddc20b7$var$columnGapMap[gap],
            columnGap && $d0ccb72b8ddc20b7$var$columnGapMap[columnGap],
            gap && $d0ccb72b8ddc20b7$var$rowGapMap[gap],
            rowGap && $d0ccb72b8ddc20b7$var$rowGapMap[rowGap],
            alignItems && $d0ccb72b8ddc20b7$var$alignItemsMap[alignItems],
            direction && $d0ccb72b8ddc20b7$var$flexDirectionMap[direction],
            justifyContent && $d0ccb72b8ddc20b7$var$justifyContentMap[justifyContent],
            wrap && $d0ccb72b8ddc20b7$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$d0ccb72b8ddc20b7$var$Flex.displayName = 'Flex';
var $d0ccb72b8ddc20b7$export$2e2bcd8739ae039 = $d0ccb72b8ddc20b7$var$Flex;

});


parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});



parcelRegister("jlnvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $097ee65829e33b82$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $gS5Cm = parcelRequire("gS5Cm");

var $9Ooyy = parcelRequire("9Ooyy");

var $a41RA = parcelRequire("a41RA");

var $7gEwE = parcelRequire("7gEwE");

var $dpXLF = parcelRequire("dpXLF");

var $BQUUh = parcelRequire("BQUUh");
class $097ee65829e33b82$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $gS5Cm.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $gS5Cm.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponentOld = isRankable ? (0, $7gEwE.default) : (0, $BQUUh.default);
        const HeadCellComponent = isRankable ? (0, $a41RA.default) : (0, $dpXLF.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ooyy.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
            const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            const headCellId = `head-cell-${index}`;
            const handleClick = ()=>{
                this.setState({
                    activeSortButtonId: headCellId
                });
                if (isSortable) onSort(cell)();
            };
            return (0, $VSDnB.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isIconOnlyHeader: isIconOnlyHeader,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                headCellId: headCellId,
                activeSortButtonId: activeSortButtonId,
                onClick: handleClick,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ascendingSortTooltip: ascendingSortTooltip,
                descendingSortTooltip: descendingSortTooltip,
                buttonAriaRoleDescription: buttonAriaRoleDescription,
                ...restCellProps
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeadCellComponentOld, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;

});
parcelRegister("9Ooyy", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e002e0403dc403bb$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e002e0403dc403bb$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");



var $54lmm = parcelRequire("54lmm");

var $9GQPi = parcelRequire("9GQPi");
function $e002e0403dc403bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e002e0403dc403bb$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $e002e0403dc403bb$var$headStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderBlockEnd: `none`
});
const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("thead", {
        css: [
            $e002e0403dc403bb$var$headStyles,
            isRanking && $e002e0403dc403bb$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $e002e0403dc403bb$var$headCellBaseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $54lmm.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'middle',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e002e0403dc403bb$var$headCellBaseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $54lmm.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e002e0403dc403bb$var$onClickStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $e002e0403dc403bb$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $54lmm.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $54lmm.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $54lmm.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $54lmm.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $54lmm.MSThemeColors).Text}`
            }
        }
    }
});
const $e002e0403dc403bb$var$ascendingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $54lmm.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $54lmm.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e002e0403dc403bb$var$descendingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $54lmm.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $54lmm.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e002e0403dc403bb$export$4e8024263ace498b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $9GQPi.getTruncationStyleVars)({
            width: width
        }),
        [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: (0, $54lmm.head).textColor
    };
    const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    const isVisuallyRefreshed = (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9GQPi.cellStyles),
            isVisuallyRefreshed ? $e002e0403dc403bb$var$headCellBaseStyles : $e002e0403dc403bb$var$headCellBaseStylesOld,
            !isVisuallyRefreshed && onClick && $e002e0403dc403bb$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9GQPi.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $9GQPi.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $9GQPi.overflowTruncateStyles),
            !isVisuallyRefreshed && isSortable && $e002e0403dc403bb$var$baseStyles,
            !isVisuallyRefreshed && isASC && $e002e0403dc403bb$var$ascendingStyles,
            !isVisuallyRefreshed && isDESC && $e002e0403dc403bb$var$descendingStyles
        ],
        onClick: !isVisuallyRefreshed ? onClick : undefined,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("a41RA", function(module, exports) {

$parcel$export(module.exports, "default", () => $669a06e89a9827f7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $dpXLF = parcelRequire("dpXLF");
class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpXLF.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $669a06e89a9827f7$var$RankableTableHeadCell = (0, $cVljL.default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;

});
parcelRegister("cVljL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e49a9b167764eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dpXLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c80f4a483cfd6a$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cC5ib = parcelRequire("cC5ib");

var $kcHZS = parcelRequire("kcHZS");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");
var $3Lty3 = parcelRequire("3Lty3");
var $dS3PR = parcelRequire("dS3PR");

var $3bDjY = parcelRequire("3bDjY");


var $9Ooyy = parcelRequire("9Ooyy");
const $d9c80f4a483cfd6a$var$styles = {
    buttonWrapper: "_1yt4ze3t _1e0c1txw _bfhk18uv _4cvr1h6o _d0altlke",
    sortIconHiddenWrapper: "_1yt41b66 _1e0c1txw _tzy4idpf _bfhk18uv _1h7hkb7n",
    sortIconVisibleWrapper: "_1yt41b66 _1e0c1txw _tzy4kb7n _bfhk18uv",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $d9c80f4a483cfd6a$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o"
};
const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $d9c80f4a483cfd6a$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lty3.default), {
        onClick: onClick,
        xcss: $d9c80f4a483cfd6a$var$styles.buttonWrapper,
        "aria-roledescription": buttonAriaRoleDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        xcss: isVisibleIconOnlyHeader ? $d9c80f4a483cfd6a$var$styles.hideIconHeaderWrapper : $d9c80f4a483cfd6a$var$styles.visibleHeaderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtle",
        weight: "bold",
        maxLines: 1
    }, content)), shouldRenderSortIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        xcss: isSortIconVisible ? $d9c80f4a483cfd6a$var$styles.sortIconVisibleWrapper : $d9c80f4a483cfd6a$var$styles.sortIconHiddenWrapper
    }, sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcHZS))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && `${testId}--up--icon`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cC5ib))), {
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        testId: testId && `${testId}--down--icon`
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder
    }, isSortable ? visuallyRefreshedButton : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::980468f720de67e44e700795aed02102>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1v12.75m-5-4.5 5 5 5-5"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::656cb3b07e22a80c807b482f8fbbfa44>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});

parcelRegister("3Lty3", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eb08f4038c94d3$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $6wxJn = parcelRequire("6wxJn");

var $a1dy0 = parcelRequire("a1dy0");
const $70eb08f4038c94d3$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $70eb08f4038c94d3$var$Pressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $eGmKJ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ $5uXOq.createElement((0, $a1dy0.default // @ts-expect-error we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- TODO: Properly type this and allow pass-through if we can determine the type
        ,
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $DEWI6.cx)($70eb08f4038c94d3$var$styles.root, isDisabled && $70eb08f4038c94d3$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }, children);
});
var $70eb08f4038c94d3$export$2e2bcd8739ae039 = $70eb08f4038c94d3$var$Pressable;

});



parcelRegister("7gEwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $5uXOq = parcelRequire("5uXOq");

var $cVljL = parcelRequire("cVljL");

var $gS5Cm = parcelRequire("gS5Cm");

var $BQUUh = parcelRequire("BQUUh");
class $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $gS5Cm.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BQUUh.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld = (0, $cVljL.default)($5fc2a0c6e4ccfbc5$var$RankableTableHeadCellComponentOld);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5fc2a0c6e4ccfbc5$export$2e2bcd8739ae039 = $5fc2a0c6e4ccfbc5$var$RankableTableHeadCellOld;

});
parcelRegister("BQUUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd2f57a58531c0d$export$2e2bcd8739ae039);
// Delete this file when cleaning up platform-component-visual-refresh FG

var $5uXOq = parcelRequire("5uXOq");

var $9Ooyy = parcelRequire("9Ooyy");
const $4bd2f57a58531c0d$var$TableHeadCellOld = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ooyy.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4bd2f57a58531c0d$export$2e2bcd8739ae039 = $4bd2f57a58531c0d$var$TableHeadCellOld;

});



parcelRegister("8DmN8", function(module, exports) {

let $6493a52e1cae0609$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6493a52e1cae0609$var$load("cM9em"),
    $6493a52e1cae0609$var$load("fr9NE"),
    $6493a52e1cae0609$var$load("bz1jP")
]).then(()=>parcelRequire('4THp8'));

});



parcelRegister("mfkbx", function(module, exports) {

$parcel$export(module.exports, "useListController", () => $b026baabd706f021$export$b430d72535914a9c);

var $5uXOq = parcelRequire("5uXOq");

var $jxRF2 = parcelRequire("jxRF2");

var $hem2I = parcelRequire("hem2I");

var $90XDC = parcelRequire("90XDC");

var $eBqFt = parcelRequire("eBqFt");
const $b026baabd706f021$export$b430d72535914a9c = ()=>{
    const { filters: filters } = (0, $eBqFt.useHeartbeatsContext)();
    const { data: data } = (0, $hem2I.default)((0, $90XDC.heartbeatsResource));
    const { data: user } = (0, $hem2I.default)((0, $jxRF2.eocUserResource));
    const timezone = (0, $5uXOq.useMemo)(()=>user?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone, [
        user?.timeZone
    ]);
    const heartbeats = (0, $5uXOq.useMemo)(()=>{
        let list = data?.heartbeats || [];
        if (filters.searchText) {
            const searchValue = filters.searchText.toLowerCase();
            list = list.filter((item)=>item.name.toLowerCase().includes(searchValue));
        }
        if (filters.statuses.length) list = list.filter((item)=>filters.statuses.some((option)=>option.value === item.status));
        return list;
    }, [
        data,
        filters
    ]);
    return {
        timezone: timezone,
        heartbeats: heartbeats
    };
};

});

parcelRegister("hueR6", function(module, exports) {

$parcel$export(module.exports, "Action", () => $b872d24aabcd7270$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $bWn3s = parcelRequire("bWn3s");

var $2NMNM = parcelRequire("2NMNM");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $h8yj2 = parcelRequire("h8yj2");

var $hmVmJ = parcelRequire("hmVmJ");
var $dH6Pi = parcelRequire("dH6Pi");
var $8eCQi = parcelRequire("8eCQi");

var $2tKfK = parcelRequire("2tKfK");

var $hem2I = parcelRequire("hem2I");

var $eBqFt = parcelRequire("eBqFt");

var $90XDC = parcelRequire("90XDC");

var $a6q38 = parcelRequire("a6q38");
const $b872d24aabcd7270$var$ContainerStyles = (0, $8CUq3.xcss)({
    width: 'fit-content'
});
const $b872d24aabcd7270$export$e19cd5f9376f8cee = ({ heartbeat: heartbeat, onDeleteClick: onDeleteClick, onSwitchClick: onSwitchClick })=>{
    const { focusState: focusState } = (0, $eBqFt.useHeartbeatsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: rights } = (0, $hem2I.default)((0, $90XDC.heartbeatsUserRightsResource));
    const flagApi = (0, $2tKfK.default)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dropdownButtonRef = (0, $5uXOq.useRef)(null);
    function copyToClipboard() {
        const { clipboard: clipboard } = window.navigator;
        clipboard.writeText(heartbeat.heartbeatEmailAddress).then(()=>{
            flagApi.showFlag({
                ...(0, $8eCQi.successToastProps)(),
                title: formatMessage((0, $a6q38.default).copySuccess)
            });
        });
    }
    (0, $hmVmJ.assert)(!!rights, new (0, $dH6Pi.AssertionError)('Action', 'User right should be set in parent component, but somehow it is not set.'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onClick: (e)=>e.stopPropagation(),
        xcss: $b872d24aabcd7270$var$ContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                label: formatMessage((0, $a6q38.default).moreAriaLabel, {
                    name: heartbeat.name
                }),
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
                ref: (0, $bWn3s.mergeRefs)([
                    triggerRef,
                    dropdownButtonRef
                ]),
                appearance: "subtle"
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: copyToClipboard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $a6q38.default).copy)), rights.hasEditRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            const event = createAnalyticsEvent({});
            (0, $h8yj2.fireUIAnalytics)(event, 'button clicked', 'dropdownMenuEditButton');
            focusState.open({
                data: heartbeat,
                mode: 'edit',
                returnRef: dropdownButtonRef
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $a6q38.default).edit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: ()=>{
            focusState.open({
                data: {
                    ...heartbeat,
                    name: ''
                },
                mode: 'duplicate',
                returnRef: dropdownButtonRef
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $a6q38.default).duplicate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onSwitchClick
    }, heartbeat.status === 'Off' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $a6q38.default).turnon) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $a6q38.default).turnoff))), rights.hasDeleteRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onDeleteClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $a6q38.default).delete)))));
};

});
parcelRegister("a6q38", function(module, exports) {

$parcel$export(module.exports, "default", () => $4563847c41b6eb50$export$2e2bcd8739ae039);
const $4563847c41b6eb50$var$messages = {
    edit: {
        id: 'eoc.heartbeats.table-actions.edit.no-translate',
        defaultMessage: 'Edit',
        description: 'Text of edit action button applied on a heartbeat.'
    },
    duplicate: {
        id: 'eoc.heartbeats.table-actions.duplicate.no-translate',
        defaultMessage: 'Duplicate',
        description: 'Text of duplicate action button applied on a heartbeat.'
    },
    turnon: {
        id: 'eoc.heartbeats.table-actions.turnon.no-translate',
        defaultMessage: 'Turn on',
        description: 'Text of turn-on action button applied on a heartbeat.'
    },
    turnoff: {
        id: 'eoc.heartbeats.table-actions.turnoff.no-translate',
        defaultMessage: 'Turn off',
        description: 'Text of turn-off action button applied on a heartbeat.'
    },
    delete: {
        id: 'eoc.heartbeats.table-actions.delete.no-translate',
        defaultMessage: 'Delete',
        description: 'Text of delete action button applied on a heartbeat.'
    },
    copy: {
        id: `eoc.heartbeats.table-actions.copy.no-translate`,
        defaultMessage: 'Copy heartbeat name',
        description: "The text will be displayed at the copy button's tooltip"
    },
    copySuccess: {
        id: `eoc.heartbeats.table-actions.copySuccess.no-translate`,
        defaultMessage: 'Heartbeat name copied sucessfully!',
        description: "The text will be displayed at the copy button's tooltip"
    },
    moreAriaLabel: {
        id: `eoc.heartbeats.table-actions.moreAriaLabel.no-translate`,
        defaultMessage: 'More actions for {name}',
        description: 'The aria label of more button'
    }
};
var $4563847c41b6eb50$export$2e2bcd8739ae039 = $4563847c41b6eb50$var$messages;

});


parcelRegister("ewKxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd3db180d66ec847$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $dd3db180d66ec847$var$messages = (0, $7VHMR.defineMessages)({
    name: {
        id: 'eoc.heartbeats.list.table-header.name.no-translate',
        defaultMessage: 'Name',
        description: 'Table header of name column'
    },
    lastPinged: {
        id: 'eoc.heartbeats.list.table-header.last-pinged.no-translate',
        defaultMessage: 'Last pinged',
        description: 'Table header of last pinged column'
    },
    nextPing: {
        id: 'eoc.heartbeats.list.table-header.next-ping.no-translate',
        defaultMessage: 'Next ping',
        description: 'Table header of next ping column'
    },
    teams: {
        id: 'eoc.heartbeats.list.table-header.owner-team.no-translate',
        defaultMessage: 'Teams',
        description: 'Table header of owner team column.'
    },
    status: {
        id: 'eoc.heartbeats.list.table-header.status.no-translate',
        defaultMessage: 'Status',
        description: 'Table header of status column'
    },
    actions: {
        id: 'eoc.heartbeats.list.table-header.actions.no-translate',
        defaultMessage: 'Actions',
        description: 'Table header of actions column'
    }
});
var $dd3db180d66ec847$export$2e2bcd8739ae039 = $dd3db180d66ec847$var$messages;

});

parcelRegister("hTHJX", function(module, exports) {

$parcel$export(module.exports, "NoSearchResultEmptyState", () => $cd5e907edd0e6085$export$c39742fe4871dc83);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $hTEpF = parcelRequire("hTEpF");

var $dBFxd = parcelRequire("dBFxd");

var $vk73z = parcelRequire("vk73z");
const $cd5e907edd0e6085$export$c39742fe4871dc83 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $vk73z.default).title),
        description: formatMessage((0, $vk73z.default).description),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dBFxd.CustomSVG), null),
        width: "wide"
    });
};

});
parcelRegister("dBFxd", function(module, exports) {

$parcel$export(module.exports, "CustomSVG", () => $c391aaf52d1a290b$export$59357636fba1f8da);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $c391aaf52d1a290b$var$boxStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});
const $c391aaf52d1a290b$export$59357636fba1f8da = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c391aaf52d1a290b$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "174",
        height: "159",
        viewBox: "0 0 174 159",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_1032_107356)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "174",
        height: "159",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M88.4279 158.958C87.6467 158.983 86.8656 159 86.0845 159.008C84.9926 159.017 84.1022 158.137 84.1022 157.049C84.0938 155.985 84.9422 155.106 86.0089 155.073C86.0257 155.073 86.0509 155.073 86.0677 155.073C91.0485 155.047 96.1048 154.511 100.968 153.481C102.035 153.255 103.085 153.934 103.311 154.997C103.538 156.061 102.858 157.107 101.791 157.334C97.4151 158.246 92.9215 158.799 88.4279 158.958Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M75.4005 158.297C75.2913 158.297 75.1738 158.297 75.0562 158.28C69.8318 157.56 64.6746 156.295 59.7106 154.52C58.6859 154.152 58.1484 153.029 58.5179 151.999C58.8875 150.978 60.0214 150.442 61.0461 150.81C65.7497 152.493 70.6381 153.691 75.5937 154.369C76.6772 154.52 77.4332 155.508 77.282 156.588C77.156 157.56 76.3413 158.263 75.4005 158.297Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M111.778 154.386C110.946 154.411 110.157 153.917 109.854 153.096C109.477 152.074 109.997 150.944 111.022 150.567C115.709 148.842 120.228 146.623 124.469 143.977C125.393 143.399 126.611 143.675 127.191 144.596C127.77 145.517 127.493 146.732 126.569 147.31C122.101 150.098 117.33 152.443 112.399 154.26C112.19 154.344 111.988 154.377 111.778 154.386Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M50.6058 150.291C50.2698 150.299 49.9255 150.232 49.6147 150.065C44.9699 147.603 40.5518 144.647 36.5034 141.289C35.6634 140.594 35.5458 139.354 36.243 138.517C36.9401 137.679 38.1832 137.562 39.0232 138.257C42.87 141.448 47.0529 144.245 51.4625 146.581C52.4284 147.092 52.7896 148.281 52.2773 149.244C51.9329 149.897 51.2861 150.274 50.6058 150.291Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M30.0611 134.313C29.4984 134.33 28.9272 134.112 28.5241 133.668C24.988 129.766 21.8466 125.495 19.1924 120.965C18.6381 120.027 18.9573 118.821 19.898 118.268C20.8387 117.716 22.0482 118.034 22.6026 118.972C25.1223 123.268 28.1041 127.321 31.4554 131.022C32.1862 131.826 32.1274 133.074 31.3126 133.802C30.9515 134.129 30.5063 134.296 30.0611 134.313Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M150.936 121.3C150.583 121.308 150.213 121.233 149.886 121.04C148.936 120.496 148.609 119.298 149.155 118.352C151.641 114.023 153.682 109.425 155.219 104.694C155.555 103.655 156.672 103.094 157.705 103.429C158.747 103.764 159.31 104.878 158.974 105.908C157.353 110.899 155.194 115.739 152.573 120.303C152.229 120.923 151.599 121.275 150.936 121.3Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M16.2106 112.323C15.4043 112.348 14.6316 111.879 14.3124 111.092C12.3302 106.226 10.8519 101.143 9.91955 95.968C9.72637 94.8961 10.4403 93.8745 11.5154 93.6818C12.5905 93.4892 13.6152 94.201 13.8084 95.2729C14.6988 100.18 16.1014 105.004 17.9745 109.618C18.386 110.623 17.8989 111.778 16.8826 112.18C16.6642 112.264 16.4374 112.314 16.2106 112.323Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M159.746 96.8385C159.612 96.8468 159.478 96.8385 159.343 96.8133C158.268 96.6291 157.546 95.6158 157.731 94.5439C158.57 89.6534 158.898 84.6373 158.722 79.638L158.713 79.4705C158.671 78.3818 159.528 77.4691 160.62 77.4356C161.712 77.3937 162.627 78.2478 162.661 79.3365L162.669 79.504C162.854 84.7713 162.501 90.0554 161.619 95.2139C161.46 96.1434 160.662 96.805 159.746 96.8385Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M10.7679 86.8732C9.67598 86.9151 8.76046 86.1028 8.72686 85.0142V84.9304C8.54208 79.6882 8.88645 74.4292 9.75998 69.3043C9.94476 68.2324 10.9611 67.5122 12.0362 67.688C13.1113 67.8723 13.8336 68.8855 13.6573 69.9574C12.8341 74.8228 12.4982 79.8138 12.6745 84.7797C12.7165 85.8767 11.8598 86.8314 10.7679 86.8732Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M159.587 70.7031C158.621 70.7366 157.756 70.0583 157.579 69.0869C156.681 64.1797 155.278 59.3562 153.397 54.7504C152.985 53.7455 153.472 52.5898 154.48 52.1795C155.488 51.7692 156.647 52.2549 157.059 53.2598C159.041 58.1168 160.528 63.2083 161.468 68.3835C161.661 69.4554 160.956 70.477 159.881 70.678C159.78 70.6864 159.688 70.6948 159.587 70.7031Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M14.3376 61.173C14.1108 61.1814 13.884 61.1479 13.6572 61.0809C12.6157 60.7459 12.053 59.6322 12.3889 58.6021C14.01 53.6111 16.1518 48.7625 18.7724 44.1986C19.31 43.2523 20.5195 42.9257 21.4686 43.4617C22.4177 43.9976 22.7453 45.2035 22.2077 46.1498C19.7299 50.4792 17.6889 55.0766 16.1518 59.8164C15.8831 60.6203 15.1439 61.1479 14.3376 61.173Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M150.532 46.3594C149.827 46.3845 149.138 46.0328 148.76 45.388C146.232 41.1004 143.25 37.0473 139.89 33.346C139.16 32.542 139.218 31.2943 140.033 30.5657C140.84 29.8372 142.091 29.8958 142.822 30.7081C146.366 34.6104 149.508 38.8729 152.17 43.3949C152.725 44.3328 152.405 45.5387 151.465 46.0914C151.171 46.2589 150.851 46.3426 150.532 46.3594Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M26.5502 38.2196C26.105 38.2364 25.6515 38.1024 25.2651 37.8009C24.4084 37.131 24.2488 35.8916 24.9207 35.0374C28.1628 30.8922 31.8333 27.0736 35.8482 23.6737C36.6797 22.9703 37.9228 23.0708 38.6368 23.8998C39.3423 24.7288 39.2415 25.9682 38.41 26.68C34.6051 29.9041 31.111 33.5385 28.0369 37.4659C27.6673 37.9433 27.1129 38.2029 26.5502 38.2196Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M133.65 26.571C133.179 26.5878 132.709 26.4371 132.323 26.1188C128.467 22.9367 124.285 20.1397 119.866 17.8033C118.901 17.2925 118.531 16.1033 119.043 15.1403C119.556 14.1773 120.748 13.8172 121.714 14.3197C126.359 16.7733 130.777 19.721 134.834 23.079C135.674 23.7741 135.792 25.0134 135.094 25.8509C134.725 26.3031 134.187 26.5459 133.65 26.571Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M45.877 20.7928C45.1966 20.818 44.5247 20.4914 44.1299 19.8717C43.5504 18.9505 43.8275 17.7363 44.7515 17.1585C49.2199 14.3615 53.9823 12.0167 58.9211 10.1912C59.9458 9.81432 61.0797 10.3335 61.4577 11.3552C61.8357 12.3768 61.3149 13.5073 60.2902 13.8842C55.6118 15.6092 51.0929 17.8368 46.8513 20.4914C46.5489 20.684 46.213 20.7845 45.877 20.7928Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M111.005 13.7002C110.762 13.7086 110.51 13.6751 110.274 13.583C105.571 11.9081 100.674 10.719 95.7185 10.0407C94.635 9.88995 93.879 8.9018 94.0302 7.82154C94.1814 6.74127 95.1809 5.9876 96.2561 6.13833C101.48 6.85013 106.638 8.10626 111.602 9.8732C112.626 10.2417 113.164 11.3638 112.794 12.3938C112.517 13.1726 111.786 13.6751 111.005 13.7002Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M70.0166 11.0203C69.0759 11.0538 68.2192 10.4089 68.0176 9.46267C67.7908 8.39915 68.4712 7.35238 69.5379 7.12628C74.6698 6.03764 79.995 5.4682 85.2362 5.42633C86.3281 5.41795 87.2184 6.29724 87.2268 7.38588C87.2352 8.45777 86.3869 9.32868 85.3202 9.37055C85.3034 9.37055 85.2782 9.37055 85.2614 9.37055C80.2806 9.39568 75.2242 9.94837 70.361 10.9784C70.2434 11.0035 70.1258 11.0119 70.0166 11.0203Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M160.259 28.6311C160.049 28.5724 159.906 28.3798 159.931 28.1621C159.948 28.0365 159.965 27.9109 159.982 27.7853C160.024 27.5424 160.074 27.2828 160.141 27.0148C160.393 26.0518 160.855 25.1893 161.519 24.4272C162.182 23.6652 163.14 23.0288 164.374 22.5347L166.457 21.6889C167.701 21.1948 168.465 20.3741 168.767 19.2436C168.876 18.8333 168.91 18.4146 168.868 17.9791C168.826 17.5437 168.7 17.1333 168.473 16.7565C168.246 16.3797 167.936 16.0363 167.524 15.7349C167.113 15.4334 166.609 15.2073 166.004 15.0482C165.349 14.8807 164.769 14.8556 164.248 14.9728C163.728 15.0901 163.266 15.2994 162.863 15.5925C162.459 15.8856 162.123 16.2624 161.855 16.7146C161.577 17.1668 161.376 17.6525 161.241 18.155C161.199 18.3057 161.166 18.4565 161.141 18.5905C161.065 18.984 160.67 19.2185 160.284 19.1013L157.067 18.1215C156.765 18.0294 156.555 17.7363 156.588 17.4264C156.597 17.326 156.613 17.2255 156.63 17.125C156.681 16.8403 156.739 16.5723 156.807 16.3043C157.059 15.3413 157.487 14.4452 158.092 13.6162C158.696 12.7872 159.444 12.1089 160.334 11.5813C161.225 11.0537 162.233 10.7104 163.375 10.5429C164.517 10.3754 165.76 10.4759 167.113 10.8276C168.515 11.1961 169.691 11.7236 170.64 12.4103C171.598 13.097 172.345 13.8674 172.891 14.7132C173.437 15.5674 173.782 16.4718 173.916 17.4348C174.05 18.3978 174 19.3358 173.756 20.2485C173.378 21.6889 172.723 22.8361 171.808 23.6903C170.884 24.5445 169.784 25.2144 168.49 25.6917L166.735 26.3533C166.239 26.5124 165.5 26.839 164.887 27.5089C164.828 27.5759 164.576 27.8523 164.324 28.2793C164.139 28.5976 164.005 28.9074 163.912 29.1754C163.837 29.3931 163.602 29.5103 163.383 29.4517L160.259 28.6311ZM157.689 33.5467C157.899 32.7511 158.352 32.1482 159.058 31.7295C159.763 31.3108 160.511 31.2019 161.309 31.4113C162.107 31.6206 162.711 32.0812 163.131 32.793C163.551 33.5048 163.652 34.2585 163.442 35.054C163.232 35.8496 162.77 36.4441 162.056 36.8545C161.342 37.2564 160.586 37.3569 159.797 37.1476C158.999 36.9382 158.394 36.486 157.991 35.791C157.579 35.0875 157.479 34.3422 157.689 33.5467Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M15.5471 17.8537C15.3455 17.7867 15.2111 17.5773 15.2531 17.368C15.2783 17.2424 15.3035 17.1168 15.3287 16.9911C15.3875 16.7483 15.4547 16.4971 15.5471 16.2375C15.8663 15.2912 16.3786 14.4621 17.101 13.7503C17.8149 13.0302 18.806 12.4691 20.0827 12.0504L22.2162 11.347C23.4845 10.9366 24.3076 10.1746 24.6855 9.06082C24.8199 8.65886 24.8871 8.24015 24.8703 7.80469C24.8619 7.36924 24.7527 6.95053 24.5596 6.55694C24.3664 6.16336 24.0724 5.80327 23.6776 5.47668C23.2913 5.15009 22.7957 4.89049 22.2078 4.68951C21.5694 4.47178 20.9815 4.41316 20.4607 4.4969C19.9315 4.58065 19.4612 4.7565 19.0412 5.02448C18.6213 5.29245 18.2601 5.64416 17.9577 6.07962C17.6385 6.51507 17.4034 6.98403 17.2354 7.4781C17.185 7.62884 17.143 7.7712 17.1094 7.90518C17.0086 8.29039 16.597 8.49975 16.2191 8.35739L13.0777 7.16826C12.7837 7.05939 12.599 6.74955 12.6493 6.43971C12.6661 6.33922 12.6913 6.23873 12.7165 6.13824C12.7837 5.86189 12.8593 5.59392 12.9517 5.33432C13.2709 4.38804 13.7581 3.5255 14.4216 2.73833C15.0851 1.95116 15.8747 1.3231 16.7902 0.854149C17.7141 0.385196 18.7472 0.108849 19.8895 0.0251079C21.0403 -0.0586337 22.275 0.117224 23.5936 0.561054C24.9627 1.02163 26.105 1.62457 27.0122 2.37824C27.9193 3.13192 28.6164 3.94421 29.1036 4.83187C29.5907 5.71953 29.8763 6.64069 29.9435 7.61209C30.0107 8.58349 29.8931 9.51302 29.5907 10.4091C29.112 11.8243 28.3896 12.9213 27.4069 13.7085C26.4326 14.4956 25.2819 15.0902 23.9632 15.4838L22.1658 16.0197C21.6618 16.1453 20.8975 16.4217 20.2423 17.0498C20.1751 17.1167 19.9063 17.3763 19.6292 17.7783C19.4192 18.0882 19.268 18.3812 19.1588 18.6408C19.0748 18.8502 18.8312 18.9591 18.6129 18.8837L15.5471 17.8537ZM12.6493 22.5851C12.9097 21.8063 13.4053 21.2285 14.136 20.86C14.8668 20.4915 15.6227 20.4329 16.4038 20.6925C17.185 20.9521 17.7561 21.4546 18.1257 22.1915C18.4953 22.9284 18.5457 23.6905 18.2853 24.4693C18.0249 25.248 17.5209 25.8175 16.7818 26.1692C16.0427 26.5209 15.2867 26.5712 14.5056 26.3116C13.7245 26.052 13.1533 25.5579 12.7921 24.8293C12.4394 24.1175 12.389 23.3639 12.6493 22.5851Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        opacity: "0.3",
        d: "M10.4068 151.053C10.2052 151.129 9.97 151.053 9.86921 150.861C9.81041 150.752 9.75162 150.634 9.69282 150.517C9.58363 150.291 9.48284 150.048 9.38205 149.797C9.03768 148.867 8.91169 147.896 9.02088 146.891C9.13007 145.886 9.54163 144.823 10.2724 143.701L11.4903 141.816C12.221 140.703 12.3806 139.589 11.969 138.492C11.8178 138.098 11.6079 137.73 11.3223 137.395C11.0367 137.06 10.7007 136.8 10.2976 136.616C9.89441 136.432 9.44084 136.34 8.92849 136.323C8.41613 136.315 7.87017 136.415 7.29062 136.633C6.66067 136.867 6.16511 137.177 5.80394 137.579C5.44277 137.973 5.19079 138.408 5.03121 138.877C4.87162 139.346 4.81283 139.849 4.84642 140.376C4.88002 140.904 4.98921 141.414 5.174 141.909C5.23279 142.059 5.28319 142.193 5.34198 142.319C5.50997 142.679 5.31678 143.106 4.93882 143.232L1.74708 144.27C1.4447 144.371 1.10873 144.245 0.957545 143.969C0.907149 143.876 0.865152 143.784 0.814757 143.692C0.688767 143.433 0.579576 143.173 0.487184 142.922C0.142812 141.992 -0.0251739 141.013 -0.00837533 139.983C0.00842328 138.952 0.226805 137.973 0.65517 137.035C1.07513 136.097 1.70508 135.234 2.54501 134.447C3.38494 133.66 4.46005 133.024 5.77035 132.546C7.13103 132.044 8.39093 131.801 9.56683 131.818C10.7427 131.834 11.801 132.035 12.7418 132.412C13.6825 132.797 14.4804 133.342 15.144 134.054C15.8075 134.765 16.3031 135.561 16.6306 136.449C17.1514 137.847 17.2774 139.162 17.017 140.384C16.7566 141.607 16.2359 142.788 15.4547 143.927L14.3964 145.476C14.0857 145.895 13.6657 146.581 13.5481 147.477C13.5397 147.569 13.4893 147.938 13.5313 148.424C13.5649 148.792 13.6321 149.119 13.7161 149.387C13.7833 149.604 13.6573 149.839 13.4389 149.923L10.4068 151.053ZM11.1375 156.547C10.8519 155.776 10.8771 155.022 11.2131 154.269C11.5491 153.524 12.1034 153.004 12.8762 152.72C13.6489 152.435 14.4132 152.468 15.1608 152.812C15.9167 153.155 16.4375 153.716 16.723 154.487C17.0086 155.257 16.975 156.011 16.6222 156.748C16.2695 157.484 15.7067 157.995 14.9424 158.28C14.1697 158.565 13.4137 158.54 12.6746 158.205C11.9354 157.87 11.4231 157.317 11.1375 156.547Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M125.452 111.87L119.447 106.067L111.358 114.399L117.363 120.202C118.901 121.685 119.976 123.569 120.48 125.637C120.984 127.706 122.067 129.59 123.596 131.072L147.979 154.603C151.675 158.171 157.563 158.07 161.141 154.394C164.719 150.709 164.618 144.839 160.931 141.272L136.547 117.74C135.01 116.258 133.087 115.245 130.996 114.81C128.913 114.366 126.989 113.344 125.452 111.87Z",
        fill: "#CFD4DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M130.76 114.734C128.77 114.274 126.93 113.286 125.46 111.862L123.629 110.095C121.32 107.868 117.641 107.926 115.406 110.229C113.172 112.532 113.231 116.2 115.541 118.427L117.372 120.194C118.842 121.618 119.892 123.41 120.421 125.378C122.395 123.887 124.259 122.238 126.015 120.429C127.753 118.645 129.332 116.736 130.76 114.734Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M85.6309 130.637C72.6372 130.846 60.3406 125.997 51.009 116.987C31.7326 98.3878 31.237 67.6211 49.8919 48.4025C58.9295 39.0988 71.0665 33.8566 84.0519 33.6388C97.0456 33.4295 109.342 38.2781 118.674 47.2887C128.014 56.2993 133.263 68.3999 133.482 81.3464C133.692 94.3012 128.829 106.561 119.791 115.865C110.762 125.185 98.6247 130.427 85.6309 130.637ZM84.245 45.2203C74.3507 45.3794 65.1198 49.3739 58.2324 56.4584C44.0292 71.088 44.4071 94.5105 59.0807 108.671C66.1865 115.53 75.5518 119.223 85.4461 119.064C95.3405 118.904 104.571 114.91 111.459 107.825C118.338 100.741 122.042 91.4037 121.882 81.539C121.723 71.6742 117.716 62.471 110.61 55.6042C103.496 48.7542 94.1394 45.0612 84.245 45.2203Z",
        fill: "url(#paint0_linear_1032_107356)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M99.8845 71.3646L95.3993 66.9681C94.7358 66.3233 93.6774 66.3317 93.0223 66.9933L84.7994 75.3423L76.4253 67.144C75.7617 66.4992 74.7034 66.5076 74.0483 67.1691L69.6386 71.6409C68.9919 72.3025 69.0003 73.3576 69.6638 74.0108L78.0379 82.2091L69.815 90.5581C69.1683 91.2197 69.1767 92.2748 69.8402 92.928L74.3254 97.3244C74.989 97.9692 76.0473 97.9609 76.7024 97.2993L84.9254 88.9503L93.2995 97.1486C93.963 97.7934 95.0213 97.785 95.6765 97.1235L100.086 92.6517C100.733 91.9901 100.724 90.935 100.061 90.2818L91.6868 82.0835L99.9097 73.7344C100.556 73.0729 100.548 72.0094 99.8845 71.3646Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint0_linear_1032_107356",
        x1: "50.448",
        y1: "116.439",
        x2: "119.038",
        y2: "47.6424",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5572",
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.966",
        stopColor: "#E9EBEF",
        stopOpacity: "0.5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_1032_107356"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "174",
        height: "159",
        fill: "white"
    })))));
};

});

parcelRegister("vk73z", function(module, exports) {

$parcel$export(module.exports, "default", () => $82a3b46429b35e25$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $82a3b46429b35e25$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        id: 'eoc.heartbeats.list.no-search-result.empty-state.title.no-translate',
        defaultMessage: `We couldn\u{2019}t find what you\u{2019}re looking for`,
        description: `The text will be displayed in no search result component's header.`
    },
    description: {
        id: 'eoc.heartbeats.list.no-search-result.empty-state.description.no-translate',
        defaultMessage: 'Try a different name or double-check your filters.',
        description: `The text will be displayed in no search result component's description.`
    }
});
var $82a3b46429b35e25$export$2e2bcd8739ae039 = $82a3b46429b35e25$var$messages;

});


parcelRegister("2iYCT", function(module, exports) {

$parcel$export(module.exports, "DynamicTableWrapper", () => $a256a5326c15f015$export$29ec9bf09b5d4060);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bWGt6 = parcelRequire("bWGt6");
function $a256a5326c15f015$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a256a5326c15f015$export$29ec9bf09b5d4060 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1mr9ejt0"
})({
    name: "1siebwf",
    styles: "margin-top:var(--ds-space-400, 32px)"
});

});

parcelRegister("3pHgf", function(module, exports) {

$parcel$export(module.exports, "Team", () => $f915934b33afdb29$export$3e5d0af8e738b082);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $kgoHi = parcelRequire("kgoHi");

var $fXc9u = parcelRequire("fXc9u");
const $f915934b33afdb29$export$3e5d0af8e738b082 = ({ ownerTeamId: ownerTeamId })=>{
    const requestedResponders = (0, $5uXOq.useMemo)(()=>{
        if (ownerTeamId) return [
            {
                id: ownerTeamId,
                type: 'team'
            }
        ];
        return [];
    }, [
        ownerTeamId
    ]);
    const [team] = (0, $fXc9u.useResponderNames)(requestedResponders);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, 'name' in team && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        columnGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        borderColor: "transparent",
        size: "small",
        src: team.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, team.name)));
};

});


parcelRegister("hDWrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $743e627f532a2b02$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $743e627f532a2b02$var$messages = (0, $7VHMR.defineMessages)({
    heartbeatLimitBanner: {
        id: 'eoc.heartbeats.banner.no-translate',
        defaultMessage: `You've reached limit of {limit} heartbeats. Please remove some heartbeats or contact your admin for assistance. `,
        description: 'Description of the heartbeat banner'
    },
    viewInOgText: {
        id: 'eoc.heartbeats.banner.view-in-og.no-translate',
        defaultMessage: 'View heartbeats in Opsgenie',
        description: 'View in Opsgenie text'
    }
});
var $743e627f532a2b02$export$2e2bcd8739ae039 = $743e627f532a2b02$var$messages;

});

parcelRegister("l6bFa", function(module, exports) {

$parcel$export(module.exports, "ActionButtonsSkeleton", () => $35afc2e4ca8c240c$export$9983a19039791e77);
$parcel$export(module.exports, "BottomBarSkeleton", () => $35afc2e4ca8c240c$export$4c66923f63e9b34);
$parcel$export(module.exports, "ContentSkeleton", () => $35afc2e4ca8c240c$export$773d77ea47ab486d);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");

var $fNobW = parcelRequire("fNobW");

var $8icyj = parcelRequire("8icyj");
const $35afc2e4ca8c240c$export$9983a19039791e77 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "heartbeats-action-buttons-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: "185px",
        height: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: "160px",
        height: 4
    })));
};
const $35afc2e4ca8c240c$export$4c66923f63e9b34 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "heartbeats-bottom-bar-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.400",
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: "75%",
        height: 2.25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: "10%",
        height: 2.25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: "20px",
        height: 2.25
    }))));
};
const $35afc2e4ca8c240c$export$773d77ea47ab486d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "heartbeats-content-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8icyj.default), {
        width: "100%",
        height: 18
    }));
};

});


parcelRegister("1jd5c", function(module, exports) {

$parcel$export(module.exports, "HeartbeatsTour", () => $d432dfdaa72edb83$export$109335d532ae2008);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");
var $994MI = parcelRequire("994MI");

var $7gs1W = parcelRequire("7gs1W");
var $1QiBP = parcelRequire("1QiBP");


var $h8yj2 = parcelRequire("h8yj2");

var $awLan = parcelRequire("awLan");

var $fdfOR = parcelRequire("fdfOR");
const $d432dfdaa72edb83$var$Tour = ({ stop: stop, learnMoreUrl: learnMoreUrl })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'spotlight'
        });
        (0, $h8yj2.fireScreenAnalytics)(analyticsEvent);
        setActiveSpotlight(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const end = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'ok'
        });
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent);
        setActiveSpotlight(null);
        stop?.();
    };
    const learnMore = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore'
        });
        (0, $h8yj2.fireUIAnalytics)(analyticsEvent);
    };
    const renderActiveSpotlight = ()=>{
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7gs1W.default), {
                actions: [
                    {
                        onClick: end,
                        text: formatMessage((0, $fdfOR.default).ok)
                    },
                    {
                        onClick: learnMore,
                        text: formatMessage((0, $fdfOR.default).learnMore),
                        appearance: 'subtle',
                        href: learnMoreUrl,
                        target: '_blank'
                    }
                ],
                heading: formatMessage((0, $fdfOR.default).heading),
                key: (0, $awLan.SPOTLIGHT_NAMES).actions,
                target: (0, $awLan.SPOTLIGHT_NAMES).actions,
                targetRadius: 3,
                targetBgColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
            }, formatMessage((0, $fdfOR.default).description))
        ];
        if (activeSpotlight === null) return null;
        return spotlights[activeSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderActiveSpotlight());
};
const $d432dfdaa72edb83$export$109335d532ae2008 = (0, $994MI.default)({
    source: 'OpsHeartbeatsSpotlightTour',
    tags: [
        'spotlight',
        'ops-heartbeats-spotlight'
    ]
})($d432dfdaa72edb83$var$Tour);

});
parcelRegister("fdfOR", function(module, exports) {

$parcel$export(module.exports, "default", () => $44be4916d240091d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $44be4916d240091d$var$messages = (0, $7VHMR.defineMessages)({
    learnMore: {
        id: 'eoc-heartbeats.tour.learn-more.no-translate',
        defaultMessage: 'Learn More',
        description: 'Action button that redirects user to learn more page'
    },
    ok: {
        id: 'eoc-heartbeats.tour.ok.no-translate',
        defaultMessage: 'OK',
        description: 'Action button that finishes spotlight'
    },
    heading: {
        id: 'eoc-heartbeats.tour.heading.no-translate',
        defaultMessage: 'Easy access to heartbeat actions',
        description: 'Heading of the spotlight'
    },
    description: {
        id: 'eoc-heartbeats.tour.description.no-translate',
        defaultMessage: "Copy heartbeat\u2019s name, edit, duplicate, and manage more heartbeat actions.",
        description: 'Description of the spotlight'
    }
});
var $44be4916d240091d$export$2e2bcd8739ae039 = $44be4916d240091d$var$messages;

});


parcelRegister("2WDJ4", function(module, exports) {

$parcel$export(module.exports, "GlobalContextContainer", () => $cd75cd51f8698b39$export$8a0b5f75aa4dc446);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $74BDp = parcelRequire("74BDp");
var $aI12f = parcelRequire("aI12f");

var $85qyr = parcelRequire("85qyr");

var $dJl1T = parcelRequire("dJl1T");

var $jcw0u = parcelRequire("jcw0u");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $3HwlS = parcelRequire("3HwlS");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lhVtI = parcelRequire("lhVtI");

var $fjcgS = parcelRequire("fjcgS");
const $cd75cd51f8698b39$var$addSearchPayload = (event)=>{
    try {
        const searchPayload = (0, $85qyr.addSearchSessionAttributes)();
        if (Object.keys(searchPayload).length > 0) // eslint-disable-next-line no-param-reassign
        event.payload.attributes = {
            ...event.payload.attributes,
            ...searchPayload
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('observability.analytics-providers-eoc.addSearchPayload', 'Failed to dynamically add search payload', e);
    }
    return event;
};
// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
const $cd75cd51f8698b39$var$sendAnalyticsEvent = (event)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>client.sendEvent(event));
};
// A custom listener to send events from analyticsBridge channel. Using the analytics bridge on AFE code
// creates events in this channel, which we can then listen here and send.
const $cd75cd51f8698b39$var$EocAnalyticsListener = ({ children: children })=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $cfDZ3.setSubProduct)('serviceDesk');
    }, []);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        onEvent: (event)=>{
            // Mimic the behaviour on JFE, is this really necessary?
            const enrichedEvent = $cd75cd51f8698b39$var$addSearchPayload(event);
            $cd75cd51f8698b39$var$sendAnalyticsEvent((0, $lhVtI.getEvent)(enrichedEvent));
        },
        channel: "analyticsBridge"
    }, children);
};
const $cd75cd51f8698b39$export$8a0b5f75aa4dc446 = ({ children: children, packageName: packageName, teamName: teamName, config: config })=>{
    const flagService = (0, $pa9q9.useFlagService)();
    const isNewNavigation = (0, $3HwlS.getWillShowNav4)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74BDp.GlobalContextContainer), {
        config: {
            ...config,
            isNewNavigation: isNewNavigation
        },
        flagService: flagService,
        reporter: ({ id: id, error: reporterError })=>{
            const error = (0, $aI12f.isHTTPError)(reporterError) ? new (0, $jJZqs.default)(reporterError.response.status, reporterError.message, reporterError.response.headers.get((0, $fnyT4.TRACE_ID_HEADER)) ?? undefined, reporterError.response) : reporterError;
            (0, $jcw0u.default)({
                meta: {
                    id: id,
                    packageName: packageName,
                    teamName: teamName
                },
                error: error
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd75cd51f8698b39$var$EocAnalyticsListener, null, children));
};

});

parcelRegister("dF4Di", function(module, exports) {

$parcel$export(module.exports, "ConsolidatedStateWrapper", () => $33187c8ccf842c7e$export$808758a1c9216c53);

var $5uXOq = parcelRequire("5uXOq");

var $beRD7 = parcelRequire("beRD7");

var $8J6rn = parcelRequire("8J6rn");

var $13f5b = parcelRequire("13f5b");
const $33187c8ccf842c7e$export$808758a1c9216c53 = ({ children: children, loadingComponent: loadingComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $13f5b.ConsolidatedStateLoading), null), errorComponent: errorComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null) })=>{
    const { shouldUseJSM: shouldUseJSM, loading: loading, error: error } = (0, $8J6rn.useOgTenantInfo)();
    if (loading) return loadingComponent;
    if (error || !shouldUseJSM) return errorComponent;
    return children;
};

});
parcelRegister("13f5b", function(module, exports) {

$parcel$export(module.exports, "ConsolidatedStateLoading", () => $b14022075e056ba2$export$bde5b6095281f205);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");

var $eZJjh = parcelRequire("eZJjh");
const $b14022075e056ba2$export$bde5b6095281f205 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));

});


parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("7jF6i", function(module, exports) {

$parcel$export(module.exports, "useOpsgenieBaseUrl", () => $1469318d2c6fedc9$export$60d311c8b1ba6c11);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8r6sb = parcelRequire("8r6sb");
const $1469318d2c6fedc9$export$d4c72bab9d6cc13a = {
    opsgenieBaseUrl: undefined,
    fetchStatus: undefined,
    error: undefined
};
const $1469318d2c6fedc9$var$opsgenieBaseUrlStore = (0, $iXqE5.createStore)({
    name: 'opsgenieBaseUrl',
    initialState: $1469318d2c6fedc9$export$d4c72bab9d6cc13a,
    actions: (0, $8r6sb.actions)
});
const $1469318d2c6fedc9$export$7d5869fb9c3cabbd = (0, $3sQ5x.createHook)($1469318d2c6fedc9$var$opsgenieBaseUrlStore);
const $1469318d2c6fedc9$export$60d311c8b1ba6c11 = (packageName)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [state, { fetchOpsgenieBaseUrl: fetchOpsgenieBaseUrl }] = $1469318d2c6fedc9$export$7d5869fb9c3cabbd();
    const fetchOgBaseUrl = (0, $5uXOq.useCallback)(()=>fetchOpsgenieBaseUrl(createAnalyticsEvent({}), packageName), [
        createAnalyticsEvent,
        fetchOpsgenieBaseUrl,
        packageName
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (state.opsgenieBaseUrl === undefined && !state.fetchStatus) fetchOgBaseUrl();
    }, [
        fetchOgBaseUrl,
        state.opsgenieBaseUrl,
        state.fetchStatus
    ]);
    return [
        state,
        {
            fetchOgBaseUrl: fetchOgBaseUrl
        }
    ];
};

});
parcelRegister("8r6sb", function(module, exports) {

$parcel$export(module.exports, "actions", () => $018567380165a957$export$e324594224ef24da);

var $66VJT = parcelRequire("66VJT");
const $018567380165a957$export$e324594224ef24da = {
    fetchOpsgenieBaseUrl: $66VJT.fetchOpsgenieBaseUrl
};

});
parcelRegister("66VJT", function(module, exports) {

$parcel$export(module.exports, "fetchOpsgenieBaseUrl", () => $0533b309ea677099$export$14e903f188de435b);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");

var $gaED7 = parcelRequire("gaED7");
const $0533b309ea677099$export$14e903f188de435b = (analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
packageName)=>async ({ getState: getState, setState: setState })=>{
        const { opsgenieBaseUrl: currentOpsgenieBaseUrl, fetchStatus: currentFetchStatus } = getState();
        if (currentOpsgenieBaseUrl !== undefined || // @ts-expect-error - TS2345 - Argument of type 'FetchStatus | undefined' is not assignable to parameter of type '"SUCCESS" | "IN_PROGRESS_FETCH_STATUS"'.
        [
            (0, $gaED7.FETCH_STATUS).inProgress,
            (0, $gaED7.FETCH_STATUS).success
        ].includes(currentFetchStatus)) return;
        setState({
            fetchStatus: (0, $gaED7.FETCH_STATUS).inProgress,
            error: undefined
        });
        try {
            const { baseUrl: baseUrl } = await (0, $7f4tk.default)('/rest/internal/2/opsgenie-base-url');
            analyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'fetchOgBaseUrl succeeded');
            setState({
                fetchStatus: (0, $gaED7.FETCH_STATUS).success,
                opsgenieBaseUrl: baseUrl
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.trackFetchErrors)({
                error: error,
                id: 'fetchOgBaseUrl',
                packageName: packageName,
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                fetchStatus: (0, $gaED7.FETCH_STATUS).error,
                error: error
            });
            throw error;
        }
    };

});
parcelRegister("gaED7", function(module, exports) {

$parcel$export(module.exports, "FETCH_STATUS", () => $9abe9043030eba9b$export$7279934be2ca35bc);
const $9abe9043030eba9b$export$7279934be2ca35bc = {
    inProgress: 'IN_PROGRESS_FETCH_STATUS',
    error: 'ERROR_FETCH_STATUS',
    success: 'SUCCESS'
};

});




parcelRegister("3FJn6", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $618985da4e4e3f3d$export$4a39035bacc4ed76);

var $aIZdc = parcelRequire("aIZdc");

var $7e75W = parcelRequire("7e75W");

var $8J6rn = parcelRequire("8J6rn");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");

var $aUDLa = parcelRequire("aUDLa");

var $83mn0 = parcelRequire("83mn0");

var $7OqB4 = parcelRequire("7OqB4");

var $4PFfc = parcelRequire("4PFfc");


var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $9OXo1 = parcelRequire("9OXo1");
const $618985da4e4e3f3d$export$4a39035bacc4ed76 = (0, $7OqB4.withThrowOnError)(()=>{
    const { data: data, loading: loading, error: error } = (0, $aUDLa.useNavigationGlobalResource)();
    const { shouldUseJSM: shouldUseJSM, shouldAccessUnlockOperations: shouldAccessUnlockOperations, isTransitioning: isTransitioning, loading: ogTenantInfoLoading, isOpsAdmin: isOpsAdmin } = (0, $8J6rn.useOgTenantInfo)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const appEditions = (0, $k9JTq.useAppEditions)();
    const { hasKeys: hasKeys, loading: apiKeyManagementLoading } = (0, $7e75W.useApiKeyManagementInfo)();
    const { isByokCustomer: isByokCustomer } = (0, $4PFfc.useByokComplianceSettingWithInitialisation)();
    // Lets wait for tenant ConsolidationState to load before rendering product's setting side-nav
    if (loading || !data || ogTenantInfoLoading || apiKeyManagementLoading) return {
        data: null,
        loading: loading || ogTenantInfoLoading || apiKeyManagementLoading,
        error: error
    };
    const hasJsmAboveStandard = !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $ldyPw.FREE_EDITION) && appEditions.serviceDesk !== (0, $ldyPw.STANDARD_EDITION);
    const hasJsmAboveFree = !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $ldyPw.FREE_EDITION);
    const isAdmin = (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? tenantContext.isSiteAdmin || tenantContext.isAdmin || isOpsAdmin : tenantContext.isSiteAdmin || tenantContext.isAdmin;
    return {
        data: {
            hasApplicationAccess: (0, $83mn0.hasItemInSidebar)(data, 'application_access_browser'),
            hasSoftwareSection: tenantContext.isAdmin,
            hasSoftwareConfig: tenantContext.isAdmin,
            hasServiceDeskSection: (0, $83mn0.hasItemInSidebar)(data, 'sd-plugin-admin-section'),
            hasServiceDeskConfig: (0, $83mn0.hasItemInSidebar)(data, 'sd-configuration-link'),
            hasServiceDeskEmailRequests: (0, $83mn0.hasItemInSidebar)(data, 'sd-admin-mail-info-link'),
            hasServiceDeskIncidentManagementTools: (0, $83mn0.hasItemInSidebar)(data, 'sd-incident-management-tools-link'),
            hasIntegrationsSection: (0, $83mn0.hasItemInSidebar)(data, 'admin_applications_integrations_section'),
            hasServiceDeskCustomerAccess: tenantContext.isAdmin && appEditions.serviceDesk !== (0, $ldyPw.UNLICENSED),
            hasServiceDeskKbPermissionsAccess: tenantContext.isAdmin,
            hasServiceDeskAuthenticationSettings: tenantContext.isAdmin && appEditions.serviceDesk !== (0, $ldyPw.UNLICENSED),
            hasApplicationLinksIntegration: (0, $83mn0.hasItemInSidebar)(data, 'configure-application-links'),
            hasDvcsAccountsIntegration: (0, $83mn0.hasItemInSidebar)(data, 'bitbucket_bulk_repo'),
            hasStatusPageIntegration: !!tenantContext.atlassianAccountId && (0, $83mn0.hasItemInSidebar)(data, 'jsd-status-page__admin-page'),
            hasCompassPageIntegration: tenantContext.isSiteAdmin && !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$1346c9aa3cbb477d],
            hasConfluencePageIntegration: tenantContext.isAdmin,
            hasPortfolioAdmin: (0, $83mn0.hasItemInSidebar)(data, 'jpo-ws-main-admin'),
            hasProductDiscoverySection: tenantContext.isAdmin && appEditions.productDiscovery !== (0, $ldyPw.UNLICENSED),
            hasOperationsSection: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? (tenantContext.isAdmin || isOpsAdmin) && !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] : tenantContext.isAdmin && !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61],
            hasOpsReportsAccess: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? (tenantContext.isAdmin || isOpsAdmin) && !isByokCustomer && shouldUseJSM && !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $ldyPw.FREE_EDITION) : tenantContext.isAdmin && !isByokCustomer && shouldUseJSM && !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && appEditions.serviceDesk !== (0, $ldyPw.FREE_EDITION),
            hasChatOpsToolAccess: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? (tenantContext.isAdmin || isOpsAdmin) && !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && !(0, $aIZdc.isFedRamp)() : tenantContext.isAdmin && !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && !(0, $aIZdc.isFedRamp)(),
            hasAuditLogsAccess: shouldUseJSM && !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61],
            hasGlobalHeartbeatsAccess: shouldUseJSM && hasJsmAboveStandard && isAdmin && (0, $4R6GH.fg)('global_heartbeats'),
            hasGlobalSyncAccess: shouldUseJSM && hasJsmAboveStandard,
            hasGlobalSchedulesAccess: shouldUseJSM && hasJsmAboveFree && isAdmin && (0, $4R6GH.fg)('global_on-call_schedules'),
            hasGlobalIncomingCallAccess: shouldUseJSM && hasJsmAboveStandard && isAdmin,
            hasGlobalIntegrationAccess: shouldUseJSM && hasJsmAboveStandard,
            hasPoliciesAccess: shouldUseJSM && hasJsmAboveStandard,
            hasMaintenanceAccess: shouldUseJSM && !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61],
            hasGlobalEscalationsAccess: shouldUseJSM && hasJsmAboveFree && isAdmin && (0, $4R6GH.fg)('alx-9154_global_escalations'),
            hasGlobalRoleAccess: shouldUseJSM && hasJsmAboveStandard && (tenantContext.isAdmin || tenantContext.isSiteAdmin),
            hasRoleCreationAccess: shouldUseJSM && hasJsmAboveStandard && (tenantContext.isAdmin || tenantContext.isSiteAdmin || isOpsAdmin) && (0, $4R6GH.fg)('operations-tenant-info-endpoint-update'),
            hasRoleAssignmentAccess: shouldUseJSM && (tenantContext.isAdmin || tenantContext.isSiteAdmin || isOpsAdmin) && (0, $4R6GH.fg)('operations-tenant-info-endpoint-update'),
            hasRoleBasedNotificationsAccess: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? shouldUseJSM && (tenantContext.isAdmin || isOpsAdmin) && hasJsmAboveStandard : shouldUseJSM && tenantContext.isAdmin && hasJsmAboveStandard,
            hasOrganizationsListAccess: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && (tenantContext.isAdmin || isOpsAdmin) : !!tenantContext.licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61] && tenantContext.isAdmin,
            hasUnlockOperationsAccess: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? (0, $co1wz.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && shouldAccessUnlockOperations && (tenantContext.isAdmin || tenantContext.isSiteAdmin || isOpsAdmin) : (0, $co1wz.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && shouldAccessUnlockOperations && (tenantContext.isAdmin || tenantContext.isSiteAdmin),
            hasApiKeyManagementAccess: (0, $4R6GH.fg)('operations-tenant-info-endpoint-update') ? isTransitioning && shouldUseJSM && hasJsmAboveStandard && (tenantContext.isSiteAdmin || isOpsAdmin) && hasKeys : isTransitioning && shouldUseJSM && hasJsmAboveStandard && tenantContext.isSiteAdmin && hasKeys
        },
        loading: loading,
        error: error
    };
});

});
parcelRegister("7e75W", function(module, exports) {

$parcel$export(module.exports, "useApiKeyManagementInfo", () => $8ead749962be5bb7$export$19350f4f23ab0aaf);

var $drGWM = parcelRequire("drGWM");

var $2YP9W = parcelRequire("2YP9W");
const $8ead749962be5bb7$export$19350f4f23ab0aaf = ()=>{
    const { loading: loading, error: error, data: data } = (0, $2YP9W.useResource)((0, $drGWM.checkApiKeyManagementKeysResource)());
    return {
        hasKeys: data ?? false,
        loading: loading,
        error: error
    };
};

});

const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';


parcelRegister("bMSgL", function(module, exports) {

$parcel$export(module.exports, "heartbeatsLinks", () => $99a9a98a7b8e9a4e$export$14b88a5d45974386);
const $99a9a98a7b8e9a4e$export$14b88a5d45974386 = {
    'heartbeats-list-description': {
        iphId: '3dSX8RbqPG9NfE5QwdW5ko',
        sacUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-heartbeats/'
    },
    'heartbeats-empty-state': {
        iphId: '3dSX8RbqPG9NfE5QwdW5ko',
        sacUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-heartbeats/'
    }
};

});

parcelRegister("I5c2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $c021f5d11940bc1f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c021f5d11940bc1f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitle: {
        "id": "eoc-heartbeats.page-title",
        "defaultMessage": "Heartbeats"
    }
});

});



//# sourceMappingURL=async-jira-eoc-heartbeats.481593fa.js.map
